import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  _count?: Maybe<AccountCount>;
  accountPortfolios: Array<AccountPortfolio>;
  applicationDate?: Maybe<Scalars['DateTime']['output']>;
  applicationRefId?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionBank?: Maybe<Scalars['String']['output']>;
  distributionBankAccount?: Maybe<Scalars['String']['output']>;
  distributionBankBeneficiary?: Maybe<Scalars['String']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  distributionInstructionDisplay?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mailingAddressCode?: Maybe<Scalars['String']['output']>;
  masterAccountNo: Scalars['String']['output'];
  permanentAddressCode?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['String']['output']>;
  status: AccountStatus;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AccountAccountPortfoliosArgs = {
  cursor?: InputMaybe<AccountPortfolioWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccountPortfolioScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccountPortfolioOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type AccountProfileArgs = {
  where?: InputMaybe<ProfileWhereInput>;
};


export type AccountTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};

export type AccountCount = {
  __typename?: 'AccountCount';
  accountPortfolios: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
};

export type AccountCountAggregate = {
  __typename?: 'AccountCountAggregate';
  _all: Scalars['Int']['output'];
  applicationDate: Scalars['Int']['output'];
  applicationRefId: Scalars['Int']['output'];
  applicationStatus: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  distributionBank: Scalars['Int']['output'];
  distributionBankAccount: Scalars['Int']['output'];
  distributionBankBeneficiary: Scalars['Int']['output'];
  distributionInstruction: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mailingAddressCode: Scalars['Int']['output'];
  masterAccountNo: Scalars['Int']['output'];
  permanentAddressCode: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AccountCreateManyProfileInput = {
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo: Scalars['String']['input'];
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
};

export type AccountCreateManyProfileInputEnvelope = {
  data: Array<AccountCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<AccountCreateManyProfileInputEnvelope>;
};

export type AccountCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<AccountUncheckedCreateWithoutTransactionsInput>;
};

export type AccountCreateOrConnectWithoutProfileInput = {
  create: AccountUncheckedCreateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutTransactionsInput = {
  create: AccountUncheckedCreateWithoutTransactionsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutProfileInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioCreateNestedManyWithoutAccountInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo: Scalars['String']['input'];
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutAccountInput>;
};

export type AccountListRelationFilter = {
  every?: InputMaybe<AccountWhereInput>;
  none?: InputMaybe<AccountWhereInput>;
  some?: InputMaybe<AccountWhereInput>;
};

export type AccountMaxAggregate = {
  __typename?: 'AccountMaxAggregate';
  applicationDate?: Maybe<Scalars['DateTime']['output']>;
  applicationRefId?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionBank?: Maybe<Scalars['String']['output']>;
  distributionBankAccount?: Maybe<Scalars['String']['output']>;
  distributionBankBeneficiary?: Maybe<Scalars['String']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mailingAddressCode?: Maybe<Scalars['String']['output']>;
  masterAccountNo?: Maybe<Scalars['String']['output']>;
  permanentAddressCode?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountMinAggregate = {
  __typename?: 'AccountMinAggregate';
  applicationDate?: Maybe<Scalars['DateTime']['output']>;
  applicationRefId?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionBank?: Maybe<Scalars['String']['output']>;
  distributionBankAccount?: Maybe<Scalars['String']['output']>;
  distributionBankBeneficiary?: Maybe<Scalars['String']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mailingAddressCode?: Maybe<Scalars['String']['output']>;
  masterAccountNo?: Maybe<Scalars['String']['output']>;
  permanentAddressCode?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithRelationInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioOrderByRelationAggregateInput>;
  applicationDate?: InputMaybe<SortOrderInput>;
  applicationRefId?: InputMaybe<SortOrderInput>;
  applicationStatus?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  distributionBank?: InputMaybe<SortOrderInput>;
  distributionBankAccount?: InputMaybe<SortOrderInput>;
  distributionBankBeneficiary?: InputMaybe<SortOrderInput>;
  distributionInstruction?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mailingAddressCode?: InputMaybe<SortOrderInput>;
  masterAccountNo?: InputMaybe<SortOrder>;
  permanentAddressCode?: InputMaybe<SortOrderInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountPortfolio = {
  __typename?: 'AccountPortfolio';
  _count?: Maybe<AccountPortfolioCount>;
  account: Account;
  accountMasterAccountNo: Scalars['String']['output'];
  amount: Scalars['Decimal']['output'];
  availableUnits?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentMarketValue?: Maybe<Scalars['Decimal']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  distributionInstructionDisplay?: Maybe<Scalars['String']['output']>;
  fund: Fund;
  fundCode: Scalars['String']['output'];
  holdingUnits: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isSwitchingAllowed: Scalars['Boolean']['output'];
  livePortfolioHoldingUnits?: Maybe<Scalars['Decimal']['output']>;
  pendingUnits?: Maybe<Scalars['Decimal']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo9Digit?: Maybe<Scalars['String']['output']>;
  profitLoss: Scalars['Decimal']['output'];
  profitLossPercentage?: Maybe<Scalars['Decimal']['output']>;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime']['output'];
  weightedAvgNavPrice: Scalars['Decimal']['output'];
  weightedAvgNavPriceSyncedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AccountPortfolioTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};

export type AccountPortfolioAvgAggregate = {
  __typename?: 'AccountPortfolioAvgAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  holdingUnits?: Maybe<Scalars['Decimal']['output']>;
  profitLoss?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgNavPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type AccountPortfolioCount = {
  __typename?: 'AccountPortfolioCount';
  transactions: Scalars['Int']['output'];
};

export type AccountPortfolioCountAggregate = {
  __typename?: 'AccountPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  accountMasterAccountNo: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  distributionInstruction: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  holdingUnits: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  planCode: Scalars['Int']['output'];
  portfolioAccountNo: Scalars['Int']['output'];
  portfolioAccountNo9Digit: Scalars['Int']['output'];
  profitLoss: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weightedAvgNavPrice: Scalars['Int']['output'];
  weightedAvgNavPriceSyncedAt: Scalars['Int']['output'];
};

export type AccountPortfolioCreateManyAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  holdingUnits: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss: Scalars['Decimal']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice: Scalars['Decimal']['input'];
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioCreateManyAccountInputEnvelope = {
  data: Array<AccountPortfolioCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountPortfolioCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountPortfolioCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountPortfolioCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountPortfolioCreateManyAccountInputEnvelope>;
};

export type AccountPortfolioCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<AccountPortfolioWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountPortfolioCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<AccountPortfolioUncheckedCreateWithoutTransactionsInput>;
};

export type AccountPortfolioCreateOrConnectWithoutAccountInput = {
  create: AccountPortfolioUncheckedCreateWithoutAccountInput;
  where: AccountPortfolioWhereUniqueInput;
};

export type AccountPortfolioCreateOrConnectWithoutTransactionsInput = {
  create: AccountPortfolioUncheckedCreateWithoutTransactionsInput;
  where: AccountPortfolioWhereUniqueInput;
};

export type AccountPortfolioCreateWithoutAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fund: FundCreateNestedOneWithoutAccountPortfoliosInput;
  holdingUnits: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss: Scalars['Decimal']['input'];
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutAccountPortfolioInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice: Scalars['Decimal']['input'];
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioListRelationFilter = {
  every?: InputMaybe<AccountPortfolioWhereInput>;
  none?: InputMaybe<AccountPortfolioWhereInput>;
  some?: InputMaybe<AccountPortfolioWhereInput>;
};

export type AccountPortfolioMaxAggregate = {
  __typename?: 'AccountPortfolioMaxAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  holdingUnits?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo9Digit?: Maybe<Scalars['String']['output']>;
  profitLoss?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weightedAvgNavPrice?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgNavPriceSyncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountPortfolioMinAggregate = {
  __typename?: 'AccountPortfolioMinAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  distributionInstruction?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  holdingUnits?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo9Digit?: Maybe<Scalars['String']['output']>;
  profitLoss?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weightedAvgNavPrice?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgNavPriceSyncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountPortfolioNullableRelationFilter = {
  is?: InputMaybe<AccountPortfolioWhereInput>;
  isNot?: InputMaybe<AccountPortfolioWhereInput>;
};

export type AccountPortfolioOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccountPortfolioOrderByWithRelationInput = {
  account?: InputMaybe<AccountOrderByWithRelationInput>;
  accountMasterAccountNo?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  distributionInstruction?: InputMaybe<SortOrderInput>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  holdingUnits?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  planCode?: InputMaybe<SortOrderInput>;
  portfolioAccountNo?: InputMaybe<SortOrderInput>;
  portfolioAccountNo9Digit?: InputMaybe<SortOrderInput>;
  profitLoss?: InputMaybe<SortOrder>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  weightedAvgNavPrice?: InputMaybe<SortOrder>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<SortOrderInput>;
};

export enum AccountPortfolioScalarFieldEnum {
  AccountMasterAccountNo = 'accountMasterAccountNo',
  Amount = 'amount',
  CreatedAt = 'createdAt',
  DistributionInstruction = 'distributionInstruction',
  FundCode = 'fundCode',
  HoldingUnits = 'holdingUnits',
  Id = 'id',
  PlanCode = 'planCode',
  PortfolioAccountNo = 'portfolioAccountNo',
  PortfolioAccountNo9Digit = 'portfolioAccountNo9Digit',
  ProfitLoss = 'profitLoss',
  UpdatedAt = 'updatedAt',
  WeightedAvgNavPrice = 'weightedAvgNavPrice',
  WeightedAvgNavPriceSyncedAt = 'weightedAvgNavPriceSyncedAt'
}

export type AccountPortfolioScalarWhereInput = {
  AND?: InputMaybe<Array<AccountPortfolioScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountPortfolioScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountPortfolioScalarWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  fundCode?: InputMaybe<StringFilter>;
  holdingUnits?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<StringFilter>;
  planCode?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo9Digit?: InputMaybe<StringNullableFilter>;
  profitLoss?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightedAvgNavPrice?: InputMaybe<DecimalFilter>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AccountPortfolioSumAggregate = {
  __typename?: 'AccountPortfolioSumAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  holdingUnits?: Maybe<Scalars['Decimal']['output']>;
  profitLoss?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgNavPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type AccountPortfolioUncheckedCreateInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  holdingUnits: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss: Scalars['Decimal']['input'];
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutAccountPortfolioInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice: Scalars['Decimal']['input'];
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountPortfolioCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountPortfolioCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountPortfolioCreateManyAccountInputEnvelope>;
};

export type AccountPortfolioUncheckedCreateWithoutAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  holdingUnits: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss: Scalars['Decimal']['input'];
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutAccountPortfolioInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice: Scalars['Decimal']['input'];
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUncheckedCreateWithoutTransactionsInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  holdingUnits: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss: Scalars['Decimal']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice: Scalars['Decimal']['input'];
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUncheckedUpdateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  holdingUnits?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss?: InputMaybe<Scalars['Decimal']['input']>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutAccountPortfolioNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUncheckedUpdateManyWithoutAccountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  holdingUnits?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountPortfolioCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountPortfolioCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountPortfolioCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountPortfolioScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountPortfolioWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountPortfolioUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountPortfolioUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountPortfolioUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountPortfolioUncheckedUpdateWithoutAccountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  holdingUnits?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<Scalars['String']['input']>;
  profitLoss?: InputMaybe<Scalars['Decimal']['input']>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutAccountPortfolioNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightedAvgNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountPortfolioUpdateManyWithWhereWithoutAccountInput = {
  data: AccountPortfolioUncheckedUpdateManyWithoutAccountInput;
  where: AccountPortfolioScalarWhereInput;
};

export type AccountPortfolioUpdateWithWhereUniqueWithoutAccountInput = {
  data: AccountPortfolioUncheckedUpdateWithoutAccountInput;
  where: AccountPortfolioWhereUniqueInput;
};

export type AccountPortfolioUpsertWithWhereUniqueWithoutAccountInput = {
  create: AccountPortfolioUncheckedCreateWithoutAccountInput;
  update: AccountPortfolioUncheckedUpdateWithoutAccountInput;
  where: AccountPortfolioWhereUniqueInput;
};

export type AccountPortfolioWhereInput = {
  AND?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  NOT?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  OR?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  holdingUnits?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<StringFilter>;
  planCode?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo9Digit?: InputMaybe<StringNullableFilter>;
  profitLoss?: InputMaybe<DecimalFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightedAvgNavPrice?: InputMaybe<DecimalFilter>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AccountPortfolioWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  NOT?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  OR?: InputMaybe<Array<AccountPortfolioWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  holdingUnits?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo9Digit?: InputMaybe<StringNullableFilter>;
  profitLoss?: InputMaybe<DecimalFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightedAvgNavPrice?: InputMaybe<DecimalFilter>;
  weightedAvgNavPriceSyncedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AccountRelationFilter = {
  is?: InputMaybe<AccountWhereInput>;
  isNot?: InputMaybe<AccountWhereInput>;
};

export type AccountRequest = {
  __typename?: 'AccountRequest';
  accountCreatedDate?: Maybe<Scalars['DateTime']['output']>;
  approvalStatus: ApprovalStatus;
  contactEmail: Scalars['String']['output'];
  contactName?: Maybe<Scalars['String']['output']>;
  contactNo: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  idNo: Scalars['String']['output'];
  idType: IdType;
  invitationCode?: Maybe<Scalars['String']['output']>;
  modeOfContact?: Maybe<ModeOfContact>;
  name: Scalars['String']['output'];
  referenceNo: Scalars['String']['output'];
  type: AccountType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountRequestCountAggregate = {
  __typename?: 'AccountRequestCountAggregate';
  _all: Scalars['Int']['output'];
  accountCreatedDate: Scalars['Int']['output'];
  approvalStatus: Scalars['Int']['output'];
  contactEmail: Scalars['Int']['output'];
  contactName: Scalars['Int']['output'];
  contactNo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idNo: Scalars['Int']['output'];
  idType: Scalars['Int']['output'];
  invitationCode: Scalars['Int']['output'];
  modeOfContact: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  referenceNo: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AccountRequestMaxAggregate = {
  __typename?: 'AccountRequestMaxAggregate';
  accountCreatedDate?: Maybe<Scalars['DateTime']['output']>;
  approvalStatus?: Maybe<ApprovalStatus>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<IdType>;
  invitationCode?: Maybe<Scalars['String']['output']>;
  modeOfContact?: Maybe<ModeOfContact>;
  name?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountRequestMinAggregate = {
  __typename?: 'AccountRequestMinAggregate';
  accountCreatedDate?: Maybe<Scalars['DateTime']['output']>;
  approvalStatus?: Maybe<ApprovalStatus>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<IdType>;
  invitationCode?: Maybe<Scalars['String']['output']>;
  modeOfContact?: Maybe<ModeOfContact>;
  name?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountRequestOrderByWithRelationInput = {
  accountCreatedDate?: InputMaybe<SortOrderInput>;
  approvalStatus?: InputMaybe<SortOrder>;
  contactEmail?: InputMaybe<SortOrder>;
  contactName?: InputMaybe<SortOrderInput>;
  contactNo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idNo?: InputMaybe<SortOrder>;
  idType?: InputMaybe<SortOrder>;
  invitationCode?: InputMaybe<SortOrderInput>;
  modeOfContact?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  referenceNo?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountRequestUncheckedCreateInput = {
  accountCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ApprovalStatus>;
  contactEmail: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactNo: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  modeOfContact?: InputMaybe<ModeOfContact>;
  name: Scalars['String']['input'];
  referenceNo: Scalars['String']['input'];
  type: AccountType;
};

export type AccountRequestUncheckedUpdateInput = {
  accountCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ApprovalStatus>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdType>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  modeOfContact?: InputMaybe<ModeOfContact>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export type AccountRequestWhereInput = {
  AND?: InputMaybe<Array<AccountRequestWhereInput>>;
  NOT?: InputMaybe<Array<AccountRequestWhereInput>>;
  OR?: InputMaybe<Array<AccountRequestWhereInput>>;
  accountCreatedDate?: InputMaybe<DateTimeNullableFilter>;
  approvalStatus?: InputMaybe<EnumApprovalStatusFilter>;
  contactEmail?: InputMaybe<StringFilter>;
  contactName?: InputMaybe<StringNullableFilter>;
  contactNo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  idNo?: InputMaybe<StringFilter>;
  idType?: InputMaybe<EnumIdTypeFilter>;
  invitationCode?: InputMaybe<StringNullableFilter>;
  modeOfContact?: InputMaybe<EnumModeOfContactNullableFilter>;
  name?: InputMaybe<StringFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAccountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountRequestWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountRequestWhereInput>>;
  NOT?: InputMaybe<Array<AccountRequestWhereInput>>;
  OR?: InputMaybe<Array<AccountRequestWhereInput>>;
  accountCreatedDate?: InputMaybe<DateTimeNullableFilter>;
  approvalStatus?: InputMaybe<EnumApprovalStatusFilter>;
  contactEmail?: InputMaybe<StringFilter>;
  contactName?: InputMaybe<StringNullableFilter>;
  contactNo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<StringFilter>;
  idType?: InputMaybe<EnumIdTypeFilter>;
  invitationCode?: InputMaybe<StringNullableFilter>;
  modeOfContact?: InputMaybe<EnumModeOfContactNullableFilter>;
  name?: InputMaybe<StringFilter>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAccountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AccountScalarFieldEnum {
  ApplicationDate = 'applicationDate',
  ApplicationRefId = 'applicationRefId',
  ApplicationStatus = 'applicationStatus',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  DistributionBank = 'distributionBank',
  DistributionBankAccount = 'distributionBankAccount',
  DistributionBankBeneficiary = 'distributionBankBeneficiary',
  DistributionInstruction = 'distributionInstruction',
  Id = 'id',
  MailingAddressCode = 'mailingAddressCode',
  MasterAccountNo = 'masterAccountNo',
  PermanentAddressCode = 'permanentAddressCode',
  ProfileId = 'profileId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type AccountScalarWhereInput = {
  AND?: InputMaybe<Array<AccountScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountScalarWhereInput>>;
  applicationDate?: InputMaybe<DateTimeNullableFilter>;
  applicationRefId?: InputMaybe<StringNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  distributionBank?: InputMaybe<StringNullableFilter>;
  distributionBankAccount?: InputMaybe<StringNullableFilter>;
  distributionBankBeneficiary?: InputMaybe<StringNullableFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mailingAddressCode?: InputMaybe<StringNullableFilter>;
  masterAccountNo?: InputMaybe<StringFilter>;
  permanentAddressCode?: InputMaybe<StringNullableFilter>;
  profileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AccountStatus {
  Active = 'Active',
  Bankrupt = 'Bankrupt',
  Closed = 'Closed',
  Deceased = 'Deceased',
  Dormant = 'Dormant',
  Inactive = 'Inactive',
  Legal = 'Legal',
  Suspended = 'Suspended'
}

export enum AccountType {
  Corporate = 'Corporate',
  Individual = 'Individual'
}

export type AccountUncheckedCreateInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioUncheckedCreateNestedManyWithoutAccountInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo: Scalars['String']['input'];
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<AccountCreateManyProfileInputEnvelope>;
};

export type AccountUncheckedCreateWithoutProfileInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioUncheckedCreateNestedManyWithoutAccountInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo: Scalars['String']['input'];
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutTransactionsInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioUncheckedCreateNestedManyWithoutAccountInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo: Scalars['String']['input'];
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
};

export type AccountUncheckedUpdateInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioUncheckedUpdateManyWithoutAccountNestedInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateManyWithoutProfileInput = {
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
};

export type AccountUncheckedUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<AccountCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<AccountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<AccountUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<AccountUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type AccountUncheckedUpdateWithoutProfileInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioUncheckedUpdateManyWithoutAccountNestedInput>;
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationRefId?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  distributionBank?: InputMaybe<Scalars['String']['input']>;
  distributionBankAccount?: InputMaybe<Scalars['String']['input']>;
  distributionBankBeneficiary?: InputMaybe<Scalars['String']['input']>;
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<Scalars['String']['input']>;
  masterAccountNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddressCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateManyWithWhereWithoutProfileInput = {
  data: AccountUncheckedUpdateManyWithoutProfileInput;
  where: AccountScalarWhereInput;
};

export type AccountUpdateWithWhereUniqueWithoutProfileInput = {
  data: AccountUncheckedUpdateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountUpsertWithWhereUniqueWithoutProfileInput = {
  create: AccountUncheckedCreateWithoutProfileInput;
  update: AccountUncheckedUpdateWithoutProfileInput;
  where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  accountPortfolios?: InputMaybe<AccountPortfolioListRelationFilter>;
  applicationDate?: InputMaybe<DateTimeNullableFilter>;
  applicationRefId?: InputMaybe<StringNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  distributionBank?: InputMaybe<StringNullableFilter>;
  distributionBankAccount?: InputMaybe<StringNullableFilter>;
  distributionBankBeneficiary?: InputMaybe<StringNullableFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mailingAddressCode?: InputMaybe<StringNullableFilter>;
  masterAccountNo?: InputMaybe<StringFilter>;
  permanentAddressCode?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableRelationFilter>;
  profileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  accountPortfolios?: InputMaybe<AccountPortfolioListRelationFilter>;
  applicationDate?: InputMaybe<DateTimeNullableFilter>;
  applicationRefId?: InputMaybe<StringNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  distributionBank?: InputMaybe<StringNullableFilter>;
  distributionBankAccount?: InputMaybe<StringNullableFilter>;
  distributionBankBeneficiary?: InputMaybe<StringNullableFilter>;
  distributionInstruction?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailingAddressCode?: InputMaybe<StringNullableFilter>;
  masterAccountNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddressCode?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableRelationFilter>;
  profileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAccountStatusFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ActionStatus {
  Failure = 'Failure',
  Success = 'Success',
  Warning = 'Warning'
}

export type ActiveTomswinSync = {
  __typename?: 'ActiveTomswinSync';
  batchId: Scalars['String']['output'];
  completedCount: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  failedCount: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingCount: Scalars['Float']['output'];
};

export type ActivityStatsInRange = {
  __typename?: 'ActivityStatsInRange';
  loginCount: Scalars['Int']['output'];
  statementViews: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type AddressCountAggregate = {
  __typename?: 'AddressCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  adrCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idNo: Scalars['Int']['output'];
  postalCode: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  town: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AddressMaxAggregate = {
  __typename?: 'AddressMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  adrCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AddressMinAggregate = {
  __typename?: 'AddressMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  adrCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminLoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AdminPermission = {
  __typename?: 'AdminPermission';
  action?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** prisma-lint-ignore-model require-field-type */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminPermissionAvgAggregate = {
  __typename?: 'AdminPermissionAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AdminPermissionCountAggregate = {
  __typename?: 'AdminPermissionCountAggregate';
  _all: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  resource: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AdminPermissionMaxAggregate = {
  __typename?: 'AdminPermissionMaxAggregate';
  action?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminPermissionMinAggregate = {
  __typename?: 'AdminPermissionMinAggregate';
  action?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminPermissionOrderByWithRelationInput = {
  action?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  resource?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminPermissionSumAggregate = {
  __typename?: 'AdminPermissionSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AdminPermissionWhereInput = {
  AND?: InputMaybe<Array<AdminPermissionWhereInput>>;
  NOT?: InputMaybe<Array<AdminPermissionWhereInput>>;
  OR?: InputMaybe<Array<AdminPermissionWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  resource?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdminRole = {
  __typename?: 'AdminRole';
  _count?: Maybe<AdminRoleCount>;
  admins: Array<AdminUser>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** prisma-lint-ignore-model require-field-type */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionGrants?: Maybe<Array<PermissionGrant>>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  userCount?: Maybe<Scalars['Float']['output']>;
};


export type AdminRoleAdminsArgs = {
  cursor?: InputMaybe<AdminUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdminUserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdminUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AdminUserWhereInput>;
};

export type AdminRoleAvgAggregate = {
  __typename?: 'AdminRoleAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AdminRoleCount = {
  __typename?: 'AdminRoleCount';
  admins: Scalars['Int']['output'];
};

export type AdminRoleCountAggregate = {
  __typename?: 'AdminRoleCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  permissions: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AdminRoleCreateInputV2 = {
  creationStatus?: InputMaybe<CreationStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminRoleMaxAggregate = {
  __typename?: 'AdminRoleMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminRoleMinAggregate = {
  __typename?: 'AdminRoleMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminRoleNullableRelationFilter = {
  is?: InputMaybe<AdminRoleWhereInput>;
  isNot?: InputMaybe<AdminRoleWhereInput>;
};

export type AdminRoleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminRoleSumAggregate = {
  __typename?: 'AdminRoleSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AdminRoleUpdateInputV2 = {
  creationStatus?: InputMaybe<CreationStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminRoleWhereInput = {
  AND?: InputMaybe<Array<AdminRoleWhereInput>>;
  NOT?: InputMaybe<Array<AdminRoleWhereInput>>;
  OR?: InputMaybe<Array<AdminRoleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdminRoleWhereUniqueInput = {
  AND?: InputMaybe<Array<AdminRoleWhereInput>>;
  NOT?: InputMaybe<Array<AdminRoleWhereInput>>;
  OR?: InputMaybe<Array<AdminRoleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  role?: Maybe<AdminRole>;
  roleId?: Maybe<Scalars['ID']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  status: AdminUserStatus;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};


export type AdminUserRoleArgs = {
  where?: InputMaybe<AdminRoleWhereInput>;
};

export type AdminUserAvgAggregate = {
  __typename?: 'AdminUserAvgAggregate';
  roleId?: Maybe<Scalars['Float']['output']>;
};

export type AdminUserCountAggregate = {
  __typename?: 'AdminUserCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastLoginAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  profilePicture: Scalars['Int']['output'];
  roleId: Scalars['Int']['output'];
  sessionToken: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  username: Scalars['Int']['output'];
};

export type AdminUserCreateInputV2 = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  lastLoginAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AdminUserStatus>;
  username: Scalars['String']['input'];
};

export type AdminUserMaxAggregate = {
  __typename?: 'AdminUserMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AdminUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminUserMinAggregate = {
  __typename?: 'AdminUserMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AdminUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminUserOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastLoginAt?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  profilePicture?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<AdminRoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrderInput>;
  sessionToken?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
};

export enum AdminUserScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  Email = 'email',
  Id = 'id',
  LastLoginAt = 'lastLoginAt',
  Name = 'name',
  ProfilePicture = 'profilePicture',
  RoleId = 'roleId',
  SessionToken = 'sessionToken',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  Username = 'username'
}

export enum AdminUserStatus {
  Active = 'Active',
  Dormant = 'Dormant',
  Suspended = 'Suspended'
}

export type AdminUserSumAggregate = {
  __typename?: 'AdminUserSumAggregate';
  roleId?: Maybe<Scalars['Int']['output']>;
};

export type AdminUserUpdateInputV2 = {
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastLoginAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AdminUserStatus>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserWhereInput = {
  AND?: InputMaybe<Array<AdminUserWhereInput>>;
  NOT?: InputMaybe<Array<AdminUserWhereInput>>;
  OR?: InputMaybe<Array<AdminUserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastLoginAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<AdminRoleNullableRelationFilter>;
  roleId?: InputMaybe<IntNullableFilter>;
  sessionToken?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAdminUserStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type AdminUserWhereUniqueInput = {
  AND?: InputMaybe<Array<AdminUserWhereInput>>;
  NOT?: InputMaybe<Array<AdminUserWhereInput>>;
  OR?: InputMaybe<Array<AdminUserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastLoginAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<AdminRoleNullableRelationFilter>;
  roleId?: InputMaybe<IntNullableFilter>;
  sessionToken?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAdminUserStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AmountValue = {
  __typename?: 'AmountValue';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  ctaLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: AnnouncementStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AnnouncementCountAggregate = {
  __typename?: 'AnnouncementCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  ctaLink: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageId: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AnnouncementMaxAggregate = {
  __typename?: 'AnnouncementMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AnnouncementStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementMinAggregate = {
  __typename?: 'AnnouncementMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AnnouncementStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementOrderByWithRelationInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  ctaLink?: InputMaybe<SortOrderInput>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnnouncementStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type AnnouncementUncheckedCreateInput = {
  content: Scalars['String']['input'];
  creationStatus?: InputMaybe<CreationStatus>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CreateOneDocumentInput>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<AnnouncementStatus>;
  title: Scalars['String']['input'];
};

export type AnnouncementUncheckedUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CreateOneDocumentInput>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AnnouncementStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementWhereInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  ctaLink?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  imageId?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumAnnouncementStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnouncementWhereUniqueInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  ctaLink?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumAnnouncementStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnualisedReturn = {
  __typename?: 'AnnualisedReturn';
  label?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum ApprovalStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type AuditTrail = {
  __typename?: 'AuditTrail';
  action: Scalars['String']['output'];
  appVersion?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  clientIp: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interface: Interface;
  module: Scalars['String']['output'];
  relatedEntities?: Maybe<Scalars['JSON']['output']>;
  relatedIds?: Maybe<Scalars['JSON']['output']>;
  serverIp: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  status: ActionStatus;
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  userType: UserType;
  username: Scalars['String']['output'];
};

export type AuditTrailCountAggregate = {
  __typename?: 'AuditTrailCountAggregate';
  _all: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  appVersion: Scalars['Int']['output'];
  channel: Scalars['Int']['output'];
  clientIp: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  details: Scalars['Int']['output'];
  environment: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  interface: Scalars['Int']['output'];
  module: Scalars['Int']['output'];
  relatedEntities: Scalars['Int']['output'];
  relatedIds: Scalars['Int']['output'];
  serverIp: Scalars['Int']['output'];
  sessionId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  userType: Scalars['Int']['output'];
  username: Scalars['Int']['output'];
};

export type AuditTrailMaxAggregate = {
  __typename?: 'AuditTrailMaxAggregate';
  action?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  clientIp?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interface?: Maybe<Interface>;
  module?: Maybe<Scalars['String']['output']>;
  serverIp?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActionStatus>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<UserType>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AuditTrailMinAggregate = {
  __typename?: 'AuditTrailMinAggregate';
  action?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  clientIp?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interface?: Maybe<Interface>;
  module?: Maybe<Scalars['String']['output']>;
  serverIp?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActionStatus>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<UserType>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AuditTrailOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  appVersion?: InputMaybe<SortOrderInput>;
  channel?: InputMaybe<SortOrderInput>;
  clientIp?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrderInput>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interface?: InputMaybe<SortOrder>;
  module?: InputMaybe<SortOrder>;
  relatedEntities?: InputMaybe<SortOrderInput>;
  relatedIds?: InputMaybe<SortOrderInput>;
  serverIp?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  timestamp?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  userType?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
};

export type AuditTrailUncheckedCreateInput = {
  action: Scalars['String']['input'];
  appVersion?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  clientIp: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  interface: Interface;
  module: Scalars['String']['input'];
  relatedEntities?: InputMaybe<Scalars['JSON']['input']>;
  relatedIds?: InputMaybe<Scalars['JSON']['input']>;
  serverIp: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionStatus>;
  timestamp: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userType?: InputMaybe<UserType>;
  username: Scalars['String']['input'];
};

export type AuditTrailUncheckedUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  clientIp?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interface?: InputMaybe<Interface>;
  module?: InputMaybe<Scalars['String']['input']>;
  relatedEntities?: InputMaybe<Scalars['JSON']['input']>;
  relatedIds?: InputMaybe<Scalars['JSON']['input']>;
  serverIp?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<UserType>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AuditTrailWhereInput = {
  AND?: InputMaybe<Array<AuditTrailWhereInput>>;
  NOT?: InputMaybe<Array<AuditTrailWhereInput>>;
  OR?: InputMaybe<Array<AuditTrailWhereInput>>;
  action?: InputMaybe<StringFilter>;
  appVersion?: InputMaybe<StringNullableFilter>;
  channel?: InputMaybe<StringNullableFilter>;
  clientIp?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  environment?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  interface?: InputMaybe<EnumInterfaceFilter>;
  module?: InputMaybe<StringFilter>;
  relatedEntities?: InputMaybe<JsonNullableFilter>;
  relatedIds?: InputMaybe<JsonNullableFilter>;
  serverIp?: InputMaybe<StringFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumActionStatusFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
  userType?: InputMaybe<EnumUserTypeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type AuditTrailWhereUniqueInput = {
  AND?: InputMaybe<Array<AuditTrailWhereInput>>;
  NOT?: InputMaybe<Array<AuditTrailWhereInput>>;
  OR?: InputMaybe<Array<AuditTrailWhereInput>>;
  action?: InputMaybe<StringFilter>;
  appVersion?: InputMaybe<StringNullableFilter>;
  channel?: InputMaybe<StringNullableFilter>;
  clientIp?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  environment?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  interface?: InputMaybe<EnumInterfaceFilter>;
  module?: InputMaybe<StringFilter>;
  relatedEntities?: InputMaybe<JsonNullableFilter>;
  relatedIds?: InputMaybe<JsonNullableFilter>;
  serverIp?: InputMaybe<StringFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumActionStatusFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
  userType?: InputMaybe<EnumUserTypeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  refreshExpiresIn: Scalars['Float']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
};

export type AuthUserUnion = AdminUser | User;

export type AuthorisedSignatory = {
  __typename?: 'AuthorisedSignatory';
  Signatory: Array<Signatory>;
  _count?: Maybe<AuthorisedSignatoryCount>;
  attachment?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  companyProfile?: Maybe<Profile>;
  companyProfileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idNo?: Maybe<Scalars['String']['output']>;
  status: AuthorisedSignatoryStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type AuthorisedSignatorySignatoryArgs = {
  cursor?: InputMaybe<SignatoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<SignatoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SignatoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SignatoryWhereInput>;
};


export type AuthorisedSignatoryCompanyProfileArgs = {
  where?: InputMaybe<ProfileWhereInput>;
};

export type AuthorisedSignatoryCount = {
  __typename?: 'AuthorisedSignatoryCount';
  Signatory: Scalars['Int']['output'];
};

export type AuthorisedSignatoryCountAggregate = {
  __typename?: 'AuthorisedSignatoryCountAggregate';
  _all: Scalars['Int']['output'];
  attachmentId: Scalars['Int']['output'];
  companyProfileId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  fullName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idNo: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AuthorisedSignatoryCreateManyCompanyProfileInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryCreateManyCompanyProfileInputEnvelope = {
  data: Array<AuthorisedSignatoryCreateManyCompanyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorisedSignatoryCreateNestedManyWithoutCompanyProfileInput = {
  connect?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthorisedSignatoryCreateOrConnectWithoutCompanyProfileInput>>;
  create?: InputMaybe<Array<AuthorisedSignatoryCreateWithoutCompanyProfileInput>>;
  createMany?: InputMaybe<AuthorisedSignatoryCreateManyCompanyProfileInputEnvelope>;
};

export type AuthorisedSignatoryCreateNestedOneWithoutSignatoryInput = {
  connect?: InputMaybe<AuthorisedSignatoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AuthorisedSignatoryCreateOrConnectWithoutSignatoryInput>;
  create?: InputMaybe<AuthorisedSignatoryUncheckedCreateWithoutSignatoryInput>;
};

export type AuthorisedSignatoryCreateOrConnectWithoutCompanyProfileInput = {
  create: AuthorisedSignatoryUncheckedCreateWithoutCompanyProfileInput;
  where: AuthorisedSignatoryWhereUniqueInput;
};

export type AuthorisedSignatoryCreateOrConnectWithoutSignatoryInput = {
  create: AuthorisedSignatoryUncheckedCreateWithoutSignatoryInput;
  where: AuthorisedSignatoryWhereUniqueInput;
};

export type AuthorisedSignatoryCreateWithoutCompanyProfileInput = {
  Signatory?: InputMaybe<SignatoryCreateNestedManyWithoutAuthorisedSignatoryInput>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryListRelationFilter = {
  every?: InputMaybe<AuthorisedSignatoryWhereInput>;
  none?: InputMaybe<AuthorisedSignatoryWhereInput>;
  some?: InputMaybe<AuthorisedSignatoryWhereInput>;
};

export type AuthorisedSignatoryMaxAggregate = {
  __typename?: 'AuthorisedSignatoryMaxAggregate';
  attachmentId?: Maybe<Scalars['String']['output']>;
  companyProfileId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AuthorisedSignatoryStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorisedSignatoryMinAggregate = {
  __typename?: 'AuthorisedSignatoryMinAggregate';
  attachmentId?: Maybe<Scalars['String']['output']>;
  companyProfileId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AuthorisedSignatoryStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorisedSignatoryNullableRelationFilter = {
  is?: InputMaybe<AuthorisedSignatoryWhereInput>;
  isNot?: InputMaybe<AuthorisedSignatoryWhereInput>;
};

export type AuthorisedSignatoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuthorisedSignatoryOrderByWithRelationInput = {
  Signatory?: InputMaybe<SignatoryOrderByRelationAggregateInput>;
  attachmentId?: InputMaybe<SortOrderInput>;
  companyProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  companyProfileId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idNo?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AuthorisedSignatoryScalarFieldEnum {
  AttachmentId = 'attachmentId',
  CompanyProfileId = 'companyProfileId',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  Email = 'email',
  FullName = 'fullName',
  Id = 'id',
  IdNo = 'idNo',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type AuthorisedSignatoryScalarWhereInput = {
  AND?: InputMaybe<Array<AuthorisedSignatoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<AuthorisedSignatoryScalarWhereInput>>;
  OR?: InputMaybe<Array<AuthorisedSignatoryScalarWhereInput>>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  companyProfileId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  idNo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAuthorisedSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AuthorisedSignatoryStatus {
  Active = 'Active',
  Revoked = 'Revoked'
}

export type AuthorisedSignatoryUncheckedCreateInput = {
  attachment?: InputMaybe<CreateOneDocumentInput>;
  companyProfileId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput = {
  connect?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthorisedSignatoryCreateOrConnectWithoutCompanyProfileInput>>;
  create?: InputMaybe<Array<AuthorisedSignatoryCreateWithoutCompanyProfileInput>>;
  createMany?: InputMaybe<AuthorisedSignatoryCreateManyCompanyProfileInputEnvelope>;
};

export type AuthorisedSignatoryUncheckedCreateWithoutCompanyProfileInput = {
  Signatory?: InputMaybe<SignatoryUncheckedCreateNestedManyWithoutAuthorisedSignatoryInput>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryUncheckedCreateWithoutSignatoryInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  companyProfileId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryUncheckedUpdateInput = {
  attachment?: InputMaybe<CreateOneDocumentInput>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryUncheckedUpdateManyWithoutCompanyProfileInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryUncheckedUpdateManyWithoutCompanyProfileNestedInput = {
  connect?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthorisedSignatoryCreateOrConnectWithoutCompanyProfileInput>>;
  create?: InputMaybe<Array<AuthorisedSignatoryCreateWithoutCompanyProfileInput>>;
  createMany?: InputMaybe<AuthorisedSignatoryCreateManyCompanyProfileInputEnvelope>;
  delete?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuthorisedSignatoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  set?: InputMaybe<Array<AuthorisedSignatoryWhereUniqueInput>>;
  update?: InputMaybe<Array<AuthorisedSignatoryUpdateWithWhereUniqueWithoutCompanyProfileInput>>;
  updateMany?: InputMaybe<Array<AuthorisedSignatoryUpdateManyWithWhereWithoutCompanyProfileInput>>;
  upsert?: InputMaybe<Array<AuthorisedSignatoryUpsertWithWhereUniqueWithoutCompanyProfileInput>>;
};

export type AuthorisedSignatoryUncheckedUpdateWithoutCompanyProfileInput = {
  Signatory?: InputMaybe<SignatoryUncheckedUpdateManyWithoutAuthorisedSignatoryNestedInput>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthorisedSignatoryStatus>;
};

export type AuthorisedSignatoryUpdateManyWithWhereWithoutCompanyProfileInput = {
  data: AuthorisedSignatoryUncheckedUpdateManyWithoutCompanyProfileInput;
  where: AuthorisedSignatoryScalarWhereInput;
};

export type AuthorisedSignatoryUpdateWithWhereUniqueWithoutCompanyProfileInput = {
  data: AuthorisedSignatoryUncheckedUpdateWithoutCompanyProfileInput;
  where: AuthorisedSignatoryWhereUniqueInput;
};

export type AuthorisedSignatoryUpsertWithWhereUniqueWithoutCompanyProfileInput = {
  create: AuthorisedSignatoryUncheckedCreateWithoutCompanyProfileInput;
  update: AuthorisedSignatoryUncheckedUpdateWithoutCompanyProfileInput;
  where: AuthorisedSignatoryWhereUniqueInput;
};

export type AuthorisedSignatoryWhereInput = {
  AND?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  NOT?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  OR?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  Signatory?: InputMaybe<SignatoryListRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  companyProfile?: InputMaybe<ProfileNullableRelationFilter>;
  companyProfileId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  idNo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAuthorisedSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AuthorisedSignatoryWhereUniqueInput = {
  AND?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  NOT?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  OR?: InputMaybe<Array<AuthorisedSignatoryWhereInput>>;
  Signatory?: InputMaybe<SignatoryListRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  companyProfile?: InputMaybe<ProfileNullableRelationFilter>;
  companyProfileId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idNo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAuthorisedSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Bank = {
  __typename?: 'Bank';
  BankAccount: Array<BankAccount>;
  _count?: Maybe<BankCount>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type BankBankAccountArgs = {
  cursor?: InputMaybe<BankAccountWhereUniqueInput>;
  distinct?: InputMaybe<Array<BankAccountScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BankAccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BankAccountWhereInput>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  _count?: Maybe<BankAccountCount>;
  accountNo: Scalars['String']['output'];
  accountType?: Maybe<BankAccountType>;
  bank?: Maybe<Bank>;
  bankCode: Scalars['String']['output'];
  beneficiaryName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  orders: Array<Order>;
  profile: Profile;
  profileId: Scalars['String']['output'];
  sequence?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  syncBatchId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BankType>;
  updatedAt: Scalars['DateTime']['output'];
};


export type BankAccountBankArgs = {
  where?: InputMaybe<BankWhereInput>;
};


export type BankAccountOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type BankAccountBank_Account_UniqueCompoundUniqueInput = {
  accountNo: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  sequence: Scalars['String']['input'];
  type: BankType;
};

export type BankAccountCount = {
  __typename?: 'BankAccountCount';
  orders: Scalars['Int']['output'];
};

export type BankAccountCountAggregate = {
  __typename?: 'BankAccountCountAggregate';
  _all: Scalars['Int']['output'];
  accountNo: Scalars['Int']['output'];
  accountType: Scalars['Int']['output'];
  bankCode: Scalars['Int']['output'];
  beneficiaryName: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  sequence: Scalars['Int']['output'];
  swiftCode: Scalars['Int']['output'];
  syncBatchId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BankAccountCreateManyBankInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountCreateManyBankInputEnvelope = {
  data: Array<BankAccountCreateManyBankInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BankAccountCreateManyProfileInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  bankCode: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountCreateManyProfileInputEnvelope = {
  data: Array<BankAccountCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BankAccountCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BankAccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<BankAccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<BankAccountCreateManyProfileInputEnvelope>;
};

export type BankAccountCreateOrConnectWithoutBankInput = {
  create: BankAccountUncheckedCreateWithoutBankInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountCreateOrConnectWithoutProfileInput = {
  create: BankAccountUncheckedCreateWithoutProfileInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountCreateWithoutBankInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutBankAccountInput>;
  profile: ProfileCreateNestedOneWithoutBankAccountsInput;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountCreateWithoutProfileInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  bank?: InputMaybe<BankCreateNestedOneWithoutBankAccountInput>;
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutBankAccountInput>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountListRelationFilter = {
  every?: InputMaybe<BankAccountWhereInput>;
  none?: InputMaybe<BankAccountWhereInput>;
  some?: InputMaybe<BankAccountWhereInput>;
};

export type BankAccountMaxAggregate = {
  __typename?: 'BankAccountMaxAggregate';
  accountNo?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<BankAccountType>;
  bankCode?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  syncBatchId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BankType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankAccountMinAggregate = {
  __typename?: 'BankAccountMinAggregate';
  accountNo?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<BankAccountType>;
  bankCode?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  syncBatchId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BankType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankAccountNullableRelationFilter = {
  is?: InputMaybe<BankAccountWhereInput>;
  isNot?: InputMaybe<BankAccountWhereInput>;
};

export type BankAccountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BankAccountOrderByWithRelationInput = {
  accountNo?: InputMaybe<SortOrder>;
  accountType?: InputMaybe<SortOrderInput>;
  bank?: InputMaybe<BankOrderByWithRelationInput>;
  bankCode?: InputMaybe<SortOrder>;
  beneficiaryName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrder>;
  sequence?: InputMaybe<SortOrderInput>;
  swiftCode?: InputMaybe<SortOrderInput>;
  syncBatchId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum BankAccountScalarFieldEnum {
  AccountNo = 'accountNo',
  AccountType = 'accountType',
  BankCode = 'bankCode',
  BeneficiaryName = 'beneficiaryName',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Id = 'id',
  IsDefault = 'isDefault',
  ProfileId = 'profileId',
  Sequence = 'sequence',
  SwiftCode = 'swiftCode',
  SyncBatchId = 'syncBatchId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type BankAccountScalarWhereInput = {
  AND?: InputMaybe<Array<BankAccountScalarWhereInput>>;
  NOT?: InputMaybe<Array<BankAccountScalarWhereInput>>;
  OR?: InputMaybe<Array<BankAccountScalarWhereInput>>;
  accountNo?: InputMaybe<StringFilter>;
  accountType?: InputMaybe<EnumBankAccountTypeNullableFilter>;
  bankCode?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  profileId?: InputMaybe<StringFilter>;
  sequence?: InputMaybe<StringNullableFilter>;
  swiftCode?: InputMaybe<StringNullableFilter>;
  syncBatchId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumBankTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum BankAccountType {
  Current = 'Current',
  Savings = 'Savings'
}

export type BankAccountUncheckedCreateInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  bankCode: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedCreateNestedManyWithoutBankAccountInput>;
  profileId: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedCreateNestedManyWithoutBankInput = {
  connect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BankAccountCreateOrConnectWithoutBankInput>>;
  create?: InputMaybe<Array<BankAccountCreateWithoutBankInput>>;
  createMany?: InputMaybe<BankAccountCreateManyBankInputEnvelope>;
};

export type BankAccountUncheckedCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BankAccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<BankAccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<BankAccountCreateManyProfileInputEnvelope>;
};

export type BankAccountUncheckedCreateWithoutBankInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedCreateNestedManyWithoutBankAccountInput>;
  profileId: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedCreateWithoutProfileInput = {
  accountNo: Scalars['String']['input'];
  accountType?: InputMaybe<BankAccountType>;
  bankCode: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedCreateNestedManyWithoutBankAccountInput>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedUpdateInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedUpdateManyWithoutBankAccountNestedInput>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedUpdateManyWithoutBankInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedUpdateManyWithoutBankNestedInput = {
  connect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BankAccountCreateOrConnectWithoutBankInput>>;
  create?: InputMaybe<Array<BankAccountCreateWithoutBankInput>>;
  createMany?: InputMaybe<BankAccountCreateManyBankInputEnvelope>;
  delete?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BankAccountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  set?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  update?: InputMaybe<Array<BankAccountUpdateWithWhereUniqueWithoutBankInput>>;
  updateMany?: InputMaybe<Array<BankAccountUpdateManyWithWhereWithoutBankInput>>;
  upsert?: InputMaybe<Array<BankAccountUpsertWithWhereUniqueWithoutBankInput>>;
};

export type BankAccountUncheckedUpdateManyWithoutProfileInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BankAccountCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<BankAccountCreateWithoutProfileInput>>;
  createMany?: InputMaybe<BankAccountCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BankAccountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  set?: InputMaybe<Array<BankAccountWhereUniqueInput>>;
  update?: InputMaybe<Array<BankAccountUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<BankAccountUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<BankAccountUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type BankAccountUncheckedUpdateWithoutBankInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedUpdateManyWithoutBankAccountNestedInput>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUncheckedUpdateWithoutProfileInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderUncheckedUpdateManyWithoutBankAccountNestedInput>;
  sequence?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  syncBatchId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankAccountUpdateManyWithWhereWithoutBankInput = {
  data: BankAccountUncheckedUpdateManyWithoutBankInput;
  where: BankAccountScalarWhereInput;
};

export type BankAccountUpdateManyWithWhereWithoutProfileInput = {
  data: BankAccountUncheckedUpdateManyWithoutProfileInput;
  where: BankAccountScalarWhereInput;
};

export type BankAccountUpdateWithWhereUniqueWithoutBankInput = {
  data: BankAccountUncheckedUpdateWithoutBankInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountUpdateWithWhereUniqueWithoutProfileInput = {
  data: BankAccountUncheckedUpdateWithoutProfileInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountUpsertWithWhereUniqueWithoutBankInput = {
  create: BankAccountUncheckedCreateWithoutBankInput;
  update: BankAccountUncheckedUpdateWithoutBankInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountUpsertWithWhereUniqueWithoutProfileInput = {
  create: BankAccountUncheckedCreateWithoutProfileInput;
  update: BankAccountUncheckedUpdateWithoutProfileInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountWhereInput = {
  AND?: InputMaybe<Array<BankAccountWhereInput>>;
  NOT?: InputMaybe<Array<BankAccountWhereInput>>;
  OR?: InputMaybe<Array<BankAccountWhereInput>>;
  accountNo?: InputMaybe<StringFilter>;
  accountType?: InputMaybe<EnumBankAccountTypeNullableFilter>;
  bank?: InputMaybe<BankNullableRelationFilter>;
  bankCode?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<StringFilter>;
  sequence?: InputMaybe<StringNullableFilter>;
  swiftCode?: InputMaybe<StringNullableFilter>;
  syncBatchId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumBankTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BankAccountWhereUniqueInput = {
  AND?: InputMaybe<Array<BankAccountWhereInput>>;
  NOT?: InputMaybe<Array<BankAccountWhereInput>>;
  OR?: InputMaybe<Array<BankAccountWhereInput>>;
  accountNo?: InputMaybe<StringFilter>;
  accountType?: InputMaybe<EnumBankAccountTypeNullableFilter>;
  bank?: InputMaybe<BankNullableRelationFilter>;
  bankCode?: InputMaybe<StringFilter>;
  bank_account_unique?: InputMaybe<BankAccountBank_Account_UniqueCompoundUniqueInput>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<BoolFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<StringFilter>;
  sequence?: InputMaybe<StringNullableFilter>;
  swiftCode?: InputMaybe<StringNullableFilter>;
  syncBatchId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumBankTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BankCount = {
  __typename?: 'BankCount';
  BankAccount: Scalars['Int']['output'];
};

export type BankCountAggregate = {
  __typename?: 'BankCountAggregate';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BankCreateNestedOneWithoutBankAccountInput = {
  connect?: InputMaybe<BankWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BankCreateOrConnectWithoutBankAccountInput>;
  create?: InputMaybe<BankUncheckedCreateWithoutBankAccountInput>;
};

export type BankCreateOrConnectWithoutBankAccountInput = {
  create: BankUncheckedCreateWithoutBankAccountInput;
  where: BankWhereUniqueInput;
};

export type BankDetails = {
  __typename?: 'BankDetails';
  accountNo?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type BankMaxAggregate = {
  __typename?: 'BankMaxAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankMinAggregate = {
  __typename?: 'BankMinAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankNullableRelationFilter = {
  is?: InputMaybe<BankWhereInput>;
  isNot?: InputMaybe<BankWhereInput>;
};

export type BankOrderByWithRelationInput = {
  BankAccount?: InputMaybe<BankAccountOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum BankType {
  Dividend = 'Dividend',
  Investment = 'Investment'
}

export type BankUncheckedCreateInput = {
  BankAccount?: InputMaybe<BankAccountUncheckedCreateNestedManyWithoutBankInput>;
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type BankUncheckedCreateWithoutBankAccountInput = {
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type BankUncheckedUpdateInput = {
  BankAccount?: InputMaybe<BankAccountUncheckedUpdateManyWithoutBankNestedInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BankWhereInput = {
  AND?: InputMaybe<Array<BankWhereInput>>;
  BankAccount?: InputMaybe<BankAccountListRelationFilter>;
  NOT?: InputMaybe<Array<BankWhereInput>>;
  OR?: InputMaybe<Array<BankWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BankWhereUniqueInput = {
  AND?: InputMaybe<Array<BankWhereInput>>;
  BankAccount?: InputMaybe<BankAccountListRelationFilter>;
  NOT?: InputMaybe<Array<BankWhereInput>>;
  OR?: InputMaybe<Array<BankWhereInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BytesFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type CalendarYearReturn = {
  __typename?: 'CalendarYearReturn';
  label?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CollectionBankAccount = {
  __typename?: 'CollectionBankAccount';
  Payment: Array<Payment>;
  _count?: Maybe<CollectionBankAccountCount>;
  accountNo: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  beneficiaryName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  funds: Array<Fund>;
  id: Scalars['ID']['output'];
  swiftCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CollectionBankAccountPaymentArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type CollectionBankAccountFundsArgs = {
  cursor?: InputMaybe<FundWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundWhereInput>;
};

export type CollectionBankAccountCount = {
  __typename?: 'CollectionBankAccountCount';
  Payment: Scalars['Int']['output'];
  funds: Scalars['Int']['output'];
};

export type CollectionBankAccountCountAggregate = {
  __typename?: 'CollectionBankAccountCountAggregate';
  _all: Scalars['Int']['output'];
  accountNo: Scalars['Int']['output'];
  bankName: Scalars['Int']['output'];
  beneficiaryName: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  swiftCode: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CollectionBankAccountCreateNestedOneWithoutFundsInput = {
  connect?: InputMaybe<CollectionBankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionBankAccountCreateOrConnectWithoutFundsInput>;
  create?: InputMaybe<CollectionBankAccountUncheckedCreateWithoutFundsInput>;
};

export type CollectionBankAccountCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<CollectionBankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionBankAccountCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<CollectionBankAccountUncheckedCreateWithoutPaymentInput>;
};

export type CollectionBankAccountCreateOrConnectWithoutFundsInput = {
  create: CollectionBankAccountUncheckedCreateWithoutFundsInput;
  where: CollectionBankAccountWhereUniqueInput;
};

export type CollectionBankAccountCreateOrConnectWithoutPaymentInput = {
  create: CollectionBankAccountUncheckedCreateWithoutPaymentInput;
  where: CollectionBankAccountWhereUniqueInput;
};

export type CollectionBankAccountMaxAggregate = {
  __typename?: 'CollectionBankAccountMaxAggregate';
  accountNo?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectionBankAccountMinAggregate = {
  __typename?: 'CollectionBankAccountMinAggregate';
  accountNo?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectionBankAccountNullableRelationFilter = {
  is?: InputMaybe<CollectionBankAccountWhereInput>;
  isNot?: InputMaybe<CollectionBankAccountWhereInput>;
};

export type CollectionBankAccountOrderByWithRelationInput = {
  Payment?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  accountNo?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  beneficiaryName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrderInput>;
  funds?: InputMaybe<FundOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  swiftCode?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CollectionBankAccountUncheckedCreateInput = {
  Payment?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutCollectionBankAccountInput>;
  accountNo: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<FundUncheckedCreateNestedManyWithoutCollectionBankAccountInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CollectionBankAccountUncheckedCreateWithoutFundsInput = {
  Payment?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutCollectionBankAccountInput>;
  accountNo: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CollectionBankAccountUncheckedCreateWithoutPaymentInput = {
  accountNo: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<FundUncheckedCreateNestedManyWithoutCollectionBankAccountInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CollectionBankAccountUncheckedUpdateInput = {
  Payment?: InputMaybe<PaymentUncheckedUpdateManyWithoutCollectionBankAccountNestedInput>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<FundUncheckedUpdateManyWithoutCollectionBankAccountNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CollectionBankAccountWhereInput = {
  AND?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  NOT?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  OR?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  Payment?: InputMaybe<PaymentListRelationFilter>;
  accountNo?: InputMaybe<StringFilter>;
  bankName?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  swiftCode?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CollectionBankAccountWhereUniqueInput = {
  AND?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  NOT?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  OR?: InputMaybe<Array<CollectionBankAccountWhereInput>>;
  Payment?: InputMaybe<PaymentListRelationFilter>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CombineTransactionDto = {
  __typename?: 'CombineTransactionDto';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  detailedPublicStatus?: Maybe<TransactionDetailedPublicStatus>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  navPrice: Scalars['Float']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo: Scalars['String']['output'];
  publicStatus?: Maybe<TransactionPublicStatus>;
  quantity: Scalars['Float']['output'];
  referenceNo?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyAddresses = {
  __typename?: 'CompanyAddresses';
  mailingAddress?: Maybe<Address>;
  permanentAddress?: Maybe<Address>;
};

export type CompanyPerformance = {
  __typename?: 'CompanyPerformance';
  companyName: Scalars['String']['output'];
  currentMarketValues: Array<AmountValue>;
  profileId: Scalars['ID']['output'];
  profitAndLossValues: Array<ProfitAndLossValue>;
  totalInvestedValues: Array<AmountValue>;
};

export enum ConsentStatus {
  Active = 'Active',
  Revoked = 'Revoked'
}

export enum ConsentType {
  Transact = 'Transact',
  View = 'View'
}

export type ConsentedProfile = {
  __typename?: 'ConsentedProfile';
  isMain: Scalars['Boolean']['output'];
  permissions: Array<ConsentType>;
  profile: Profile;
};

export type CorporateAccountRequestCreateInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactNo: Scalars['String']['input'];
  idNo: Scalars['String']['input'];
  modeOfContact?: InputMaybe<ModeOfContact>;
  name: Scalars['String']['input'];
};

/** Payment methods available for corporate users (excludes FPX) */
export enum CorporatePaymentMethod {
  OnlineBanking = 'OnlineBanking',
  TelegraphicTransfer = 'TelegraphicTransfer'
}

export type CorporateUserUncheckedCreateInput = {
  accountRequestId: Scalars['String']['input'];
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<ProfileUncheckedCreateNestedManyWithoutUsersInput>;
  securityImageId: Scalars['String']['input'];
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CountRow = {
  __typename?: 'CountRow';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type CreateOneDocumentInput = {
  data: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFundPolicyInput = {
  annualManagementFee: Scalars['Decimal']['input'];
  annualTrusteeFee: Scalars['Decimal']['input'];
  cutOffTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit: Scalars['Decimal']['input'];
  minInitInvestment: Scalars['Decimal']['input'];
  minRedemptionUnit: Scalars['Decimal']['input'];
  minSubsequentInvestment: Scalars['Decimal']['input'];
  minSwitchingUnit: Scalars['Decimal']['input'];
  redemptionCutOffTime: Scalars['String']['input'];
  salesChargePercent: Scalars['Decimal']['input'];
  wholeSaleFlag: Scalars['Boolean']['input'];
};

export type CreateRedemptionInputArgs = {
  bankAc: Scalars['String']['input'];
  bankCd: Scalars['String']['input'];
  bankSeq: Scalars['String']['input'];
  bkDate: Scalars['String']['input'];
  extFee: Scalars['String']['input'];
  fndAcc: Scalars['String']['input'];
  icNo: Scalars['String']['input'];
  mAcc: Scalars['String']['input'];
  payN: Scalars['String']['input'];
  paymentTyp: TomswinRedemptionPaymentType;
  redTyp: TomswinRedemptionType;
  redUnit: Scalars['String']['input'];
};

export type CreateSaleInputArgs = {
  bkDate: Scalars['String']['input'];
  dvdInst: TomswinDvdInst;
  fndCde: Scalars['String']['input'];
  fndPln: TomswinFundPlan;
  icNo: Scalars['String']['input'];
  macc: Scalars['String']['input'];
  payFI: Scalars['String']['input'];
  payRef: Scalars['String']['input'];
  payTyp: TomswinPaymentType;
  salFIns: Scalars['String']['input'];
  trnAmt: Scalars['String']['input'];
};

export type CreateSwitchingInputArgs = {
  bkDate: Scalars['String']['input'];
  brnchCd: Scalars['String']['input'];
  extFee: Scalars['String']['input'];
  fndAcc: Scalars['String']['input'];
  fndAccIn: Scalars['String']['input'];
  fndAccInd: Scalars['String']['input'];
  icNo: Scalars['String']['input'];
  mAcc: Scalars['String']['input'];
  mAccIn: Scalars['String']['input'];
  swInFundCd: Scalars['String']['input'];
  swInFundPln: Scalars['String']['input'];
  swOutFundCd: Scalars['String']['input'];
  swOutFundPln: Scalars['String']['input'];
  swOutUnt: Scalars['String']['input'];
  typSw: TomswinSwitchingType;
};

export enum CreationStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type DailyStatisticsInRange = {
  __typename?: 'DailyStatisticsInRange';
  activity: ActivityStatsInRange;
  transactions: TransactionStatsInRange;
  users: UserStatsInRange;
};

export type DataPoint = {
  __typename?: 'DataPoint';
  actualDateString: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Decimal']['output'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type Document = {
  __typename?: 'Document';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['Byte']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  encodedData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentCountAggregate = {
  __typename?: 'DocumentCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mimeType: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DocumentMaxAggregate = {
  __typename?: 'DocumentMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['Byte']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentMinAggregate = {
  __typename?: 'DocumentMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['Byte']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentUncheckedUpdateInput = {
  data?: InputMaybe<Scalars['Byte']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentWhereInput = {
  AND?: InputMaybe<Array<DocumentWhereInput>>;
  NOT?: InputMaybe<Array<DocumentWhereInput>>;
  OR?: InputMaybe<Array<DocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<BytesFilter>;
  id?: InputMaybe<StringFilter>;
  mimeType?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentWhereInput>>;
  NOT?: InputMaybe<Array<DocumentWhereInput>>;
  OR?: InputMaybe<Array<DocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<BytesFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnumAccountStatusFilter = {
  equals?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  not?: InputMaybe<NestedEnumAccountStatusFilter>;
  notIn?: InputMaybe<Array<AccountStatus>>;
};

export type EnumAccountTypeFilter = {
  equals?: InputMaybe<AccountType>;
  in?: InputMaybe<Array<AccountType>>;
  not?: InputMaybe<NestedEnumAccountTypeFilter>;
  notIn?: InputMaybe<Array<AccountType>>;
};

export type EnumActionStatusFilter = {
  equals?: InputMaybe<ActionStatus>;
  in?: InputMaybe<Array<ActionStatus>>;
  not?: InputMaybe<NestedEnumActionStatusFilter>;
  notIn?: InputMaybe<Array<ActionStatus>>;
};

export type EnumAdminUserStatusFilter = {
  equals?: InputMaybe<AdminUserStatus>;
  in?: InputMaybe<Array<AdminUserStatus>>;
  not?: InputMaybe<NestedEnumAdminUserStatusFilter>;
  notIn?: InputMaybe<Array<AdminUserStatus>>;
};

export type EnumAnnouncementStatusFilter = {
  equals?: InputMaybe<AnnouncementStatus>;
  in?: InputMaybe<Array<AnnouncementStatus>>;
  not?: InputMaybe<NestedEnumAnnouncementStatusFilter>;
  notIn?: InputMaybe<Array<AnnouncementStatus>>;
};

export type EnumApprovalStatusFilter = {
  equals?: InputMaybe<ApprovalStatus>;
  in?: InputMaybe<Array<ApprovalStatus>>;
  not?: InputMaybe<NestedEnumApprovalStatusFilter>;
  notIn?: InputMaybe<Array<ApprovalStatus>>;
};

export type EnumAuthorisedSignatoryStatusFilter = {
  equals?: InputMaybe<AuthorisedSignatoryStatus>;
  in?: InputMaybe<Array<AuthorisedSignatoryStatus>>;
  not?: InputMaybe<NestedEnumAuthorisedSignatoryStatusFilter>;
  notIn?: InputMaybe<Array<AuthorisedSignatoryStatus>>;
};

export type EnumBankAccountTypeNullableFilter = {
  equals?: InputMaybe<BankAccountType>;
  in?: InputMaybe<Array<BankAccountType>>;
  not?: InputMaybe<NestedEnumBankAccountTypeNullableFilter>;
  notIn?: InputMaybe<Array<BankAccountType>>;
};

export type EnumBankTypeNullableFilter = {
  equals?: InputMaybe<BankType>;
  in?: InputMaybe<Array<BankType>>;
  not?: InputMaybe<NestedEnumBankTypeNullableFilter>;
  notIn?: InputMaybe<Array<BankType>>;
};

export type EnumConsentStatusFilter = {
  equals?: InputMaybe<ConsentStatus>;
  in?: InputMaybe<Array<ConsentStatus>>;
  not?: InputMaybe<NestedEnumConsentStatusFilter>;
  notIn?: InputMaybe<Array<ConsentStatus>>;
};

export type EnumConsentTypeFilter = {
  equals?: InputMaybe<ConsentType>;
  in?: InputMaybe<Array<ConsentType>>;
  not?: InputMaybe<NestedEnumConsentTypeFilter>;
  notIn?: InputMaybe<Array<ConsentType>>;
};

export type EnumCreationStatusFilter = {
  equals?: InputMaybe<CreationStatus>;
  in?: InputMaybe<Array<CreationStatus>>;
  not?: InputMaybe<NestedEnumCreationStatusFilter>;
  notIn?: InputMaybe<Array<CreationStatus>>;
};

export type EnumFundCategoriesFilter = {
  equals?: InputMaybe<FundCategories>;
  in?: InputMaybe<Array<FundCategories>>;
  not?: InputMaybe<NestedEnumFundCategoriesFilter>;
  notIn?: InputMaybe<Array<FundCategories>>;
};

export type EnumFundManagersNullableFilter = {
  equals?: InputMaybe<FundManagers>;
  in?: InputMaybe<Array<FundManagers>>;
  not?: InputMaybe<NestedEnumFundManagersNullableFilter>;
  notIn?: InputMaybe<Array<FundManagers>>;
};

export type EnumFundRiskProfileFilter = {
  equals?: InputMaybe<FundRiskProfile>;
  in?: InputMaybe<Array<FundRiskProfile>>;
  not?: InputMaybe<NestedEnumFundRiskProfileFilter>;
  notIn?: InputMaybe<Array<FundRiskProfile>>;
};

export type EnumFundStatusFilter = {
  equals?: InputMaybe<FundStatus>;
  in?: InputMaybe<Array<FundStatus>>;
  not?: InputMaybe<NestedEnumFundStatusFilter>;
  notIn?: InputMaybe<Array<FundStatus>>;
};

export type EnumIdTypeFilter = {
  equals?: InputMaybe<IdType>;
  in?: InputMaybe<Array<IdType>>;
  not?: InputMaybe<NestedEnumIdTypeFilter>;
  notIn?: InputMaybe<Array<IdType>>;
};

export type EnumInterfaceFilter = {
  equals?: InputMaybe<Interface>;
  in?: InputMaybe<Array<Interface>>;
  not?: InputMaybe<NestedEnumInterfaceFilter>;
  notIn?: InputMaybe<Array<Interface>>;
};

export type EnumModeOfContactNullableFilter = {
  equals?: InputMaybe<ModeOfContact>;
  in?: InputMaybe<Array<ModeOfContact>>;
  not?: InputMaybe<NestedEnumModeOfContactNullableFilter>;
  notIn?: InputMaybe<Array<ModeOfContact>>;
};

export type EnumModificationEntityTypeFilter = {
  equals?: InputMaybe<ModificationEntityType>;
  in?: InputMaybe<Array<ModificationEntityType>>;
  not?: InputMaybe<NestedEnumModificationEntityTypeFilter>;
  notIn?: InputMaybe<Array<ModificationEntityType>>;
};

export type EnumModificationStatusFilter = {
  equals?: InputMaybe<ModificationStatus>;
  in?: InputMaybe<Array<ModificationStatus>>;
  not?: InputMaybe<NestedEnumModificationStatusFilter>;
  notIn?: InputMaybe<Array<ModificationStatus>>;
};

export type EnumModificationTypeFilter = {
  equals?: InputMaybe<ModificationType>;
  in?: InputMaybe<Array<ModificationType>>;
  not?: InputMaybe<NestedEnumModificationTypeFilter>;
  notIn?: InputMaybe<Array<ModificationType>>;
};

export type EnumOrderDocumentStatusFilter = {
  equals?: InputMaybe<OrderDocumentStatus>;
  in?: InputMaybe<Array<OrderDocumentStatus>>;
  not?: InputMaybe<NestedEnumOrderDocumentStatusFilter>;
  notIn?: InputMaybe<Array<OrderDocumentStatus>>;
};

export type EnumOrderDocumentTypeFilter = {
  equals?: InputMaybe<OrderDocumentType>;
  in?: InputMaybe<Array<OrderDocumentType>>;
  not?: InputMaybe<NestedEnumOrderDocumentTypeFilter>;
  notIn?: InputMaybe<Array<OrderDocumentType>>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumOtpFlowFilter = {
  equals?: InputMaybe<OtpFlow>;
  in?: InputMaybe<Array<OtpFlow>>;
  not?: InputMaybe<NestedEnumOtpFlowFilter>;
  notIn?: InputMaybe<Array<OtpFlow>>;
};

export type EnumOtpMethodFilter = {
  equals?: InputMaybe<OtpMethod>;
  in?: InputMaybe<Array<OtpMethod>>;
  not?: InputMaybe<NestedEnumOtpMethodFilter>;
  notIn?: InputMaybe<Array<OtpMethod>>;
};

export type EnumOtpPurposeFilter = {
  equals?: InputMaybe<OtpPurpose>;
  in?: InputMaybe<Array<OtpPurpose>>;
  not?: InputMaybe<NestedEnumOtpPurposeFilter>;
  notIn?: InputMaybe<Array<OtpPurpose>>;
};

export type EnumPaymentMethodFilter = {
  equals?: InputMaybe<PaymentMethod>;
  in?: InputMaybe<Array<PaymentMethod>>;
  not?: InputMaybe<NestedEnumPaymentMethodFilter>;
  notIn?: InputMaybe<Array<PaymentMethod>>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumProfileStatusFilter = {
  equals?: InputMaybe<ProfileStatus>;
  in?: InputMaybe<Array<ProfileStatus>>;
  not?: InputMaybe<NestedEnumProfileStatusFilter>;
  notIn?: InputMaybe<Array<ProfileStatus>>;
};

export type EnumRedemptionExtentNullableFilter = {
  equals?: InputMaybe<RedemptionExtent>;
  in?: InputMaybe<Array<RedemptionExtent>>;
  not?: InputMaybe<NestedEnumRedemptionExtentNullableFilter>;
  notIn?: InputMaybe<Array<RedemptionExtent>>;
};

export type EnumRiskProfilesNullableFilter = {
  equals?: InputMaybe<RiskProfiles>;
  in?: InputMaybe<Array<RiskProfiles>>;
  not?: InputMaybe<NestedEnumRiskProfilesNullableFilter>;
  notIn?: InputMaybe<Array<RiskProfiles>>;
};

export type EnumSignatoryProviderFilter = {
  equals?: InputMaybe<SignatoryProvider>;
  in?: InputMaybe<Array<SignatoryProvider>>;
  not?: InputMaybe<NestedEnumSignatoryProviderFilter>;
  notIn?: InputMaybe<Array<SignatoryProvider>>;
};

export type EnumSignatoryStatusFilter = {
  equals?: InputMaybe<SignatoryStatus>;
  in?: InputMaybe<Array<SignatoryStatus>>;
  not?: InputMaybe<NestedEnumSignatoryStatusFilter>;
  notIn?: InputMaybe<Array<SignatoryStatus>>;
};

export type EnumStatementDocumentLocationNullableFilter = {
  equals?: InputMaybe<StatementDocumentLocation>;
  in?: InputMaybe<Array<StatementDocumentLocation>>;
  not?: InputMaybe<NestedEnumStatementDocumentLocationNullableFilter>;
  notIn?: InputMaybe<Array<StatementDocumentLocation>>;
};

export type EnumStatementSourceFilter = {
  equals?: InputMaybe<StatementSource>;
  in?: InputMaybe<Array<StatementSource>>;
  not?: InputMaybe<NestedEnumStatementSourceFilter>;
  notIn?: InputMaybe<Array<StatementSource>>;
};

export type EnumStatementStatusFilter = {
  equals?: InputMaybe<StatementStatus>;
  in?: InputMaybe<Array<StatementStatus>>;
  not?: InputMaybe<NestedEnumStatementStatusFilter>;
  notIn?: InputMaybe<Array<StatementStatus>>;
};

export type EnumStatementSubTypeFilter = {
  equals?: InputMaybe<StatementSubType>;
  in?: InputMaybe<Array<StatementSubType>>;
  not?: InputMaybe<NestedEnumStatementSubTypeFilter>;
  notIn?: InputMaybe<Array<StatementSubType>>;
};

export type EnumStatementTypeFilter = {
  equals?: InputMaybe<StatementType>;
  in?: InputMaybe<Array<StatementType>>;
  not?: InputMaybe<NestedEnumStatementTypeFilter>;
  notIn?: InputMaybe<Array<StatementType>>;
};

export type EnumTomswinSyncBatchStatusFilter = {
  equals?: InputMaybe<TomswinSyncBatchStatus>;
  in?: InputMaybe<Array<TomswinSyncBatchStatus>>;
  not?: InputMaybe<NestedEnumTomswinSyncBatchStatusFilter>;
  notIn?: InputMaybe<Array<TomswinSyncBatchStatus>>;
};

export type EnumTomswinSyncStatusFilter = {
  equals?: InputMaybe<TomswinSyncStatus>;
  in?: InputMaybe<Array<TomswinSyncStatus>>;
  not?: InputMaybe<NestedEnumTomswinSyncStatusFilter>;
  notIn?: InputMaybe<Array<TomswinSyncStatus>>;
};

export type EnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumTransactionTypeFilter = {
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  not?: InputMaybe<NestedEnumTransactionTypeFilter>;
  notIn?: InputMaybe<Array<TransactionType>>;
};

export type EnumUserStatusFilter = {
  equals?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  not?: InputMaybe<NestedEnumUserStatusFilter>;
  notIn?: InputMaybe<Array<UserStatus>>;
};

export type EnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<UserType>>;
};

export type EnvelopeStatus = {
  __typename?: 'EnvelopeStatus';
  created: Scalars['String']['output'];
  lastModified: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Faq = {
  __typename?: 'Faq';
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  subCategories: Array<SubCategory>;
  title: Scalars['String']['output'];
};

export type Fund = {
  __typename?: 'Fund';
  _count?: Maybe<FundCount>;
  accountPortfolios: Array<AccountPortfolio>;
  annualExpenseRatio: Scalars['Decimal']['output'];
  annualExpenseRatioDate?: Maybe<Scalars['DateTime']['output']>;
  annualManagementFeeDisplay?: Maybe<Scalars['String']['output']>;
  annualisedReturns?: Maybe<Array<AnnualisedReturn>>;
  assetAllocation: Scalars['String']['output'];
  benchmark: Scalars['String']['output'];
  calendarYearReturns?: Maybe<Array<CalendarYearReturn>>;
  category: FundCategories;
  classes?: Maybe<Scalars['String']['output']>;
  collectionBankAccount?: Maybe<CollectionBankAccount>;
  collectionBankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionPolicy: Scalars['String']['output'];
  esgFlag: Scalars['Boolean']['output'];
  financialYearEnd: Scalars['String']['output'];
  fundCode: Scalars['String']['output'];
  fundDocuments: Array<FundDocument>;
  fundFocusFlag: Scalars['Boolean']['output'];
  fundManager?: Maybe<FundManager>;
  fundManagerCode?: Maybe<Scalars['String']['output']>;
  fundName: Scalars['String']['output'];
  fundPerformance?: Maybe<FundPerformance>;
  fundPolicy?: Maybe<FundPolicy>;
  fundPrices: Array<FundPrice>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['output'];
  fundSizeCurrency: Scalars['String']['output'];
  fundSizeDate?: Maybe<Scalars['DateTime']['output']>;
  fundStatus: Scalars['String']['output'];
  holidays: Array<FundHoliday>;
  id: Scalars['ID']['output'];
  investmentObj: Scalars['String']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  launchDate?: Maybe<Scalars['DateTime']['output']>;
  launchPrice: Scalars['Decimal']['output'];
  lipperMyClass: Scalars['String']['output'];
  localFlag: Scalars['Boolean']['output'];
  manager?: Maybe<FundManagers>;
  managerName?: Maybe<Scalars['String']['output']>;
  mtdPerformance?: Maybe<FundYieldPerformance>;
  navPrice?: Maybe<FundNavPrice>;
  performances?: Maybe<FundPerformanceChart>;
  pricingBasic: Scalars['String']['output'];
  rm1FundIndicator: Scalars['Boolean']['output'];
  salesChargeDisplay?: Maybe<Scalars['String']['output']>;
  shariahFlag: Scalars['Boolean']['output'];
  status: FundStatus;
  switchFee: Scalars['Decimal']['output'];
  switchToTransactions: Array<Transaction>;
  switchingFeeDisplay?: Maybe<Scalars['String']['output']>;
  totalUnitInCirculation: Scalars['Int']['output'];
  totalUnitInCirculationDate?: Maybe<Scalars['DateTime']['output']>;
  transactionProcessFlow?: Maybe<TransactionProcessFlow>;
  transactions: Array<Transaction>;
  trustee?: Maybe<Trustee>;
  trusteeFeeDisplay?: Maybe<Scalars['String']['output']>;
  trusteeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  ytdPerformance?: Maybe<FundYieldPerformance>;
};


export type FundAccountPortfoliosArgs = {
  cursor?: InputMaybe<AccountPortfolioWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccountPortfolioScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccountPortfolioOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type FundCollectionBankAccountArgs = {
  where?: InputMaybe<CollectionBankAccountWhereInput>;
};


export type FundFundDocumentsArgs = {
  cursor?: InputMaybe<FundDocumentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundDocumentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundDocumentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundDocumentWhereInput>;
};


export type FundFundManagerArgs = {
  where?: InputMaybe<FundManagerWhereInput>;
};


export type FundFundPerformanceArgs = {
  where?: InputMaybe<FundPerformanceWhereInput>;
};


export type FundFundPolicyArgs = {
  where?: InputMaybe<FundPolicyWhereInput>;
};


export type FundFundPricesArgs = {
  cursor?: InputMaybe<FundPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundPriceWhereInput>;
};


export type FundHolidaysArgs = {
  cursor?: InputMaybe<FundHolidayWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundHolidayScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundHolidayOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundHolidayWhereInput>;
};


export type FundSwitchToTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type FundTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type FundTrusteeArgs = {
  where?: InputMaybe<TrusteeWhereInput>;
};

export type FundAccountBalance = {
  __typename?: 'FundAccountBalance';
  fundAccountNo: Scalars['String']['output'];
  unitBalance: Scalars['String']['output'];
};

export type FundAvgAggregate = {
  __typename?: 'FundAvgAggregate';
  annualExpenseRatio?: Maybe<Scalars['Decimal']['output']>;
  fundSize?: Maybe<Scalars['Float']['output']>;
  launchPrice?: Maybe<Scalars['Decimal']['output']>;
  switchFee?: Maybe<Scalars['Decimal']['output']>;
  totalUnitInCirculation?: Maybe<Scalars['Float']['output']>;
};

export enum FundCategories {
  Commodities = 'commodities',
  Equity = 'equity',
  Etf = 'etf',
  FixedIncome = 'fixed_income',
  MixedAssets = 'mixed_assets',
  MoneyMarket = 'money_market',
  Prs = 'prs',
  Unknown = 'unknown'
}

export type FundCategory = {
  __typename?: 'FundCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FundCategorySummary = {
  __typename?: 'FundCategorySummary';
  fundCategory: Scalars['String']['output'];
  values: Array<AmountValue>;
};

export type FundCount = {
  __typename?: 'FundCount';
  accountPortfolios: Scalars['Int']['output'];
  fundDocuments: Scalars['Int']['output'];
  fundPrices: Scalars['Int']['output'];
  holidays: Scalars['Int']['output'];
  switchToTransactions: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
};

export type FundCountAggregate = {
  __typename?: 'FundCountAggregate';
  _all: Scalars['Int']['output'];
  annualExpenseRatio: Scalars['Int']['output'];
  annualExpenseRatioDate: Scalars['Int']['output'];
  annualManagementFeeDisplay: Scalars['Int']['output'];
  assetAllocation: Scalars['Int']['output'];
  benchmark: Scalars['Int']['output'];
  category: Scalars['Int']['output'];
  classes: Scalars['Int']['output'];
  collectionBankAccountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  distributionPolicy: Scalars['Int']['output'];
  esgFlag: Scalars['Int']['output'];
  financialYearEnd: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  fundFocusFlag: Scalars['Int']['output'];
  fundManagerCode: Scalars['Int']['output'];
  fundName: Scalars['Int']['output'];
  fundRiskProfile: Scalars['Int']['output'];
  fundSize: Scalars['Int']['output'];
  fundSizeCurrency: Scalars['Int']['output'];
  fundSizeDate: Scalars['Int']['output'];
  fundStatus: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentObj: Scalars['Int']['output'];
  isin: Scalars['Int']['output'];
  launchDate: Scalars['Int']['output'];
  launchPrice: Scalars['Int']['output'];
  lipperMyClass: Scalars['Int']['output'];
  localFlag: Scalars['Int']['output'];
  manager: Scalars['Int']['output'];
  pricingBasic: Scalars['Int']['output'];
  rm1FundIndicator: Scalars['Int']['output'];
  salesChargeDisplay: Scalars['Int']['output'];
  shariahFlag: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  switchFee: Scalars['Int']['output'];
  switchingFeeDisplay: Scalars['Int']['output'];
  totalUnitInCirculation: Scalars['Int']['output'];
  totalUnitInCirculationDate: Scalars['Int']['output'];
  trusteeFeeDisplay: Scalars['Int']['output'];
  trusteeId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FundCreateManyCollectionBankAccountInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundCreateManyCollectionBankAccountInputEnvelope = {
  data: Array<FundCreateManyCollectionBankAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundCreateManyTrusteeInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundCreateManyTrusteeInputEnvelope = {
  data: Array<FundCreateManyTrusteeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundCreateNestedOneWithoutAccountPortfoliosInput = {
  connect?: InputMaybe<FundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundCreateOrConnectWithoutAccountPortfoliosInput>;
  create?: InputMaybe<FundUncheckedCreateWithoutAccountPortfoliosInput>;
};

export type FundCreateNestedOneWithoutSwitchToTransactionsInput = {
  connect?: InputMaybe<FundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundCreateOrConnectWithoutSwitchToTransactionsInput>;
  create?: InputMaybe<FundUncheckedCreateWithoutSwitchToTransactionsInput>;
};

export type FundCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<FundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<FundUncheckedCreateWithoutTransactionsInput>;
};

export type FundCreateOrConnectWithoutAccountPortfoliosInput = {
  create: FundUncheckedCreateWithoutAccountPortfoliosInput;
  where: FundWhereUniqueInput;
};

export type FundCreateOrConnectWithoutCollectionBankAccountInput = {
  create: FundUncheckedCreateWithoutCollectionBankAccountInput;
  where: FundWhereUniqueInput;
};

export type FundCreateOrConnectWithoutSwitchToTransactionsInput = {
  create: FundUncheckedCreateWithoutSwitchToTransactionsInput;
  where: FundWhereUniqueInput;
};

export type FundCreateOrConnectWithoutTransactionsInput = {
  create: FundUncheckedCreateWithoutTransactionsInput;
  where: FundWhereUniqueInput;
};

export type FundCreateOrConnectWithoutTrusteeInput = {
  create: FundUncheckedCreateWithoutTrusteeInput;
  where: FundWhereUniqueInput;
};

export type FundCreateWithoutCollectionBankAccountInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManager?: InputMaybe<FundManagerCreateNestedOneWithoutFundsInput>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trustee?: InputMaybe<TrusteeCreateNestedOneWithoutFundsInput>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundCreateWithoutTrusteeInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountCreateNestedOneWithoutFundsInput>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManager?: InputMaybe<FundManagerCreateNestedOneWithoutFundsInput>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocument = {
  __typename?: 'FundDocument';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  documentLink: Scalars['String']['output'];
  fund: Fund;
  fundCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FundDocumentCountAggregate = {
  __typename?: 'FundDocumentCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  displayName: Scalars['Int']['output'];
  documentLink: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FundDocumentCreateManyFundInput = {
  displayName: Scalars['String']['input'];
  documentLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentCreateManyFundInputEnvelope = {
  data: Array<FundDocumentCreateManyFundInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundDocumentCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundDocumentCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundDocumentCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundDocumentCreateManyFundInputEnvelope>;
};

export type FundDocumentCreateOrConnectWithoutFundInput = {
  create: FundDocumentUncheckedCreateWithoutFundInput;
  where: FundDocumentWhereUniqueInput;
};

export type FundDocumentCreateWithoutFundInput = {
  displayName: Scalars['String']['input'];
  documentLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentFundCodeDisplayNameCompoundUniqueInput = {
  displayName: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
};

export type FundDocumentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentListRelationFilter = {
  every?: InputMaybe<FundDocumentWhereInput>;
  none?: InputMaybe<FundDocumentWhereInput>;
  some?: InputMaybe<FundDocumentWhereInput>;
};

export type FundDocumentMaxAggregate = {
  __typename?: 'FundDocumentMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentLink?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundDocumentMinAggregate = {
  __typename?: 'FundDocumentMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentLink?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundDocumentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FundDocumentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  documentLink?: InputMaybe<SortOrder>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FundDocumentScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DisplayName = 'displayName',
  DocumentLink = 'documentLink',
  FundCode = 'fundCode',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type FundDocumentScalarWhereInput = {
  AND?: InputMaybe<Array<FundDocumentScalarWhereInput>>;
  NOT?: InputMaybe<Array<FundDocumentScalarWhereInput>>;
  OR?: InputMaybe<Array<FundDocumentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLink?: InputMaybe<StringFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundDocumentUncheckedCreateInput = {
  displayName: Scalars['String']['input'];
  documentLink: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentUncheckedCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundDocumentCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundDocumentCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundDocumentCreateManyFundInputEnvelope>;
};

export type FundDocumentUncheckedCreateWithoutFundInput = {
  displayName: Scalars['String']['input'];
  documentLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentUncheckedUpdateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLink?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentUncheckedUpdateManyWithoutFundInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentUncheckedUpdateManyWithoutFundNestedInput = {
  connect?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundDocumentCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundDocumentCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundDocumentCreateManyFundInputEnvelope>;
  delete?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FundDocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<FundDocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<FundDocumentUpdateWithWhereUniqueWithoutFundInput>>;
  updateMany?: InputMaybe<Array<FundDocumentUpdateManyWithWhereWithoutFundInput>>;
  upsert?: InputMaybe<Array<FundDocumentUpsertWithWhereUniqueWithoutFundInput>>;
};

export type FundDocumentUncheckedUpdateWithoutFundInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FundDocumentUpdateManyWithWhereWithoutFundInput = {
  data: FundDocumentUncheckedUpdateManyWithoutFundInput;
  where: FundDocumentScalarWhereInput;
};

export type FundDocumentUpdateWithWhereUniqueWithoutFundInput = {
  data: FundDocumentUncheckedUpdateWithoutFundInput;
  where: FundDocumentWhereUniqueInput;
};

export type FundDocumentUpsertWithWhereUniqueWithoutFundInput = {
  create: FundDocumentUncheckedCreateWithoutFundInput;
  update: FundDocumentUncheckedUpdateWithoutFundInput;
  where: FundDocumentWhereUniqueInput;
};

export type FundDocumentWhereInput = {
  AND?: InputMaybe<Array<FundDocumentWhereInput>>;
  NOT?: InputMaybe<Array<FundDocumentWhereInput>>;
  OR?: InputMaybe<Array<FundDocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLink?: InputMaybe<StringFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundDocumentWhereUniqueInput = {
  AND?: InputMaybe<Array<FundDocumentWhereInput>>;
  NOT?: InputMaybe<Array<FundDocumentWhereInput>>;
  OR?: InputMaybe<Array<FundDocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLink?: InputMaybe<StringFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  fundCode_displayName?: InputMaybe<FundDocumentFundCodeDisplayNameCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundHoliday = {
  __typename?: 'FundHoliday';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  fund?: Maybe<Fund>;
  fundId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type FundHolidayFundArgs = {
  where?: InputMaybe<FundWhereInput>;
};

export type FundHolidayCountAggregate = {
  __typename?: 'FundHolidayCountAggregate';
  _all: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  fundId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  remarks: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FundHolidayCreateManyFundInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FundHolidayCreateManyFundInputEnvelope = {
  data: Array<FundHolidayCreateManyFundInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundHolidayCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundHolidayCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundHolidayCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundHolidayCreateManyFundInputEnvelope>;
};

export type FundHolidayCreateOrConnectWithoutFundInput = {
  create: FundHolidayUncheckedCreateWithoutFundInput;
  where: FundHolidayWhereUniqueInput;
};

export type FundHolidayCreateWithoutFundInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FundHolidayListRelationFilter = {
  every?: InputMaybe<FundHolidayWhereInput>;
  none?: InputMaybe<FundHolidayWhereInput>;
  some?: InputMaybe<FundHolidayWhereInput>;
};

export type FundHolidayMaxAggregate = {
  __typename?: 'FundHolidayMaxAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fundId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundHolidayMinAggregate = {
  __typename?: 'FundHolidayMinAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fundId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundHolidayOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FundHolidayOrderByWithRelationInput = {
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  remarks?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FundHolidayScalarFieldEnum {
  Country = 'country',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  EndDate = 'endDate',
  FundId = 'fundId',
  Id = 'id',
  Remarks = 'remarks',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type FundHolidayScalarWhereInput = {
  AND?: InputMaybe<Array<FundHolidayScalarWhereInput>>;
  NOT?: InputMaybe<Array<FundHolidayScalarWhereInput>>;
  OR?: InputMaybe<Array<FundHolidayScalarWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  fundId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundHolidayUncheckedCreateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate: Scalars['DateTime']['input'];
  fundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FundHolidayUncheckedCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundHolidayCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundHolidayCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundHolidayCreateManyFundInputEnvelope>;
};

export type FundHolidayUncheckedCreateWithoutFundInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FundHolidayUncheckedUpdateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FundHolidayUncheckedUpdateManyWithoutFundInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FundHolidayUncheckedUpdateManyWithoutFundNestedInput = {
  connect?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundHolidayCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundHolidayCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundHolidayCreateManyFundInputEnvelope>;
  delete?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FundHolidayScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  set?: InputMaybe<Array<FundHolidayWhereUniqueInput>>;
  update?: InputMaybe<Array<FundHolidayUpdateWithWhereUniqueWithoutFundInput>>;
  updateMany?: InputMaybe<Array<FundHolidayUpdateManyWithWhereWithoutFundInput>>;
  upsert?: InputMaybe<Array<FundHolidayUpsertWithWhereUniqueWithoutFundInput>>;
};

export type FundHolidayUncheckedUpdateWithoutFundInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FundHolidayUpdateManyWithWhereWithoutFundInput = {
  data: FundHolidayUncheckedUpdateManyWithoutFundInput;
  where: FundHolidayScalarWhereInput;
};

export type FundHolidayUpdateWithWhereUniqueWithoutFundInput = {
  data: FundHolidayUncheckedUpdateWithoutFundInput;
  where: FundHolidayWhereUniqueInput;
};

export type FundHolidayUpsertWithWhereUniqueWithoutFundInput = {
  create: FundHolidayUncheckedCreateWithoutFundInput;
  update: FundHolidayUncheckedUpdateWithoutFundInput;
  where: FundHolidayWhereUniqueInput;
};

export type FundHolidayWhereInput = {
  AND?: InputMaybe<Array<FundHolidayWhereInput>>;
  NOT?: InputMaybe<Array<FundHolidayWhereInput>>;
  OR?: InputMaybe<Array<FundHolidayWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  fund?: InputMaybe<FundNullableRelationFilter>;
  fundId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundHolidayWhereUniqueInput = {
  AND?: InputMaybe<Array<FundHolidayWhereInput>>;
  NOT?: InputMaybe<Array<FundHolidayWhereInput>>;
  OR?: InputMaybe<Array<FundHolidayWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  fund?: InputMaybe<FundNullableRelationFilter>;
  fundId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundListRelationFilter = {
  every?: InputMaybe<FundWhereInput>;
  none?: InputMaybe<FundWhereInput>;
  some?: InputMaybe<FundWhereInput>;
};

export type FundManager = {
  __typename?: 'FundManager';
  _count?: Maybe<FundManagerCount>;
  address?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  funds: Array<Fund>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type FundManagerFundsArgs = {
  cursor?: InputMaybe<FundWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundWhereInput>;
};

export type FundManagerCount = {
  __typename?: 'FundManagerCount';
  funds: Scalars['Int']['output'];
};

export type FundManagerCountAggregate = {
  __typename?: 'FundManagerCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  faxNo: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  phoneNo: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FundManagerCreateNestedOneWithoutFundsInput = {
  connect?: InputMaybe<FundManagerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundManagerCreateOrConnectWithoutFundsInput>;
  create?: InputMaybe<FundManagerUncheckedCreateWithoutFundsInput>;
};

export type FundManagerCreateOrConnectWithoutFundsInput = {
  create: FundManagerUncheckedCreateWithoutFundsInput;
  where: FundManagerWhereUniqueInput;
};

export type FundManagerMaxAggregate = {
  __typename?: 'FundManagerMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundManagerMinAggregate = {
  __typename?: 'FundManagerMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundManagerNullableRelationFilter = {
  is?: InputMaybe<FundManagerWhereInput>;
  isNot?: InputMaybe<FundManagerWhereInput>;
};

export type FundManagerOrderByWithRelationInput = {
  address?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  faxNo?: InputMaybe<SortOrderInput>;
  funds?: InputMaybe<FundOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNo?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FundManagerUncheckedCreateWithoutFundsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  faxNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

export type FundManagerWhereInput = {
  AND?: InputMaybe<Array<FundManagerWhereInput>>;
  NOT?: InputMaybe<Array<FundManagerWhereInput>>;
  OR?: InputMaybe<Array<FundManagerWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundManagerWhereUniqueInput = {
  AND?: InputMaybe<Array<FundManagerWhereInput>>;
  NOT?: InputMaybe<Array<FundManagerWhereInput>>;
  OR?: InputMaybe<Array<FundManagerWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  phoneNo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum FundManagers {
  Afm = 'AFM',
  Aifm = 'AIFM'
}

export type FundMaxAggregate = {
  __typename?: 'FundMaxAggregate';
  annualExpenseRatio?: Maybe<Scalars['Decimal']['output']>;
  annualExpenseRatioDate?: Maybe<Scalars['DateTime']['output']>;
  annualManagementFeeDisplay?: Maybe<Scalars['String']['output']>;
  assetAllocation?: Maybe<Scalars['String']['output']>;
  benchmark?: Maybe<Scalars['String']['output']>;
  category?: Maybe<FundCategories>;
  classes?: Maybe<Scalars['String']['output']>;
  collectionBankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionPolicy?: Maybe<Scalars['String']['output']>;
  esgFlag?: Maybe<Scalars['Boolean']['output']>;
  financialYearEnd?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  fundFocusFlag?: Maybe<Scalars['Boolean']['output']>;
  fundManagerCode?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  fundRiskProfile?: Maybe<FundRiskProfile>;
  fundSize?: Maybe<Scalars['Int']['output']>;
  fundSizeCurrency?: Maybe<Scalars['String']['output']>;
  fundSizeDate?: Maybe<Scalars['DateTime']['output']>;
  fundStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  investmentObj?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  launchDate?: Maybe<Scalars['DateTime']['output']>;
  launchPrice?: Maybe<Scalars['Decimal']['output']>;
  lipperMyClass?: Maybe<Scalars['String']['output']>;
  localFlag?: Maybe<Scalars['Boolean']['output']>;
  manager?: Maybe<FundManagers>;
  pricingBasic?: Maybe<Scalars['String']['output']>;
  rm1FundIndicator?: Maybe<Scalars['Boolean']['output']>;
  salesChargeDisplay?: Maybe<Scalars['String']['output']>;
  shariahFlag?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FundStatus>;
  switchFee?: Maybe<Scalars['Decimal']['output']>;
  switchingFeeDisplay?: Maybe<Scalars['String']['output']>;
  totalUnitInCirculation?: Maybe<Scalars['Int']['output']>;
  totalUnitInCirculationDate?: Maybe<Scalars['DateTime']['output']>;
  trusteeFeeDisplay?: Maybe<Scalars['String']['output']>;
  trusteeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundMinAggregate = {
  __typename?: 'FundMinAggregate';
  annualExpenseRatio?: Maybe<Scalars['Decimal']['output']>;
  annualExpenseRatioDate?: Maybe<Scalars['DateTime']['output']>;
  annualManagementFeeDisplay?: Maybe<Scalars['String']['output']>;
  assetAllocation?: Maybe<Scalars['String']['output']>;
  benchmark?: Maybe<Scalars['String']['output']>;
  category?: Maybe<FundCategories>;
  classes?: Maybe<Scalars['String']['output']>;
  collectionBankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributionPolicy?: Maybe<Scalars['String']['output']>;
  esgFlag?: Maybe<Scalars['Boolean']['output']>;
  financialYearEnd?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  fundFocusFlag?: Maybe<Scalars['Boolean']['output']>;
  fundManagerCode?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  fundRiskProfile?: Maybe<FundRiskProfile>;
  fundSize?: Maybe<Scalars['Int']['output']>;
  fundSizeCurrency?: Maybe<Scalars['String']['output']>;
  fundSizeDate?: Maybe<Scalars['DateTime']['output']>;
  fundStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  investmentObj?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  launchDate?: Maybe<Scalars['DateTime']['output']>;
  launchPrice?: Maybe<Scalars['Decimal']['output']>;
  lipperMyClass?: Maybe<Scalars['String']['output']>;
  localFlag?: Maybe<Scalars['Boolean']['output']>;
  manager?: Maybe<FundManagers>;
  pricingBasic?: Maybe<Scalars['String']['output']>;
  rm1FundIndicator?: Maybe<Scalars['Boolean']['output']>;
  salesChargeDisplay?: Maybe<Scalars['String']['output']>;
  shariahFlag?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FundStatus>;
  switchFee?: Maybe<Scalars['Decimal']['output']>;
  switchingFeeDisplay?: Maybe<Scalars['String']['output']>;
  totalUnitInCirculation?: Maybe<Scalars['Int']['output']>;
  totalUnitInCirculationDate?: Maybe<Scalars['DateTime']['output']>;
  trusteeFeeDisplay?: Maybe<Scalars['String']['output']>;
  trusteeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundNavPrice = {
  __typename?: 'FundNavPrice';
  date: Scalars['DateTime']['output'];
  price: Scalars['Decimal']['output'];
};

export type FundNullableRelationFilter = {
  is?: InputMaybe<FundWhereInput>;
  isNot?: InputMaybe<FundWhereInput>;
};

export type FundOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FundOrderByWithRelationInput = {
  accountPortfolios?: InputMaybe<AccountPortfolioOrderByRelationAggregateInput>;
  annualExpenseRatio?: InputMaybe<SortOrder>;
  annualExpenseRatioDate?: InputMaybe<SortOrderInput>;
  annualManagementFeeDisplay?: InputMaybe<SortOrderInput>;
  assetAllocation?: InputMaybe<SortOrder>;
  benchmark?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  classes?: InputMaybe<SortOrderInput>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountOrderByWithRelationInput>;
  collectionBankAccountId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrderInput>;
  distributionPolicy?: InputMaybe<SortOrder>;
  esgFlag?: InputMaybe<SortOrder>;
  financialYearEnd?: InputMaybe<SortOrder>;
  fundCode?: InputMaybe<SortOrder>;
  fundDocuments?: InputMaybe<FundDocumentOrderByRelationAggregateInput>;
  fundFocusFlag?: InputMaybe<SortOrder>;
  fundManager?: InputMaybe<FundManagerOrderByWithRelationInput>;
  fundManagerCode?: InputMaybe<SortOrderInput>;
  fundName?: InputMaybe<SortOrder>;
  fundPerformance?: InputMaybe<FundPerformanceOrderByWithRelationInput>;
  fundPolicy?: InputMaybe<FundPolicyOrderByWithRelationInput>;
  fundPrices?: InputMaybe<FundPriceOrderByRelationAggregateInput>;
  fundRiskProfile?: InputMaybe<SortOrder>;
  fundSize?: InputMaybe<SortOrder>;
  fundSizeCurrency?: InputMaybe<SortOrder>;
  fundSizeDate?: InputMaybe<SortOrderInput>;
  fundStatus?: InputMaybe<SortOrder>;
  holidays?: InputMaybe<FundHolidayOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  investmentObj?: InputMaybe<SortOrder>;
  isin?: InputMaybe<SortOrderInput>;
  launchDate?: InputMaybe<SortOrderInput>;
  launchPrice?: InputMaybe<SortOrder>;
  lipperMyClass?: InputMaybe<SortOrder>;
  localFlag?: InputMaybe<SortOrder>;
  manager?: InputMaybe<SortOrderInput>;
  pricingBasic?: InputMaybe<SortOrder>;
  rm1FundIndicator?: InputMaybe<SortOrder>;
  salesChargeDisplay?: InputMaybe<SortOrderInput>;
  shariahFlag?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  switchFee?: InputMaybe<SortOrder>;
  switchToTransactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  switchingFeeDisplay?: InputMaybe<SortOrderInput>;
  totalUnitInCirculation?: InputMaybe<SortOrder>;
  totalUnitInCirculationDate?: InputMaybe<SortOrderInput>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  trustee?: InputMaybe<TrusteeOrderByWithRelationInput>;
  trusteeFeeDisplay?: InputMaybe<SortOrderInput>;
  trusteeId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FundPerformance = {
  __typename?: 'FundPerformance';
  createdAt: Scalars['DateTime']['output'];
  dailyReturnRate?: Maybe<Scalars['Decimal']['output']>;
  dailyReturnRateLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  fund: Fund;
  fundCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mtd?: Maybe<Scalars['Decimal']['output']>;
  mtdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  ytd?: Maybe<Scalars['Decimal']['output']>;
  ytdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type FundPerformanceAvgAggregate = {
  __typename?: 'FundPerformanceAvgAggregate';
  dailyReturnRate?: Maybe<Scalars['Decimal']['output']>;
  mtd?: Maybe<Scalars['Decimal']['output']>;
  ytd?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPerformanceChart = {
  __typename?: 'FundPerformanceChart';
  dataPoints: Array<DataPoint>;
  horizontalTitles: Array<HorizontalTitle>;
};

export type FundPerformanceCountAggregate = {
  __typename?: 'FundPerformanceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dailyReturnRate: Scalars['Int']['output'];
  dailyReturnRateLastUpdated: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mtd: Scalars['Int']['output'];
  mtdLastUpdated: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  ytd: Scalars['Int']['output'];
  ytdLastUpdated: Scalars['Int']['output'];
};

export type FundPerformanceCreateNestedOneWithoutFundInput = {
  connect?: InputMaybe<FundPerformanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPerformanceCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPerformanceUncheckedCreateWithoutFundInput>;
};

export type FundPerformanceCreateOrConnectWithoutFundInput = {
  create: FundPerformanceUncheckedCreateWithoutFundInput;
  where: FundPerformanceWhereUniqueInput;
};

export type FundPerformanceMaxAggregate = {
  __typename?: 'FundPerformanceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyReturnRate?: Maybe<Scalars['Decimal']['output']>;
  dailyReturnRateLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mtd?: Maybe<Scalars['Decimal']['output']>;
  mtdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  ytd?: Maybe<Scalars['Decimal']['output']>;
  ytdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type FundPerformanceMinAggregate = {
  __typename?: 'FundPerformanceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyReturnRate?: Maybe<Scalars['Decimal']['output']>;
  dailyReturnRateLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mtd?: Maybe<Scalars['Decimal']['output']>;
  mtdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  ytd?: Maybe<Scalars['Decimal']['output']>;
  ytdLastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type FundPerformanceNullableRelationFilter = {
  is?: InputMaybe<FundPerformanceWhereInput>;
  isNot?: InputMaybe<FundPerformanceWhereInput>;
};

export type FundPerformanceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  dailyReturnRate?: InputMaybe<SortOrderInput>;
  dailyReturnRateLastUpdated?: InputMaybe<SortOrderInput>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mtd?: InputMaybe<SortOrderInput>;
  mtdLastUpdated?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  ytd?: InputMaybe<SortOrderInput>;
  ytdLastUpdated?: InputMaybe<SortOrderInput>;
};

export type FundPerformanceSumAggregate = {
  __typename?: 'FundPerformanceSumAggregate';
  dailyReturnRate?: Maybe<Scalars['Decimal']['output']>;
  mtd?: Maybe<Scalars['Decimal']['output']>;
  ytd?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPerformanceUncheckedCreateNestedOneWithoutFundInput = {
  connect?: InputMaybe<FundPerformanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPerformanceCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPerformanceUncheckedCreateWithoutFundInput>;
};

export type FundPerformanceUncheckedCreateWithoutFundInput = {
  dailyReturnRate?: InputMaybe<Scalars['Decimal']['input']>;
  dailyReturnRateLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mtd?: InputMaybe<Scalars['Decimal']['input']>;
  mtdLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  ytd?: InputMaybe<Scalars['Decimal']['input']>;
  ytdLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FundPerformanceUncheckedUpdateOneWithoutFundNestedInput = {
  connect?: InputMaybe<FundPerformanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPerformanceCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPerformanceUncheckedCreateWithoutFundInput>;
  delete?: InputMaybe<FundPerformanceWhereInput>;
  disconnect?: InputMaybe<FundPerformanceWhereInput>;
  update?: InputMaybe<FundPerformanceUncheckedUpdateWithoutFundInput>;
  upsert?: InputMaybe<FundPerformanceUpsertWithoutFundInput>;
};

export type FundPerformanceUncheckedUpdateWithoutFundInput = {
  dailyReturnRate?: InputMaybe<Scalars['Decimal']['input']>;
  dailyReturnRateLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mtd?: InputMaybe<Scalars['Decimal']['input']>;
  mtdLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  ytd?: InputMaybe<Scalars['Decimal']['input']>;
  ytdLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FundPerformanceUpsertWithoutFundInput = {
  create: FundPerformanceUncheckedCreateWithoutFundInput;
  update: FundPerformanceUncheckedUpdateWithoutFundInput;
  where?: InputMaybe<FundPerformanceWhereInput>;
};

export type FundPerformanceWhereInput = {
  AND?: InputMaybe<Array<FundPerformanceWhereInput>>;
  NOT?: InputMaybe<Array<FundPerformanceWhereInput>>;
  OR?: InputMaybe<Array<FundPerformanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dailyReturnRate?: InputMaybe<DecimalNullableFilter>;
  dailyReturnRateLastUpdated?: InputMaybe<DateTimeNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  mtd?: InputMaybe<DecimalNullableFilter>;
  mtdLastUpdated?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  ytd?: InputMaybe<DecimalNullableFilter>;
  ytdLastUpdated?: InputMaybe<DateTimeNullableFilter>;
};

export type FundPerformanceWhereUniqueInput = {
  AND?: InputMaybe<Array<FundPerformanceWhereInput>>;
  NOT?: InputMaybe<Array<FundPerformanceWhereInput>>;
  OR?: InputMaybe<Array<FundPerformanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dailyReturnRate?: InputMaybe<DecimalNullableFilter>;
  dailyReturnRateLastUpdated?: InputMaybe<DateTimeNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mtd?: InputMaybe<DecimalNullableFilter>;
  mtdLastUpdated?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  ytd?: InputMaybe<DecimalNullableFilter>;
  ytdLastUpdated?: InputMaybe<DateTimeNullableFilter>;
};

export type FundPolicy = {
  __typename?: 'FundPolicy';
  annualManagementFee: Scalars['Decimal']['output'];
  annualTrusteeFee: Scalars['Decimal']['output'];
  coolingOffPeriodDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fund: Fund;
  id: Scalars['ID']['output'];
  minHoldingUnit: Scalars['Decimal']['output'];
  minInitInvestment: Scalars['Decimal']['output'];
  minRedemptionUnit: Scalars['Decimal']['output'];
  minSubsequentInvestment: Scalars['Decimal']['output'];
  minSwitchingUnit: Scalars['Decimal']['output'];
  purchasePeriodDays: Scalars['Int']['output'];
  redemptionCutOffTime?: Maybe<Scalars['String']['output']>;
  redemptionPeriodDays: Scalars['Int']['output'];
  salesChargePercent: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wholeSaleFlag: Scalars['Boolean']['output'];
};

export type FundPolicyAvgAggregate = {
  __typename?: 'FundPolicyAvgAggregate';
  annualManagementFee?: Maybe<Scalars['Decimal']['output']>;
  annualTrusteeFee?: Maybe<Scalars['Decimal']['output']>;
  coolingOffPeriodDays?: Maybe<Scalars['Float']['output']>;
  minHoldingUnit?: Maybe<Scalars['Decimal']['output']>;
  minInitInvestment?: Maybe<Scalars['Decimal']['output']>;
  minRedemptionUnit?: Maybe<Scalars['Decimal']['output']>;
  minSubsequentInvestment?: Maybe<Scalars['Decimal']['output']>;
  minSwitchingUnit?: Maybe<Scalars['Decimal']['output']>;
  purchasePeriodDays?: Maybe<Scalars['Float']['output']>;
  redemptionPeriodDays?: Maybe<Scalars['Float']['output']>;
  salesChargePercent?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPolicyCountAggregate = {
  __typename?: 'FundPolicyCountAggregate';
  _all: Scalars['Int']['output'];
  annualManagementFee: Scalars['Int']['output'];
  annualTrusteeFee: Scalars['Int']['output'];
  coolingOffPeriodDays: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  cutOffTime: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  minHoldingUnit: Scalars['Int']['output'];
  minInitInvestment: Scalars['Int']['output'];
  minRedemptionUnit: Scalars['Int']['output'];
  minSubsequentInvestment: Scalars['Int']['output'];
  minSwitchingUnit: Scalars['Int']['output'];
  purchasePeriodDays: Scalars['Int']['output'];
  redemptionCutOffTime: Scalars['Int']['output'];
  redemptionPeriodDays: Scalars['Int']['output'];
  salesChargePercent: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  wholeSaleFlag: Scalars['Int']['output'];
};

export type FundPolicyCreateNestedOneWithoutFundInput = {
  connect?: InputMaybe<FundPolicyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPolicyCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPolicyUncheckedCreateWithoutFundInput>;
};

export type FundPolicyCreateOrConnectWithoutFundInput = {
  create: FundPolicyUncheckedCreateWithoutFundInput;
  where: FundPolicyWhereUniqueInput;
};

export type FundPolicyMaxAggregate = {
  __typename?: 'FundPolicyMaxAggregate';
  annualManagementFee?: Maybe<Scalars['Decimal']['output']>;
  annualTrusteeFee?: Maybe<Scalars['Decimal']['output']>;
  coolingOffPeriodDays?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minHoldingUnit?: Maybe<Scalars['Decimal']['output']>;
  minInitInvestment?: Maybe<Scalars['Decimal']['output']>;
  minRedemptionUnit?: Maybe<Scalars['Decimal']['output']>;
  minSubsequentInvestment?: Maybe<Scalars['Decimal']['output']>;
  minSwitchingUnit?: Maybe<Scalars['Decimal']['output']>;
  purchasePeriodDays?: Maybe<Scalars['Int']['output']>;
  redemptionCutOffTime?: Maybe<Scalars['String']['output']>;
  redemptionPeriodDays?: Maybe<Scalars['Int']['output']>;
  salesChargePercent?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wholeSaleFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type FundPolicyMinAggregate = {
  __typename?: 'FundPolicyMinAggregate';
  annualManagementFee?: Maybe<Scalars['Decimal']['output']>;
  annualTrusteeFee?: Maybe<Scalars['Decimal']['output']>;
  coolingOffPeriodDays?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minHoldingUnit?: Maybe<Scalars['Decimal']['output']>;
  minInitInvestment?: Maybe<Scalars['Decimal']['output']>;
  minRedemptionUnit?: Maybe<Scalars['Decimal']['output']>;
  minSubsequentInvestment?: Maybe<Scalars['Decimal']['output']>;
  minSwitchingUnit?: Maybe<Scalars['Decimal']['output']>;
  purchasePeriodDays?: Maybe<Scalars['Int']['output']>;
  redemptionCutOffTime?: Maybe<Scalars['String']['output']>;
  redemptionPeriodDays?: Maybe<Scalars['Int']['output']>;
  salesChargePercent?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wholeSaleFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type FundPolicyNullableRelationFilter = {
  is?: InputMaybe<FundPolicyWhereInput>;
  isNot?: InputMaybe<FundPolicyWhereInput>;
};

export type FundPolicyOrderByWithRelationInput = {
  annualManagementFee?: InputMaybe<SortOrder>;
  annualTrusteeFee?: InputMaybe<SortOrder>;
  coolingOffPeriodDays?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cutOffTime?: InputMaybe<SortOrderInput>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minHoldingUnit?: InputMaybe<SortOrder>;
  minInitInvestment?: InputMaybe<SortOrder>;
  minRedemptionUnit?: InputMaybe<SortOrder>;
  minSubsequentInvestment?: InputMaybe<SortOrder>;
  minSwitchingUnit?: InputMaybe<SortOrder>;
  purchasePeriodDays?: InputMaybe<SortOrder>;
  redemptionCutOffTime?: InputMaybe<SortOrderInput>;
  redemptionPeriodDays?: InputMaybe<SortOrder>;
  salesChargePercent?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  wholeSaleFlag?: InputMaybe<SortOrder>;
};

export type FundPolicySumAggregate = {
  __typename?: 'FundPolicySumAggregate';
  annualManagementFee?: Maybe<Scalars['Decimal']['output']>;
  annualTrusteeFee?: Maybe<Scalars['Decimal']['output']>;
  coolingOffPeriodDays?: Maybe<Scalars['Int']['output']>;
  minHoldingUnit?: Maybe<Scalars['Decimal']['output']>;
  minInitInvestment?: Maybe<Scalars['Decimal']['output']>;
  minRedemptionUnit?: Maybe<Scalars['Decimal']['output']>;
  minSubsequentInvestment?: Maybe<Scalars['Decimal']['output']>;
  minSwitchingUnit?: Maybe<Scalars['Decimal']['output']>;
  purchasePeriodDays?: Maybe<Scalars['Int']['output']>;
  redemptionPeriodDays?: Maybe<Scalars['Int']['output']>;
  salesChargePercent?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPolicyUncheckedCreateInput = {
  annualManagementFee: Scalars['Decimal']['input'];
  annualTrusteeFee: Scalars['Decimal']['input'];
  coolingOffPeriodDays: Scalars['Int']['input'];
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit: Scalars['Decimal']['input'];
  minInitInvestment: Scalars['Decimal']['input'];
  minRedemptionUnit: Scalars['Decimal']['input'];
  minSubsequentInvestment: Scalars['Decimal']['input'];
  minSwitchingUnit: Scalars['Decimal']['input'];
  purchasePeriodDays: Scalars['Int']['input'];
  redemptionCutOffTime?: InputMaybe<Scalars['String']['input']>;
  redemptionPeriodDays: Scalars['Int']['input'];
  salesChargePercent: Scalars['Decimal']['input'];
  wholeSaleFlag: Scalars['Boolean']['input'];
};

export type FundPolicyUncheckedCreateNestedOneWithoutFundInput = {
  connect?: InputMaybe<FundPolicyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPolicyCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPolicyUncheckedCreateWithoutFundInput>;
};

export type FundPolicyUncheckedCreateWithoutFundInput = {
  annualManagementFee: Scalars['Decimal']['input'];
  annualTrusteeFee: Scalars['Decimal']['input'];
  coolingOffPeriodDays: Scalars['Int']['input'];
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit: Scalars['Decimal']['input'];
  minInitInvestment: Scalars['Decimal']['input'];
  minRedemptionUnit: Scalars['Decimal']['input'];
  minSubsequentInvestment: Scalars['Decimal']['input'];
  minSwitchingUnit: Scalars['Decimal']['input'];
  purchasePeriodDays: Scalars['Int']['input'];
  redemptionCutOffTime?: InputMaybe<Scalars['String']['input']>;
  redemptionPeriodDays: Scalars['Int']['input'];
  salesChargePercent: Scalars['Decimal']['input'];
  wholeSaleFlag: Scalars['Boolean']['input'];
};

export type FundPolicyUncheckedUpdateInput = {
  annualManagementFee?: InputMaybe<Scalars['Decimal']['input']>;
  annualTrusteeFee?: InputMaybe<Scalars['Decimal']['input']>;
  coolingOffPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit?: InputMaybe<Scalars['Decimal']['input']>;
  minInitInvestment?: InputMaybe<Scalars['Decimal']['input']>;
  minRedemptionUnit?: InputMaybe<Scalars['Decimal']['input']>;
  minSubsequentInvestment?: InputMaybe<Scalars['Decimal']['input']>;
  minSwitchingUnit?: InputMaybe<Scalars['Decimal']['input']>;
  purchasePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  redemptionCutOffTime?: InputMaybe<Scalars['String']['input']>;
  redemptionPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  salesChargePercent?: InputMaybe<Scalars['Decimal']['input']>;
  wholeSaleFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundPolicyUncheckedUpdateOneWithoutFundNestedInput = {
  connect?: InputMaybe<FundPolicyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundPolicyCreateOrConnectWithoutFundInput>;
  create?: InputMaybe<FundPolicyUncheckedCreateWithoutFundInput>;
  delete?: InputMaybe<FundPolicyWhereInput>;
  disconnect?: InputMaybe<FundPolicyWhereInput>;
  update?: InputMaybe<FundPolicyUncheckedUpdateWithoutFundInput>;
  upsert?: InputMaybe<FundPolicyUpsertWithoutFundInput>;
};

export type FundPolicyUncheckedUpdateWithoutFundInput = {
  annualManagementFee?: InputMaybe<Scalars['Decimal']['input']>;
  annualTrusteeFee?: InputMaybe<Scalars['Decimal']['input']>;
  coolingOffPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit?: InputMaybe<Scalars['Decimal']['input']>;
  minInitInvestment?: InputMaybe<Scalars['Decimal']['input']>;
  minRedemptionUnit?: InputMaybe<Scalars['Decimal']['input']>;
  minSubsequentInvestment?: InputMaybe<Scalars['Decimal']['input']>;
  minSwitchingUnit?: InputMaybe<Scalars['Decimal']['input']>;
  purchasePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  redemptionCutOffTime?: InputMaybe<Scalars['String']['input']>;
  redemptionPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  salesChargePercent?: InputMaybe<Scalars['Decimal']['input']>;
  wholeSaleFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundPolicyUpsertWithoutFundInput = {
  create: FundPolicyUncheckedCreateWithoutFundInput;
  update: FundPolicyUncheckedUpdateWithoutFundInput;
  where?: InputMaybe<FundPolicyWhereInput>;
};

export type FundPolicyWhereInput = {
  AND?: InputMaybe<Array<FundPolicyWhereInput>>;
  NOT?: InputMaybe<Array<FundPolicyWhereInput>>;
  OR?: InputMaybe<Array<FundPolicyWhereInput>>;
  annualManagementFee?: InputMaybe<DecimalFilter>;
  annualTrusteeFee?: InputMaybe<DecimalFilter>;
  coolingOffPeriodDays?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cutOffTime?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  minHoldingUnit?: InputMaybe<DecimalFilter>;
  minInitInvestment?: InputMaybe<DecimalFilter>;
  minRedemptionUnit?: InputMaybe<DecimalFilter>;
  minSubsequentInvestment?: InputMaybe<DecimalFilter>;
  minSwitchingUnit?: InputMaybe<DecimalFilter>;
  purchasePeriodDays?: InputMaybe<IntFilter>;
  redemptionCutOffTime?: InputMaybe<StringNullableFilter>;
  redemptionPeriodDays?: InputMaybe<IntFilter>;
  salesChargePercent?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  wholeSaleFlag?: InputMaybe<BoolFilter>;
};

export type FundPolicyWhereUniqueInput = {
  AND?: InputMaybe<Array<FundPolicyWhereInput>>;
  NOT?: InputMaybe<Array<FundPolicyWhereInput>>;
  OR?: InputMaybe<Array<FundPolicyWhereInput>>;
  annualManagementFee?: InputMaybe<DecimalFilter>;
  annualTrusteeFee?: InputMaybe<DecimalFilter>;
  coolingOffPeriodDays?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cutOffTime?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minHoldingUnit?: InputMaybe<DecimalFilter>;
  minInitInvestment?: InputMaybe<DecimalFilter>;
  minRedemptionUnit?: InputMaybe<DecimalFilter>;
  minSubsequentInvestment?: InputMaybe<DecimalFilter>;
  minSwitchingUnit?: InputMaybe<DecimalFilter>;
  purchasePeriodDays?: InputMaybe<IntFilter>;
  redemptionCutOffTime?: InputMaybe<StringNullableFilter>;
  redemptionPeriodDays?: InputMaybe<IntFilter>;
  salesChargePercent?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  wholeSaleFlag?: InputMaybe<BoolFilter>;
};

export type FundPrice = {
  __typename?: 'FundPrice';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fund: Fund;
  id: Scalars['ID']['output'];
  price: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FundPriceAvgAggregate = {
  __typename?: 'FundPriceAvgAggregate';
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPriceCountAggregate = {
  __typename?: 'FundPriceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FundPriceCreateManyFundInput = {
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
};

export type FundPriceCreateManyFundInputEnvelope = {
  data: Array<FundPriceCreateManyFundInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundPriceCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundPriceCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundPriceCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundPriceCreateManyFundInputEnvelope>;
};

export type FundPriceCreateOrConnectWithoutFundInput = {
  create: FundPriceUncheckedCreateWithoutFundInput;
  where: FundPriceWhereUniqueInput;
};

export type FundPriceCreateWithoutFundInput = {
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
};

export type FundPriceListRelationFilter = {
  every?: InputMaybe<FundPriceWhereInput>;
  none?: InputMaybe<FundPriceWhereInput>;
  some?: InputMaybe<FundPriceWhereInput>;
};

export type FundPriceMaxAggregate = {
  __typename?: 'FundPriceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundPriceMinAggregate = {
  __typename?: 'FundPriceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FundPriceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FundPriceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Date = 'date',
  DeletedAt = 'deletedAt',
  FundCode = 'fundCode',
  Id = 'id',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

export type FundPriceScalarWhereInput = {
  AND?: InputMaybe<Array<FundPriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<FundPriceScalarWhereInput>>;
  OR?: InputMaybe<Array<FundPriceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundPriceSumAggregate = {
  __typename?: 'FundPriceSumAggregate';
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type FundPriceUncheckedCreateInput = {
  date: Scalars['DateTime']['input'];
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
};

export type FundPriceUncheckedCreateNestedManyWithoutFundInput = {
  connect?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundPriceCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundPriceCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundPriceCreateManyFundInputEnvelope>;
};

export type FundPriceUncheckedCreateWithoutFundInput = {
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
};

export type FundPriceUncheckedUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FundPriceUncheckedUpdateManyWithoutFundInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FundPriceUncheckedUpdateManyWithoutFundNestedInput = {
  connect?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundPriceCreateOrConnectWithoutFundInput>>;
  create?: InputMaybe<Array<FundPriceCreateWithoutFundInput>>;
  createMany?: InputMaybe<FundPriceCreateManyFundInputEnvelope>;
  delete?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FundPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<FundPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<FundPriceUpdateWithWhereUniqueWithoutFundInput>>;
  updateMany?: InputMaybe<Array<FundPriceUpdateManyWithWhereWithoutFundInput>>;
  upsert?: InputMaybe<Array<FundPriceUpsertWithWhereUniqueWithoutFundInput>>;
};

export type FundPriceUncheckedUpdateWithoutFundInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FundPriceUpdateManyWithWhereWithoutFundInput = {
  data: FundPriceUncheckedUpdateManyWithoutFundInput;
  where: FundPriceScalarWhereInput;
};

export type FundPriceUpdateWithWhereUniqueWithoutFundInput = {
  data: FundPriceUncheckedUpdateWithoutFundInput;
  where: FundPriceWhereUniqueInput;
};

export type FundPriceUpsertWithWhereUniqueWithoutFundInput = {
  create: FundPriceUncheckedCreateWithoutFundInput;
  update: FundPriceUncheckedUpdateWithoutFundInput;
  where: FundPriceWhereUniqueInput;
};

export type FundPriceWhereInput = {
  AND?: InputMaybe<Array<FundPriceWhereInput>>;
  NOT?: InputMaybe<Array<FundPriceWhereInput>>;
  OR?: InputMaybe<Array<FundPriceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundPriceWhereUniqueInput = {
  AND?: InputMaybe<Array<FundPriceWhereInput>>;
  NOT?: InputMaybe<Array<FundPriceWhereInput>>;
  OR?: InputMaybe<Array<FundPriceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundRelationFilter = {
  is?: InputMaybe<FundWhereInput>;
  isNot?: InputMaybe<FundWhereInput>;
};

export enum FundRiskProfile {
  High = 'high',
  Low = 'low',
  LowMedium = 'low_medium',
  Medium = 'medium',
  MediumHigh = 'medium_high'
}

export enum FundScalarFieldEnum {
  AnnualExpenseRatio = 'annualExpenseRatio',
  AnnualExpenseRatioDate = 'annualExpenseRatioDate',
  AnnualManagementFeeDisplay = 'annualManagementFeeDisplay',
  AssetAllocation = 'assetAllocation',
  Benchmark = 'benchmark',
  Category = 'category',
  Classes = 'classes',
  CollectionBankAccountId = 'collectionBankAccountId',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  CurrencyCode = 'currencyCode',
  DeletedAt = 'deletedAt',
  DistributionPolicy = 'distributionPolicy',
  EsgFlag = 'esgFlag',
  FinancialYearEnd = 'financialYearEnd',
  FundCode = 'fundCode',
  FundFocusFlag = 'fundFocusFlag',
  FundManagerCode = 'fundManagerCode',
  FundName = 'fundName',
  FundRiskProfile = 'fundRiskProfile',
  FundSize = 'fundSize',
  FundSizeCurrency = 'fundSizeCurrency',
  FundSizeDate = 'fundSizeDate',
  FundStatus = 'fundStatus',
  Id = 'id',
  InvestmentObj = 'investmentObj',
  Isin = 'isin',
  LaunchDate = 'launchDate',
  LaunchPrice = 'launchPrice',
  LipperMyClass = 'lipperMyClass',
  LocalFlag = 'localFlag',
  Manager = 'manager',
  PricingBasic = 'pricingBasic',
  Rm1FundIndicator = 'rm1FundIndicator',
  SalesChargeDisplay = 'salesChargeDisplay',
  ShariahFlag = 'shariahFlag',
  Status = 'status',
  SwitchFee = 'switchFee',
  SwitchingFeeDisplay = 'switchingFeeDisplay',
  TotalUnitInCirculation = 'totalUnitInCirculation',
  TotalUnitInCirculationDate = 'totalUnitInCirculationDate',
  TrusteeFeeDisplay = 'trusteeFeeDisplay',
  TrusteeId = 'trusteeId',
  UpdatedAt = 'updatedAt'
}

export type FundScalarWhereInput = {
  AND?: InputMaybe<Array<FundScalarWhereInput>>;
  NOT?: InputMaybe<Array<FundScalarWhereInput>>;
  OR?: InputMaybe<Array<FundScalarWhereInput>>;
  annualExpenseRatio?: InputMaybe<DecimalFilter>;
  annualExpenseRatioDate?: InputMaybe<DateTimeNullableFilter>;
  annualManagementFeeDisplay?: InputMaybe<StringNullableFilter>;
  assetAllocation?: InputMaybe<StringFilter>;
  benchmark?: InputMaybe<StringFilter>;
  category?: InputMaybe<EnumFundCategoriesFilter>;
  classes?: InputMaybe<StringNullableFilter>;
  collectionBankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  distributionPolicy?: InputMaybe<StringFilter>;
  esgFlag?: InputMaybe<BoolFilter>;
  financialYearEnd?: InputMaybe<StringFilter>;
  fundCode?: InputMaybe<StringFilter>;
  fundFocusFlag?: InputMaybe<BoolFilter>;
  fundManagerCode?: InputMaybe<StringNullableFilter>;
  fundName?: InputMaybe<StringFilter>;
  fundRiskProfile?: InputMaybe<EnumFundRiskProfileFilter>;
  fundSize?: InputMaybe<IntFilter>;
  fundSizeCurrency?: InputMaybe<StringFilter>;
  fundSizeDate?: InputMaybe<DateTimeNullableFilter>;
  fundStatus?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  investmentObj?: InputMaybe<StringFilter>;
  isin?: InputMaybe<StringNullableFilter>;
  launchDate?: InputMaybe<DateTimeNullableFilter>;
  launchPrice?: InputMaybe<DecimalFilter>;
  lipperMyClass?: InputMaybe<StringFilter>;
  localFlag?: InputMaybe<BoolFilter>;
  manager?: InputMaybe<EnumFundManagersNullableFilter>;
  pricingBasic?: InputMaybe<StringFilter>;
  rm1FundIndicator?: InputMaybe<BoolFilter>;
  salesChargeDisplay?: InputMaybe<StringNullableFilter>;
  shariahFlag?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumFundStatusFilter>;
  switchFee?: InputMaybe<DecimalFilter>;
  switchingFeeDisplay?: InputMaybe<StringNullableFilter>;
  totalUnitInCirculation?: InputMaybe<IntFilter>;
  totalUnitInCirculationDate?: InputMaybe<DateTimeNullableFilter>;
  trusteeFeeDisplay?: InputMaybe<StringNullableFilter>;
  trusteeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum FundStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type FundSumAggregate = {
  __typename?: 'FundSumAggregate';
  annualExpenseRatio?: Maybe<Scalars['Decimal']['output']>;
  fundSize?: Maybe<Scalars['Int']['output']>;
  launchPrice?: Maybe<Scalars['Decimal']['output']>;
  switchFee?: Maybe<Scalars['Decimal']['output']>;
  totalUnitInCirculation?: Maybe<Scalars['Int']['output']>;
};

export type FundUncheckedCreateInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<Array<FundDocumentInput>>;
  fundFocusFlag: Scalars['Boolean']['input'];
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPolicy?: InputMaybe<CreateOneFundPolicyInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['String']['input'];
  manager: FundManagers;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status: FundStatus;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedCreateNestedManyWithoutCollectionBankAccountInput = {
  connect?: InputMaybe<Array<FundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundCreateOrConnectWithoutCollectionBankAccountInput>>;
  create?: InputMaybe<Array<FundCreateWithoutCollectionBankAccountInput>>;
  createMany?: InputMaybe<FundCreateManyCollectionBankAccountInputEnvelope>;
};

export type FundUncheckedCreateNestedManyWithoutTrusteeInput = {
  connect?: InputMaybe<Array<FundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundCreateOrConnectWithoutTrusteeInput>>;
  create?: InputMaybe<Array<FundCreateWithoutTrusteeInput>>;
  createMany?: InputMaybe<FundCreateManyTrusteeInputEnvelope>;
};

export type FundUncheckedCreateWithoutAccountPortfoliosInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentUncheckedCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceUncheckedCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayUncheckedCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedCreateWithoutCollectionBankAccountInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentUncheckedCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceUncheckedCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayUncheckedCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedCreateWithoutSwitchToTransactionsInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentUncheckedCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceUncheckedCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayUncheckedCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedCreateWithoutTransactionsInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentUncheckedCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceUncheckedCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayUncheckedCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedCreateWithoutTrusteeInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<FundDocumentUncheckedCreateNestedManyWithoutFundInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPerformance?: InputMaybe<FundPerformanceUncheckedCreateNestedOneWithoutFundInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedCreateNestedOneWithoutFundInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedCreateNestedManyWithoutFundInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus: Scalars['String']['input'];
  holidays?: InputMaybe<FundHolidayUncheckedCreateNestedManyWithoutFundInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['Boolean']['input'];
  manager?: InputMaybe<FundManagers>;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status?: InputMaybe<FundStatus>;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedUpdateInput = {
  annualExpenseRatio: Scalars['Decimal']['input'];
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation: Scalars['String']['input'];
  benchmark: Scalars['String']['input'];
  category: FundCategories;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  distributionPolicy: Scalars['String']['input'];
  esgFlag: Scalars['Boolean']['input'];
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  fundDocuments?: InputMaybe<Array<FundDocumentInput>>;
  fundFocusFlag: Scalars['Boolean']['input'];
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName: Scalars['String']['input'];
  fundPolicy?: InputMaybe<CreateOneFundPolicyInput>;
  fundRiskProfile: FundRiskProfile;
  fundSize: Scalars['Int']['input'];
  fundSizeCurrency: Scalars['String']['input'];
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj: Scalars['String']['input'];
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice: Scalars['Decimal']['input'];
  lipperMyClass: Scalars['String']['input'];
  localFlag: Scalars['String']['input'];
  manager: FundManagers;
  pricingBasic: Scalars['String']['input'];
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag: Scalars['Boolean']['input'];
  status: FundStatus;
  switchFee: Scalars['Decimal']['input'];
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation: Scalars['Int']['input'];
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedUpdateManyWithoutCollectionBankAccountInput = {
  annualExpenseRatio?: InputMaybe<Scalars['Decimal']['input']>;
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation?: InputMaybe<Scalars['String']['input']>;
  benchmark?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<FundCategories>;
  classes?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy?: InputMaybe<Scalars['String']['input']>;
  esgFlag?: InputMaybe<Scalars['Boolean']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  fundRiskProfile?: InputMaybe<FundRiskProfile>;
  fundSize?: InputMaybe<Scalars['Int']['input']>;
  fundSizeCurrency?: InputMaybe<Scalars['String']['input']>;
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice?: InputMaybe<Scalars['Decimal']['input']>;
  lipperMyClass?: InputMaybe<Scalars['String']['input']>;
  localFlag?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<FundManagers>;
  pricingBasic?: InputMaybe<Scalars['String']['input']>;
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FundStatus>;
  switchFee?: InputMaybe<Scalars['Decimal']['input']>;
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation?: InputMaybe<Scalars['Int']['input']>;
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedUpdateManyWithoutCollectionBankAccountNestedInput = {
  connect?: InputMaybe<Array<FundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundCreateOrConnectWithoutCollectionBankAccountInput>>;
  create?: InputMaybe<Array<FundCreateWithoutCollectionBankAccountInput>>;
  createMany?: InputMaybe<FundCreateManyCollectionBankAccountInputEnvelope>;
  delete?: InputMaybe<Array<FundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FundWhereUniqueInput>>;
  set?: InputMaybe<Array<FundWhereUniqueInput>>;
  update?: InputMaybe<Array<FundUpdateWithWhereUniqueWithoutCollectionBankAccountInput>>;
  updateMany?: InputMaybe<Array<FundUpdateManyWithWhereWithoutCollectionBankAccountInput>>;
  upsert?: InputMaybe<Array<FundUpsertWithWhereUniqueWithoutCollectionBankAccountInput>>;
};

export type FundUncheckedUpdateManyWithoutTrusteeInput = {
  annualExpenseRatio?: InputMaybe<Scalars['Decimal']['input']>;
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation?: InputMaybe<Scalars['String']['input']>;
  benchmark?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<FundCategories>;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy?: InputMaybe<Scalars['String']['input']>;
  esgFlag?: InputMaybe<Scalars['Boolean']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  fundRiskProfile?: InputMaybe<FundRiskProfile>;
  fundSize?: InputMaybe<Scalars['Int']['input']>;
  fundSizeCurrency?: InputMaybe<Scalars['String']['input']>;
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice?: InputMaybe<Scalars['Decimal']['input']>;
  lipperMyClass?: InputMaybe<Scalars['String']['input']>;
  localFlag?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<FundManagers>;
  pricingBasic?: InputMaybe<Scalars['String']['input']>;
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FundStatus>;
  switchFee?: InputMaybe<Scalars['Decimal']['input']>;
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation?: InputMaybe<Scalars['Int']['input']>;
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedUpdateManyWithoutTrusteeNestedInput = {
  connect?: InputMaybe<Array<FundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FundCreateOrConnectWithoutTrusteeInput>>;
  create?: InputMaybe<Array<FundCreateWithoutTrusteeInput>>;
  createMany?: InputMaybe<FundCreateManyTrusteeInputEnvelope>;
  delete?: InputMaybe<Array<FundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FundWhereUniqueInput>>;
  set?: InputMaybe<Array<FundWhereUniqueInput>>;
  update?: InputMaybe<Array<FundUpdateWithWhereUniqueWithoutTrusteeInput>>;
  updateMany?: InputMaybe<Array<FundUpdateManyWithWhereWithoutTrusteeInput>>;
  upsert?: InputMaybe<Array<FundUpsertWithWhereUniqueWithoutTrusteeInput>>;
};

export type FundUncheckedUpdateWithoutCollectionBankAccountInput = {
  annualExpenseRatio?: InputMaybe<Scalars['Decimal']['input']>;
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation?: InputMaybe<Scalars['String']['input']>;
  benchmark?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<FundCategories>;
  classes?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy?: InputMaybe<Scalars['String']['input']>;
  esgFlag?: InputMaybe<Scalars['Boolean']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  fundDocuments?: InputMaybe<FundDocumentUncheckedUpdateManyWithoutFundNestedInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  fundPerformance?: InputMaybe<FundPerformanceUncheckedUpdateOneWithoutFundNestedInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedUpdateOneWithoutFundNestedInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedUpdateManyWithoutFundNestedInput>;
  fundRiskProfile?: InputMaybe<FundRiskProfile>;
  fundSize?: InputMaybe<Scalars['Int']['input']>;
  fundSizeCurrency?: InputMaybe<Scalars['String']['input']>;
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  holidays?: InputMaybe<FundHolidayUncheckedUpdateManyWithoutFundNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice?: InputMaybe<Scalars['Decimal']['input']>;
  lipperMyClass?: InputMaybe<Scalars['String']['input']>;
  localFlag?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<FundManagers>;
  pricingBasic?: InputMaybe<Scalars['String']['input']>;
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FundStatus>;
  switchFee?: InputMaybe<Scalars['Decimal']['input']>;
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation?: InputMaybe<Scalars['Int']['input']>;
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['String']['input']>;
};

export type FundUncheckedUpdateWithoutTrusteeInput = {
  annualExpenseRatio?: InputMaybe<Scalars['Decimal']['input']>;
  annualExpenseRatioDate?: InputMaybe<Scalars['DateTime']['input']>;
  annualManagementFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  assetAllocation?: InputMaybe<Scalars['String']['input']>;
  benchmark?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<FundCategories>;
  classes?: InputMaybe<Scalars['String']['input']>;
  collectionBankAccountId?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  distributionPolicy?: InputMaybe<Scalars['String']['input']>;
  esgFlag?: InputMaybe<Scalars['Boolean']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  fundDocuments?: InputMaybe<FundDocumentUncheckedUpdateManyWithoutFundNestedInput>;
  fundFocusFlag?: InputMaybe<Scalars['Boolean']['input']>;
  fundManagerCode?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  fundPerformance?: InputMaybe<FundPerformanceUncheckedUpdateOneWithoutFundNestedInput>;
  fundPolicy?: InputMaybe<FundPolicyUncheckedUpdateOneWithoutFundNestedInput>;
  fundPrices?: InputMaybe<FundPriceUncheckedUpdateManyWithoutFundNestedInput>;
  fundRiskProfile?: InputMaybe<FundRiskProfile>;
  fundSize?: InputMaybe<Scalars['Int']['input']>;
  fundSizeCurrency?: InputMaybe<Scalars['String']['input']>;
  fundSizeDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundStatus?: InputMaybe<Scalars['String']['input']>;
  holidays?: InputMaybe<FundHolidayUncheckedUpdateManyWithoutFundNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['DateTime']['input']>;
  launchPrice?: InputMaybe<Scalars['Decimal']['input']>;
  lipperMyClass?: InputMaybe<Scalars['String']['input']>;
  localFlag?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<FundManagers>;
  pricingBasic?: InputMaybe<Scalars['String']['input']>;
  rm1FundIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  salesChargeDisplay?: InputMaybe<Scalars['String']['input']>;
  shariahFlag?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FundStatus>;
  switchFee?: InputMaybe<Scalars['Decimal']['input']>;
  switchingFeeDisplay?: InputMaybe<Scalars['String']['input']>;
  totalUnitInCirculation?: InputMaybe<Scalars['Int']['input']>;
  totalUnitInCirculationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trusteeFeeDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type FundUpdateManyWithWhereWithoutCollectionBankAccountInput = {
  data: FundUncheckedUpdateManyWithoutCollectionBankAccountInput;
  where: FundScalarWhereInput;
};

export type FundUpdateManyWithWhereWithoutTrusteeInput = {
  data: FundUncheckedUpdateManyWithoutTrusteeInput;
  where: FundScalarWhereInput;
};

export type FundUpdateWithWhereUniqueWithoutCollectionBankAccountInput = {
  data: FundUncheckedUpdateWithoutCollectionBankAccountInput;
  where: FundWhereUniqueInput;
};

export type FundUpdateWithWhereUniqueWithoutTrusteeInput = {
  data: FundUncheckedUpdateWithoutTrusteeInput;
  where: FundWhereUniqueInput;
};

export type FundUpsertWithWhereUniqueWithoutCollectionBankAccountInput = {
  create: FundUncheckedCreateWithoutCollectionBankAccountInput;
  update: FundUncheckedUpdateWithoutCollectionBankAccountInput;
  where: FundWhereUniqueInput;
};

export type FundUpsertWithWhereUniqueWithoutTrusteeInput = {
  create: FundUncheckedCreateWithoutTrusteeInput;
  update: FundUncheckedUpdateWithoutTrusteeInput;
  where: FundWhereUniqueInput;
};

export type FundWhereInput = {
  AND?: InputMaybe<Array<FundWhereInput>>;
  NOT?: InputMaybe<Array<FundWhereInput>>;
  OR?: InputMaybe<Array<FundWhereInput>>;
  accountPortfolios?: InputMaybe<AccountPortfolioListRelationFilter>;
  annualExpenseRatio?: InputMaybe<DecimalFilter>;
  annualExpenseRatioDate?: InputMaybe<DateTimeNullableFilter>;
  annualManagementFeeDisplay?: InputMaybe<StringNullableFilter>;
  assetAllocation?: InputMaybe<StringFilter>;
  benchmark?: InputMaybe<StringFilter>;
  category?: InputMaybe<EnumFundCategoriesFilter>;
  classes?: InputMaybe<StringNullableFilter>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountNullableRelationFilter>;
  collectionBankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  distributionPolicy?: InputMaybe<StringFilter>;
  esgFlag?: InputMaybe<BoolFilter>;
  financialYearEnd?: InputMaybe<StringFilter>;
  fundCode?: InputMaybe<StringFilter>;
  fundDocuments?: InputMaybe<FundDocumentListRelationFilter>;
  fundFocusFlag?: InputMaybe<BoolFilter>;
  fundManager?: InputMaybe<FundManagerNullableRelationFilter>;
  fundManagerCode?: InputMaybe<StringNullableFilter>;
  fundName?: InputMaybe<StringFilter>;
  fundPerformance?: InputMaybe<FundPerformanceNullableRelationFilter>;
  fundPolicy?: InputMaybe<FundPolicyNullableRelationFilter>;
  fundPrices?: InputMaybe<FundPriceListRelationFilter>;
  fundRiskProfile?: InputMaybe<EnumFundRiskProfileFilter>;
  fundSize?: InputMaybe<IntFilter>;
  fundSizeCurrency?: InputMaybe<StringFilter>;
  fundSizeDate?: InputMaybe<DateTimeNullableFilter>;
  fundStatus?: InputMaybe<StringFilter>;
  holidays?: InputMaybe<FundHolidayListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  investmentObj?: InputMaybe<StringFilter>;
  isin?: InputMaybe<StringNullableFilter>;
  launchDate?: InputMaybe<DateTimeNullableFilter>;
  launchPrice?: InputMaybe<DecimalFilter>;
  lipperMyClass?: InputMaybe<StringFilter>;
  localFlag?: InputMaybe<BoolFilter>;
  manager?: InputMaybe<EnumFundManagersNullableFilter>;
  pricingBasic?: InputMaybe<StringFilter>;
  rm1FundIndicator?: InputMaybe<BoolFilter>;
  salesChargeDisplay?: InputMaybe<StringNullableFilter>;
  shariahFlag?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumFundStatusFilter>;
  switchFee?: InputMaybe<DecimalFilter>;
  switchToTransactions?: InputMaybe<TransactionListRelationFilter>;
  switchingFeeDisplay?: InputMaybe<StringNullableFilter>;
  totalUnitInCirculation?: InputMaybe<IntFilter>;
  totalUnitInCirculationDate?: InputMaybe<DateTimeNullableFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  trustee?: InputMaybe<TrusteeNullableRelationFilter>;
  trusteeFeeDisplay?: InputMaybe<StringNullableFilter>;
  trusteeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundWhereUniqueInput = {
  AND?: InputMaybe<Array<FundWhereInput>>;
  NOT?: InputMaybe<Array<FundWhereInput>>;
  OR?: InputMaybe<Array<FundWhereInput>>;
  accountPortfolios?: InputMaybe<AccountPortfolioListRelationFilter>;
  annualExpenseRatio?: InputMaybe<DecimalFilter>;
  annualExpenseRatioDate?: InputMaybe<DateTimeNullableFilter>;
  annualManagementFeeDisplay?: InputMaybe<StringNullableFilter>;
  assetAllocation?: InputMaybe<StringFilter>;
  benchmark?: InputMaybe<StringFilter>;
  category?: InputMaybe<EnumFundCategoriesFilter>;
  classes?: InputMaybe<StringNullableFilter>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountNullableRelationFilter>;
  collectionBankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  distributionPolicy?: InputMaybe<StringFilter>;
  esgFlag?: InputMaybe<BoolFilter>;
  financialYearEnd?: InputMaybe<StringFilter>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  fundDocuments?: InputMaybe<FundDocumentListRelationFilter>;
  fundFocusFlag?: InputMaybe<BoolFilter>;
  fundManager?: InputMaybe<FundManagerNullableRelationFilter>;
  fundManagerCode?: InputMaybe<StringNullableFilter>;
  fundName?: InputMaybe<StringFilter>;
  fundPerformance?: InputMaybe<FundPerformanceNullableRelationFilter>;
  fundPolicy?: InputMaybe<FundPolicyNullableRelationFilter>;
  fundPrices?: InputMaybe<FundPriceListRelationFilter>;
  fundRiskProfile?: InputMaybe<EnumFundRiskProfileFilter>;
  fundSize?: InputMaybe<IntFilter>;
  fundSizeCurrency?: InputMaybe<StringFilter>;
  fundSizeDate?: InputMaybe<DateTimeNullableFilter>;
  fundStatus?: InputMaybe<StringFilter>;
  holidays?: InputMaybe<FundHolidayListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  investmentObj?: InputMaybe<StringFilter>;
  isin?: InputMaybe<StringNullableFilter>;
  launchDate?: InputMaybe<DateTimeNullableFilter>;
  launchPrice?: InputMaybe<DecimalFilter>;
  lipperMyClass?: InputMaybe<StringFilter>;
  localFlag?: InputMaybe<BoolFilter>;
  manager?: InputMaybe<EnumFundManagersNullableFilter>;
  pricingBasic?: InputMaybe<StringFilter>;
  rm1FundIndicator?: InputMaybe<BoolFilter>;
  salesChargeDisplay?: InputMaybe<StringNullableFilter>;
  shariahFlag?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumFundStatusFilter>;
  switchFee?: InputMaybe<DecimalFilter>;
  switchToTransactions?: InputMaybe<TransactionListRelationFilter>;
  switchingFeeDisplay?: InputMaybe<StringNullableFilter>;
  totalUnitInCirculation?: InputMaybe<IntFilter>;
  totalUnitInCirculationDate?: InputMaybe<DateTimeNullableFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  trustee?: InputMaybe<TrusteeNullableRelationFilter>;
  trusteeFeeDisplay?: InputMaybe<StringNullableFilter>;
  trusteeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FundYieldPerformance = {
  __typename?: 'FundYieldPerformance';
  date?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  yieldType?: Maybe<YieldType>;
};

export type GeneratePresignedFileInput = {
  fileName: Scalars['String']['input'];
  /** The purpose of the upload, such as: profile_picture, ... */
  purpose: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type GeographicalSummary = {
  __typename?: 'GeographicalSummary';
  geographical: Scalars['String']['output'];
  values: Array<AmountValue>;
};

export type GetSignedFileInput = {
  location: Scalars['String']['input'];
};

export type HorizontalTitle = {
  __typename?: 'HorizontalTitle';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum IdType {
  CompanyRegistrationNo = 'CompanyRegistrationNo',
  Nric = 'NRIC',
  Passport = 'Passport'
}

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Interface {
  Admin = 'Admin',
  App = 'App'
}

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type LabelValueRow = {
  __typename?: 'LabelValueRow';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum LedgerTransactionType {
  Dv = 'DV',
  Dx = 'DX',
  Fc = 'FC',
  Ji = 'JI',
  Jo = 'JO',
  Ns = 'NS',
  Ob = 'OB',
  Pe = 'PE',
  Pr = 'PR',
  Re = 'RE',
  Rf = 'RF',
  Ri = 'RI',
  Ro = 'RO',
  Si = 'SI',
  So = 'SO',
  Ti = 'TI',
  To = 'TO',
  Us = 'US',
  Vo = 'VO',
  Xi = 'XI',
  Xo = 'XO',
  Xr = 'XR',
  Xs = 'XS'
}

export type ListAccountPortfoliosByUserFilter = {
  accountMasterAccountNos?: InputMaybe<Array<Scalars['String']['input']>>;
  fundCategory?: InputMaybe<FundCategories>;
};

export type ListAccountPortfoliosByUserProfileFilter = {
  accountMasterAccountNos?: InputMaybe<Array<Scalars['String']['input']>>;
  fundCategory?: InputMaybe<FundCategories>;
  profileId: Scalars['String']['input'];
};

export type ListTransactionsByUserFilter = {
  accountMasterAccountNos?: InputMaybe<Array<Scalars['String']['input']>>;
  publicStatus?: InputMaybe<TransactionPublicStatus>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  /** JWT access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Float']['output']>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  otpChallengeId?: Maybe<Scalars['String']['output']>;
  refreshExpiresIn?: Maybe<Scalars['Float']['output']>;
  /** JWT refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type McasRequestOtpInput = {
  channelType: Scalars['String']['input'];
  forChannelType: Scalars['String']['input'];
  icNumber: Scalars['String']['input'];
  tacChannelType: Scalars['String']['input'];
  transType: Scalars['String']['input'];
  verificationNumber: Scalars['String']['input'];
};

export type McasVerifyOtpInput = {
  channelType: Scalars['String']['input'];
  icNumber: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  transType: Scalars['String']['input'];
};

export enum ModeOfContact {
  Email = 'Email',
  Phone = 'Phone'
}

export type Modification = {
  __typename?: 'Modification';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityIdentifier?: Maybe<Scalars['String']['output']>;
  entityType: ModificationEntityType;
  id: Scalars['ID']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy: Scalars['String']['output'];
  newValues?: Maybe<Scalars['String']['output']>;
  oldValues?: Maybe<Scalars['String']['output']>;
  referenceKeys: Scalars['JSON']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: ModificationStatus;
  type: ModificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModificationCountAggregate = {
  __typename?: 'ModificationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  entityIdentifier: Scalars['Int']['output'];
  entityType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  modifiedBy: Scalars['Int']['output'];
  newValues: Scalars['Int']['output'];
  oldValues: Scalars['Int']['output'];
  referenceKeys: Scalars['Int']['output'];
  reviewedAt: Scalars['Int']['output'];
  reviewedBy: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export enum ModificationEntityType {
  AdminRole = 'AdminRole',
  AdminUser = 'AdminUser',
  Announcement = 'Announcement',
  AuthorisedSignatory = 'AuthorisedSignatory',
  Fund = 'Fund',
  FundHoliday = 'FundHoliday',
  InvitationCode = 'InvitationCode',
  Order = 'Order',
  Profile = 'Profile',
  ProfileConsent = 'ProfileConsent',
  PublicHoliday = 'PublicHoliday',
  User = 'User'
}

export type ModificationMaxAggregate = {
  __typename?: 'ModificationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityIdentifier?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<ModificationEntityType>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  newValues?: Maybe<Scalars['String']['output']>;
  oldValues?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ModificationStatus>;
  type?: Maybe<ModificationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModificationMinAggregate = {
  __typename?: 'ModificationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityIdentifier?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<ModificationEntityType>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  newValues?: Maybe<Scalars['String']['output']>;
  oldValues?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ModificationStatus>;
  type?: Maybe<ModificationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModificationModel = {
  __typename?: 'ModificationModel';
  after: Scalars['JSON']['output'];
  before: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityIdentifier?: Maybe<Scalars['String']['output']>;
  entityType: ModificationEntityType;
  id: Scalars['ID']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy: Scalars['String']['output'];
  modifyingUser?: Maybe<AdminUser>;
  newValues?: Maybe<Scalars['String']['output']>;
  oldValues?: Maybe<Scalars['String']['output']>;
  referenceKeys: Scalars['JSON']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  reviewingUser?: Maybe<AdminUser>;
  status: ModificationStatus;
  type: ModificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModificationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityIdentifier?: InputMaybe<SortOrderInput>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  modifiedBy?: InputMaybe<SortOrder>;
  newValues?: InputMaybe<SortOrderInput>;
  oldValues?: InputMaybe<SortOrderInput>;
  referenceKeys?: InputMaybe<SortOrder>;
  reviewedAt?: InputMaybe<SortOrderInput>;
  reviewedBy?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ModificationStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum ModificationType {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export type ModificationUncheckedCreateInput = {
  entityId: Scalars['String']['input'];
  entityIdentifier?: InputMaybe<Scalars['String']['input']>;
  entityType: ModificationEntityType;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy: Scalars['String']['input'];
  newValues?: InputMaybe<Scalars['String']['input']>;
  oldValues?: InputMaybe<Scalars['String']['input']>;
  referenceKeys?: InputMaybe<Scalars['JSON']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ModificationStatus>;
  type: ModificationType;
};

export type ModificationUncheckedUpdateInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityIdentifier?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<ModificationEntityType>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  newValues?: InputMaybe<Scalars['String']['input']>;
  oldValues?: InputMaybe<Scalars['String']['input']>;
  referenceKeys?: InputMaybe<Scalars['JSON']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ModificationStatus>;
  type?: InputMaybe<ModificationType>;
};

export type ModificationWhereInput = {
  AND?: InputMaybe<Array<ModificationWhereInput>>;
  NOT?: InputMaybe<Array<ModificationWhereInput>>;
  OR?: InputMaybe<Array<ModificationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityIdentifier?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumModificationEntityTypeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  modifiedBy?: InputMaybe<StringFilter>;
  newValues?: InputMaybe<StringNullableFilter>;
  oldValues?: InputMaybe<StringNullableFilter>;
  referenceKeys?: InputMaybe<JsonFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  reviewedBy?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumModificationStatusFilter>;
  type?: InputMaybe<EnumModificationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ModificationWhereUniqueInput = {
  AND?: InputMaybe<Array<ModificationWhereInput>>;
  NOT?: InputMaybe<Array<ModificationWhereInput>>;
  OR?: InputMaybe<Array<ModificationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityIdentifier?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumModificationEntityTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  modifiedBy?: InputMaybe<StringFilter>;
  newValues?: InputMaybe<StringNullableFilter>;
  oldValues?: InputMaybe<StringNullableFilter>;
  referenceKeys?: InputMaybe<JsonFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  reviewedBy?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumModificationStatusFilter>;
  type?: InputMaybe<EnumModificationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminLogin: Auth;
  approveModification?: Maybe<ModificationModel>;
  approveOrder?: Maybe<Order>;
  cancelOrder?: Maybe<Order>;
  completeManualProcessing?: Maybe<Order>;
  createOneAccount: Account;
  createOneAccountPortfolio: AccountPortfolio;
  createOneAccountRequest: AccountRequest;
  createOneAdminRole: AdminRole;
  createOneAdminUser: AdminUser;
  createOneAnnouncement?: Maybe<Announcement>;
  createOneAuditTrail: AuditTrail;
  createOneAuthorisedSignatory?: Maybe<AuthorisedSignatory>;
  createOneBank: Bank;
  createOneBankAccount: BankAccount;
  createOneCollectionBankAccount: CollectionBankAccount;
  createOneCorporateAccountRequest: AccountRequest;
  createOneCorporateUser?: Maybe<User>;
  createOneDocument: Document;
  createOneFund?: Maybe<Fund>;
  createOneFundDocument: FundDocument;
  createOneFundHoliday?: Maybe<FundHoliday>;
  createOneFundPolicy: FundPolicy;
  createOneFundPrice: FundPrice;
  createOneModification: Modification;
  createOneOrder: Order;
  createOneOrderDocument: OrderDocument;
  createOnePayment: Payment;
  createOneProfile: Profile;
  createOneProfileConsent?: Maybe<ProfileConsent>;
  createOnePublicHoliday?: Maybe<PublicHoliday>;
  createOneSignatory: Signatory;
  createOneStatement: Statement;
  createOneTransaction: Transaction;
  createOneTrustee: Trustee;
  createOneUser?: Maybe<User>;
  createOrderPayments?: Maybe<Order>;
  createOrderSubmissions?: Maybe<Order>;
  createSupportTicket?: Maybe<Scalars['Boolean']['output']>;
  deleteOneAccount?: Maybe<Account>;
  deleteOneAccountPortfolio?: Maybe<AccountPortfolio>;
  deleteOneAccountRequest?: Maybe<AccountRequest>;
  deleteOneAdminRole: AdminRole;
  deleteOneAdminUser?: Maybe<AdminUser>;
  deleteOneAnnouncement?: Maybe<Announcement>;
  deleteOneAuditTrail?: Maybe<AuditTrail>;
  deleteOneAuthorisedSignatory?: Maybe<AuthorisedSignatory>;
  deleteOneBank?: Maybe<Bank>;
  deleteOneBankAccount?: Maybe<BankAccount>;
  deleteOneCollectionBankAccount?: Maybe<CollectionBankAccount>;
  deleteOneDocument?: Maybe<Document>;
  deleteOneFund?: Maybe<Fund>;
  deleteOneFundDocument?: Maybe<FundDocument>;
  deleteOneFundHoliday?: Maybe<FundHoliday>;
  deleteOneFundPolicy?: Maybe<FundPolicy>;
  deleteOneFundPrice?: Maybe<FundPrice>;
  deleteOneModification?: Maybe<Modification>;
  deleteOneOrder?: Maybe<Order>;
  deleteOneOrderDocument?: Maybe<OrderDocument>;
  deleteOnePayment?: Maybe<Payment>;
  deleteOneProfile?: Maybe<Profile>;
  deleteOneProfileConsent?: Maybe<ProfileConsent>;
  deleteOnePublicHoliday?: Maybe<PublicHoliday>;
  deleteOneStatement?: Maybe<Statement>;
  deleteOneTransaction?: Maybe<Transaction>;
  deleteOneTrustee?: Maybe<Trustee>;
  deleteOneUser?: Maybe<User>;
  exportAccountRequests: Array<AccountRequest>;
  exportAdminUsers: Array<AdminUser>;
  exportAnnouncements: Array<Announcement>;
  exportAuditTrails: Array<AuditTrail>;
  exportFundHolidays: Array<FundHoliday>;
  exportFunds: Array<Fund>;
  exportModifications: Array<ModificationModel>;
  exportOrders: Array<Order>;
  exportOtpChallenges: Array<OtpChallenge>;
  exportProfileConsents: Array<ProfileConsent>;
  exportPublicHolidays: Array<PublicHoliday>;
  exportTransactions: Array<Transaction>;
  generatePresignedFile: SignedFile;
  getSignedFile: SignedFile;
  login: LoginResponse;
  logout: StatusResponse;
  markOrderPendingPaymentVerification?: Maybe<Order>;
  onboardCorporateUser?: Maybe<User>;
  recoverUsername: StatusResponse;
  refreshToken: Auth;
  register: Auth;
  rejectModification?: Maybe<ModificationModel>;
  rejectOrder?: Maybe<Order>;
  requestOtp: OtpChallenge;
  requestOtpLogin: OtpChallenge;
  requestSimpleOtp: OtpChallenge;
  resetPassword: StatusResponse;
  sendInvitationCodeToUser?: Maybe<User>;
  signatoryApproveOrder: Order;
  signatoryRejectOrder: Order;
  submitOrder?: Maybe<Order>;
  submitSwitchOrder?: Maybe<Order>;
  submitWithdrawOrder?: Maybe<Order>;
  tomswinCreateRedemption: TomswinTransaction;
  tomswinCreateSale: TomswinTransaction;
  tomswinCreateSwitching: TomswinTransaction;
  tomswinSyncRemoveIndex: Scalars['Boolean']['output'];
  tomswinSyncResetFileType: Scalars['Boolean']['output'];
  updateOneAccount?: Maybe<Account>;
  updateOneAccountPortfolio?: Maybe<AccountPortfolio>;
  updateOneAccountRequest?: Maybe<AccountRequest>;
  updateOneAdminRole?: Maybe<AdminRole>;
  updateOneAdminUser?: Maybe<AdminUser>;
  updateOneAnnouncement?: Maybe<Announcement>;
  updateOneAuditTrail?: Maybe<AuditTrail>;
  updateOneAuthorisedSignatory?: Maybe<AuthorisedSignatory>;
  updateOneBank?: Maybe<Bank>;
  updateOneBankAccount?: Maybe<BankAccount>;
  updateOneCollectionBankAccount?: Maybe<CollectionBankAccount>;
  updateOneDocument?: Maybe<Document>;
  updateOneFund?: Maybe<Fund>;
  updateOneFundDocument?: Maybe<FundDocument>;
  updateOneFundHoliday?: Maybe<FundHoliday>;
  updateOneFundPolicy?: Maybe<FundPolicy>;
  updateOneFundPrice?: Maybe<FundPrice>;
  updateOneModification?: Maybe<Modification>;
  updateOneOrder?: Maybe<Order>;
  updateOneOrderDocument?: Maybe<OrderDocument>;
  updateOnePayment: Payment;
  updateOneProfile: Profile;
  updateOneProfileConsent?: Maybe<ProfileConsent>;
  updateOnePublicHoliday?: Maybe<PublicHoliday>;
  updateOneStatement?: Maybe<Statement>;
  updateOneTransaction?: Maybe<Transaction>;
  updateOneTrustee?: Maybe<Trustee>;
  updateOneUser?: Maybe<User>;
  updateUserSecurityImage?: Maybe<User>;
  verifyOtp: StatusResponse;
  verifyOtpLogin: Auth;
  verifySimpleOtp: OtpChallenge;
};


export type MutationAdminLoginArgs = {
  data: AdminLoginInput;
};


export type MutationApproveModificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveOrderArgs = {
  id: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteManualProcessingArgs = {
  id: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
};


export type MutationCreateOneAccountArgs = {
  data: AccountUncheckedCreateInput;
};


export type MutationCreateOneAccountPortfolioArgs = {
  data: AccountPortfolioUncheckedCreateInput;
};


export type MutationCreateOneAccountRequestArgs = {
  data: AccountRequestUncheckedCreateInput;
};


export type MutationCreateOneAdminRoleArgs = {
  data: AdminRoleCreateInputV2;
};


export type MutationCreateOneAdminUserArgs = {
  data: AdminUserCreateInputV2;
};


export type MutationCreateOneAnnouncementArgs = {
  data: AnnouncementUncheckedCreateInput;
};


export type MutationCreateOneAuditTrailArgs = {
  data: AuditTrailUncheckedCreateInput;
};


export type MutationCreateOneAuthorisedSignatoryArgs = {
  data: AuthorisedSignatoryUncheckedCreateInput;
};


export type MutationCreateOneBankArgs = {
  data: BankUncheckedCreateInput;
};


export type MutationCreateOneBankAccountArgs = {
  data: BankAccountUncheckedCreateInput;
};


export type MutationCreateOneCollectionBankAccountArgs = {
  data: CollectionBankAccountUncheckedCreateInput;
};


export type MutationCreateOneCorporateAccountRequestArgs = {
  data: CorporateAccountRequestCreateInput;
};


export type MutationCreateOneCorporateUserArgs = {
  data: CorporateUserUncheckedCreateInput;
};


export type MutationCreateOneDocumentArgs = {
  data: CreateOneDocumentInput;
};


export type MutationCreateOneFundArgs = {
  data: FundUncheckedCreateInput;
};


export type MutationCreateOneFundDocumentArgs = {
  data: FundDocumentUncheckedCreateInput;
};


export type MutationCreateOneFundHolidayArgs = {
  data: FundHolidayUncheckedCreateInput;
};


export type MutationCreateOneFundPolicyArgs = {
  data: FundPolicyUncheckedCreateInput;
};


export type MutationCreateOneFundPriceArgs = {
  data: FundPriceUncheckedCreateInput;
};


export type MutationCreateOneModificationArgs = {
  data: ModificationUncheckedCreateInput;
};


export type MutationCreateOneOrderArgs = {
  data: OrderUncheckedCreateInput;
};


export type MutationCreateOneOrderDocumentArgs = {
  data: OrderDocumentUncheckedCreateInput;
};


export type MutationCreateOnePaymentArgs = {
  data: PaymentUncheckedCreateInput;
};


export type MutationCreateOneProfileArgs = {
  data: ProfileUncheckedCreateInput;
};


export type MutationCreateOneProfileConsentArgs = {
  data: ProfileConsentUncheckedCreateInput;
};


export type MutationCreateOnePublicHolidayArgs = {
  data: PublicHolidayUncheckedCreateInput;
};


export type MutationCreateOneSignatoryArgs = {
  data: SignatoryUncheckedCreateInput;
};


export type MutationCreateOneStatementArgs = {
  data: StatementUncheckedCreateInput;
};


export type MutationCreateOneTransactionArgs = {
  data: TransactionUncheckedCreateInput;
};


export type MutationCreateOneTrusteeArgs = {
  data: TrusteeUncheckedCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserUncheckedCreateInput;
};


export type MutationCreateOrderPaymentsArgs = {
  orderId: Scalars['ID']['input'];
  payments: Array<PaymentInput>;
};


export type MutationCreateOrderSubmissionsArgs = {
  orderId: Scalars['ID']['input'];
  payments: Array<PaymentInput>;
  transactionFormDocumentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSupportTicketArgs = {
  data: SupportCreateInput;
};


export type MutationDeleteOneAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type MutationDeleteOneAccountPortfolioArgs = {
  where: AccountPortfolioWhereUniqueInput;
};


export type MutationDeleteOneAccountRequestArgs = {
  where: AccountRequestWhereUniqueInput;
};


export type MutationDeleteOneAdminRoleArgs = {
  where: AdminRoleWhereUniqueInput;
};


export type MutationDeleteOneAdminUserArgs = {
  where: AdminUserWhereUniqueInput;
};


export type MutationDeleteOneAnnouncementArgs = {
  where: AnnouncementWhereUniqueInput;
};


export type MutationDeleteOneAuditTrailArgs = {
  where: AuditTrailWhereUniqueInput;
};


export type MutationDeleteOneAuthorisedSignatoryArgs = {
  where: AuthorisedSignatoryWhereUniqueInput;
};


export type MutationDeleteOneBankArgs = {
  where: BankWhereUniqueInput;
};


export type MutationDeleteOneBankAccountArgs = {
  where: BankAccountWhereUniqueInput;
};


export type MutationDeleteOneCollectionBankAccountArgs = {
  where: CollectionBankAccountWhereUniqueInput;
};


export type MutationDeleteOneDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type MutationDeleteOneFundArgs = {
  where: FundWhereUniqueInput;
};


export type MutationDeleteOneFundDocumentArgs = {
  where: FundDocumentWhereUniqueInput;
};


export type MutationDeleteOneFundHolidayArgs = {
  where: FundHolidayWhereUniqueInput;
};


export type MutationDeleteOneFundPolicyArgs = {
  where: FundPolicyWhereUniqueInput;
};


export type MutationDeleteOneFundPriceArgs = {
  where: FundPriceWhereUniqueInput;
};


export type MutationDeleteOneModificationArgs = {
  where: ModificationWhereUniqueInput;
};


export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteOneOrderDocumentArgs = {
  where: OrderDocumentWhereUniqueInput;
};


export type MutationDeleteOnePaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type MutationDeleteOneProfileArgs = {
  where: ProfileWhereUniqueInput;
};


export type MutationDeleteOneProfileConsentArgs = {
  where: ProfileConsentWhereUniqueInput;
};


export type MutationDeleteOnePublicHolidayArgs = {
  where: PublicHolidayWhereUniqueInput;
};


export type MutationDeleteOneStatementArgs = {
  where: StatementWhereUniqueInput;
};


export type MutationDeleteOneTransactionArgs = {
  where: TransactionWhereUniqueInput;
};


export type MutationDeleteOneTrusteeArgs = {
  where: TrusteeWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationExportAccountRequestsArgs = {
  orderBy?: InputMaybe<Array<AccountRequestOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountRequestWhereInput>;
};


export type MutationExportAdminUsersArgs = {
  orderBy?: InputMaybe<Array<AdminUserOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AdminUserWhereInput>;
};


export type MutationExportAnnouncementsArgs = {
  orderBy?: InputMaybe<Array<AnnouncementOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type MutationExportAuditTrailsArgs = {
  orderBy?: InputMaybe<Array<AuditTrailOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AuditTrailWhereInput>;
};


export type MutationExportFundHolidaysArgs = {
  orderBy?: InputMaybe<Array<FundHolidayOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundHolidayWhereInput>;
};


export type MutationExportFundsArgs = {
  orderBy?: InputMaybe<Array<FundOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundWhereInput>;
};


export type MutationExportModificationsArgs = {
  orderBy?: InputMaybe<Array<ModificationOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ModificationWhereInput>;
};


export type MutationExportOrdersArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationExportOtpChallengesArgs = {
  orderBy?: InputMaybe<Array<OtpChallengeOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OtpChallengeWhereInput>;
};


export type MutationExportProfileConsentsArgs = {
  orderBy?: InputMaybe<Array<ProfileConsentOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProfileConsentWhereInput>;
};


export type MutationExportPublicHolidaysArgs = {
  orderBy?: InputMaybe<Array<PublicHolidayOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PublicHolidayWhereInput>;
};


export type MutationExportTransactionsArgs = {
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type MutationGeneratePresignedFileArgs = {
  data: GeneratePresignedFileInput;
};


export type MutationGetSignedFileArgs = {
  data: GetSignedFileInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationMarkOrderPendingPaymentVerificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationOnboardCorporateUserArgs = {
  data: OnboardCorporateUserInput;
};


export type MutationRecoverUsernameArgs = {
  data: RecoverUsernameInput;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationRejectModificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRejectOrderArgs = {
  id: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
};


export type MutationRequestOtpArgs = {
  data: RequestOtpInput;
};


export type MutationRequestOtpLoginArgs = {
  data: RequestLoginOtpInput;
};


export type MutationRequestSimpleOtpArgs = {
  data: RequestSimpleOtpInput;
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationSendInvitationCodeToUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSignatoryApproveOrderArgs = {
  documentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  signatoryId: Scalars['String']['input'];
};


export type MutationSignatoryRejectOrderArgs = {
  id: Scalars['String']['input'];
  signatoryId: Scalars['String']['input'];
};


export type MutationSubmitOrderArgs = {
  order?: InputMaybe<OrderInput>;
};


export type MutationSubmitSwitchOrderArgs = {
  order?: InputMaybe<SwitchOrderInput>;
};


export type MutationSubmitWithdrawOrderArgs = {
  order?: InputMaybe<WithdrawOrderInput>;
};


export type MutationTomswinCreateRedemptionArgs = {
  redemption: CreateRedemptionInputArgs;
};


export type MutationTomswinCreateSaleArgs = {
  sale: CreateSaleInputArgs;
};


export type MutationTomswinCreateSwitchingArgs = {
  switching: CreateSwitchingInputArgs;
};


export type MutationTomswinSyncRemoveIndexArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationTomswinSyncResetFileTypeArgs = {
  fileType: Scalars['String']['input'];
};


export type MutationUpdateOneAccountArgs = {
  data: AccountUncheckedUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpdateOneAccountPortfolioArgs = {
  data: AccountPortfolioUncheckedUpdateInput;
  where: AccountPortfolioWhereUniqueInput;
};


export type MutationUpdateOneAccountRequestArgs = {
  data: AccountRequestUncheckedUpdateInput;
  where: AccountRequestWhereUniqueInput;
};


export type MutationUpdateOneAdminRoleArgs = {
  data: AdminRoleUpdateInputV2;
  where: AdminRoleWhereUniqueInput;
};


export type MutationUpdateOneAdminUserArgs = {
  data: AdminUserUpdateInputV2;
  where: AdminUserWhereUniqueInput;
};


export type MutationUpdateOneAnnouncementArgs = {
  data: AnnouncementUncheckedUpdateInput;
  where: AnnouncementWhereUniqueInput;
};


export type MutationUpdateOneAuditTrailArgs = {
  data: AuditTrailUncheckedUpdateInput;
  where: AuditTrailWhereUniqueInput;
};


export type MutationUpdateOneAuthorisedSignatoryArgs = {
  data: AuthorisedSignatoryUncheckedUpdateInput;
  where: AuthorisedSignatoryWhereUniqueInput;
};


export type MutationUpdateOneBankArgs = {
  data: BankUncheckedUpdateInput;
  where: BankWhereUniqueInput;
};


export type MutationUpdateOneBankAccountArgs = {
  data: BankAccountUncheckedUpdateInput;
  where: BankAccountWhereUniqueInput;
};


export type MutationUpdateOneCollectionBankAccountArgs = {
  data: CollectionBankAccountUncheckedUpdateInput;
  where: CollectionBankAccountWhereUniqueInput;
};


export type MutationUpdateOneDocumentArgs = {
  data: DocumentUncheckedUpdateInput;
  where: DocumentWhereUniqueInput;
};


export type MutationUpdateOneFundArgs = {
  data: FundUncheckedUpdateInput;
  where: FundWhereUniqueInput;
};


export type MutationUpdateOneFundDocumentArgs = {
  data: FundDocumentUncheckedUpdateInput;
  where: FundDocumentWhereUniqueInput;
};


export type MutationUpdateOneFundHolidayArgs = {
  data: FundHolidayUncheckedUpdateInput;
  where: FundHolidayWhereUniqueInput;
};


export type MutationUpdateOneFundPolicyArgs = {
  data: FundPolicyUncheckedUpdateInput;
  where: FundPolicyWhereUniqueInput;
};


export type MutationUpdateOneFundPriceArgs = {
  data: FundPriceUncheckedUpdateInput;
  where: FundPriceWhereUniqueInput;
};


export type MutationUpdateOneModificationArgs = {
  data: ModificationUncheckedUpdateInput;
  where: ModificationWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUncheckedUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOneOrderDocumentArgs = {
  data: OrderDocumentUncheckedUpdateInput;
  where: OrderDocumentWhereUniqueInput;
};


export type MutationUpdateOnePaymentArgs = {
  data: PaymentUncheckedUpdateInput;
  where: PaymentWhereUniqueInput;
};


export type MutationUpdateOneProfileArgs = {
  data: ProfileUncheckedUpdateInput;
  where: ProfileWhereUniqueInput;
};


export type MutationUpdateOneProfileConsentArgs = {
  data: ProfileConsentUncheckedUpdateInput;
  where: ProfileConsentWhereUniqueInput;
};


export type MutationUpdateOnePublicHolidayArgs = {
  data: PublicHolidayUncheckedUpdateInput;
  where: PublicHolidayWhereUniqueInput;
};


export type MutationUpdateOneStatementArgs = {
  data: StatementUncheckedUpdateInput;
  where: StatementWhereUniqueInput;
};


export type MutationUpdateOneTransactionArgs = {
  data: TransactionUncheckedUpdateInput;
  where: TransactionWhereUniqueInput;
};


export type MutationUpdateOneTrusteeArgs = {
  data: TrusteeUncheckedUpdateInput;
  where: TrusteeWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUncheckedUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserSecurityImageArgs = {
  securityImageId: Scalars['String']['input'];
};


export type MutationVerifyOtpArgs = {
  data: VerifyOtpInput;
};


export type MutationVerifyOtpLoginArgs = {
  data: VerifyLoginOtpInput;
};


export type MutationVerifySimpleOtpArgs = {
  data: VerifySimpleOtpInput;
};

export type MyAccountSummary = {
  __typename?: 'MyAccountSummary';
  currentMarketValues: Array<AmountValue>;
  fundCategorySummaries: Array<FundCategorySummary>;
  geographicalSummaries: Array<GeographicalSummary>;
  profitAndLossValues: Array<ProfitAndLossValue>;
  totalInvestedValues: Array<AmountValue>;
};

export type MyConsentedProfileSummary = {
  __typename?: 'MyConsentedProfileSummary';
  companyPerformances: Array<CompanyPerformance>;
  currentMarketValues: Array<AmountValue>;
  fundCategorySummaries: Array<FundCategorySummary>;
  geographicalSummaries: Array<GeographicalSummary>;
  profitAndLossValues: Array<ProfitAndLossValue>;
  totalInvestedValues: Array<AmountValue>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBytesFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumAccountStatusFilter = {
  equals?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  not?: InputMaybe<NestedEnumAccountStatusFilter>;
  notIn?: InputMaybe<Array<AccountStatus>>;
};

export type NestedEnumAccountTypeFilter = {
  equals?: InputMaybe<AccountType>;
  in?: InputMaybe<Array<AccountType>>;
  not?: InputMaybe<NestedEnumAccountTypeFilter>;
  notIn?: InputMaybe<Array<AccountType>>;
};

export type NestedEnumActionStatusFilter = {
  equals?: InputMaybe<ActionStatus>;
  in?: InputMaybe<Array<ActionStatus>>;
  not?: InputMaybe<NestedEnumActionStatusFilter>;
  notIn?: InputMaybe<Array<ActionStatus>>;
};

export type NestedEnumAdminUserStatusFilter = {
  equals?: InputMaybe<AdminUserStatus>;
  in?: InputMaybe<Array<AdminUserStatus>>;
  not?: InputMaybe<NestedEnumAdminUserStatusFilter>;
  notIn?: InputMaybe<Array<AdminUserStatus>>;
};

export type NestedEnumAnnouncementStatusFilter = {
  equals?: InputMaybe<AnnouncementStatus>;
  in?: InputMaybe<Array<AnnouncementStatus>>;
  not?: InputMaybe<NestedEnumAnnouncementStatusFilter>;
  notIn?: InputMaybe<Array<AnnouncementStatus>>;
};

export type NestedEnumApprovalStatusFilter = {
  equals?: InputMaybe<ApprovalStatus>;
  in?: InputMaybe<Array<ApprovalStatus>>;
  not?: InputMaybe<NestedEnumApprovalStatusFilter>;
  notIn?: InputMaybe<Array<ApprovalStatus>>;
};

export type NestedEnumAuthorisedSignatoryStatusFilter = {
  equals?: InputMaybe<AuthorisedSignatoryStatus>;
  in?: InputMaybe<Array<AuthorisedSignatoryStatus>>;
  not?: InputMaybe<NestedEnumAuthorisedSignatoryStatusFilter>;
  notIn?: InputMaybe<Array<AuthorisedSignatoryStatus>>;
};

export type NestedEnumBankAccountTypeNullableFilter = {
  equals?: InputMaybe<BankAccountType>;
  in?: InputMaybe<Array<BankAccountType>>;
  not?: InputMaybe<NestedEnumBankAccountTypeNullableFilter>;
  notIn?: InputMaybe<Array<BankAccountType>>;
};

export type NestedEnumBankTypeNullableFilter = {
  equals?: InputMaybe<BankType>;
  in?: InputMaybe<Array<BankType>>;
  not?: InputMaybe<NestedEnumBankTypeNullableFilter>;
  notIn?: InputMaybe<Array<BankType>>;
};

export type NestedEnumConsentStatusFilter = {
  equals?: InputMaybe<ConsentStatus>;
  in?: InputMaybe<Array<ConsentStatus>>;
  not?: InputMaybe<NestedEnumConsentStatusFilter>;
  notIn?: InputMaybe<Array<ConsentStatus>>;
};

export type NestedEnumConsentTypeFilter = {
  equals?: InputMaybe<ConsentType>;
  in?: InputMaybe<Array<ConsentType>>;
  not?: InputMaybe<NestedEnumConsentTypeFilter>;
  notIn?: InputMaybe<Array<ConsentType>>;
};

export type NestedEnumCreationStatusFilter = {
  equals?: InputMaybe<CreationStatus>;
  in?: InputMaybe<Array<CreationStatus>>;
  not?: InputMaybe<NestedEnumCreationStatusFilter>;
  notIn?: InputMaybe<Array<CreationStatus>>;
};

export type NestedEnumFundCategoriesFilter = {
  equals?: InputMaybe<FundCategories>;
  in?: InputMaybe<Array<FundCategories>>;
  not?: InputMaybe<NestedEnumFundCategoriesFilter>;
  notIn?: InputMaybe<Array<FundCategories>>;
};

export type NestedEnumFundManagersNullableFilter = {
  equals?: InputMaybe<FundManagers>;
  in?: InputMaybe<Array<FundManagers>>;
  not?: InputMaybe<NestedEnumFundManagersNullableFilter>;
  notIn?: InputMaybe<Array<FundManagers>>;
};

export type NestedEnumFundRiskProfileFilter = {
  equals?: InputMaybe<FundRiskProfile>;
  in?: InputMaybe<Array<FundRiskProfile>>;
  not?: InputMaybe<NestedEnumFundRiskProfileFilter>;
  notIn?: InputMaybe<Array<FundRiskProfile>>;
};

export type NestedEnumFundStatusFilter = {
  equals?: InputMaybe<FundStatus>;
  in?: InputMaybe<Array<FundStatus>>;
  not?: InputMaybe<NestedEnumFundStatusFilter>;
  notIn?: InputMaybe<Array<FundStatus>>;
};

export type NestedEnumIdTypeFilter = {
  equals?: InputMaybe<IdType>;
  in?: InputMaybe<Array<IdType>>;
  not?: InputMaybe<NestedEnumIdTypeFilter>;
  notIn?: InputMaybe<Array<IdType>>;
};

export type NestedEnumInterfaceFilter = {
  equals?: InputMaybe<Interface>;
  in?: InputMaybe<Array<Interface>>;
  not?: InputMaybe<NestedEnumInterfaceFilter>;
  notIn?: InputMaybe<Array<Interface>>;
};

export type NestedEnumModeOfContactNullableFilter = {
  equals?: InputMaybe<ModeOfContact>;
  in?: InputMaybe<Array<ModeOfContact>>;
  not?: InputMaybe<NestedEnumModeOfContactNullableFilter>;
  notIn?: InputMaybe<Array<ModeOfContact>>;
};

export type NestedEnumModificationEntityTypeFilter = {
  equals?: InputMaybe<ModificationEntityType>;
  in?: InputMaybe<Array<ModificationEntityType>>;
  not?: InputMaybe<NestedEnumModificationEntityTypeFilter>;
  notIn?: InputMaybe<Array<ModificationEntityType>>;
};

export type NestedEnumModificationStatusFilter = {
  equals?: InputMaybe<ModificationStatus>;
  in?: InputMaybe<Array<ModificationStatus>>;
  not?: InputMaybe<NestedEnumModificationStatusFilter>;
  notIn?: InputMaybe<Array<ModificationStatus>>;
};

export type NestedEnumModificationTypeFilter = {
  equals?: InputMaybe<ModificationType>;
  in?: InputMaybe<Array<ModificationType>>;
  not?: InputMaybe<NestedEnumModificationTypeFilter>;
  notIn?: InputMaybe<Array<ModificationType>>;
};

export type NestedEnumOrderDocumentStatusFilter = {
  equals?: InputMaybe<OrderDocumentStatus>;
  in?: InputMaybe<Array<OrderDocumentStatus>>;
  not?: InputMaybe<NestedEnumOrderDocumentStatusFilter>;
  notIn?: InputMaybe<Array<OrderDocumentStatus>>;
};

export type NestedEnumOrderDocumentTypeFilter = {
  equals?: InputMaybe<OrderDocumentType>;
  in?: InputMaybe<Array<OrderDocumentType>>;
  not?: InputMaybe<NestedEnumOrderDocumentTypeFilter>;
  notIn?: InputMaybe<Array<OrderDocumentType>>;
};

export type NestedEnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumOtpFlowFilter = {
  equals?: InputMaybe<OtpFlow>;
  in?: InputMaybe<Array<OtpFlow>>;
  not?: InputMaybe<NestedEnumOtpFlowFilter>;
  notIn?: InputMaybe<Array<OtpFlow>>;
};

export type NestedEnumOtpMethodFilter = {
  equals?: InputMaybe<OtpMethod>;
  in?: InputMaybe<Array<OtpMethod>>;
  not?: InputMaybe<NestedEnumOtpMethodFilter>;
  notIn?: InputMaybe<Array<OtpMethod>>;
};

export type NestedEnumOtpPurposeFilter = {
  equals?: InputMaybe<OtpPurpose>;
  in?: InputMaybe<Array<OtpPurpose>>;
  not?: InputMaybe<NestedEnumOtpPurposeFilter>;
  notIn?: InputMaybe<Array<OtpPurpose>>;
};

export type NestedEnumPaymentMethodFilter = {
  equals?: InputMaybe<PaymentMethod>;
  in?: InputMaybe<Array<PaymentMethod>>;
  not?: InputMaybe<NestedEnumPaymentMethodFilter>;
  notIn?: InputMaybe<Array<PaymentMethod>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumProfileStatusFilter = {
  equals?: InputMaybe<ProfileStatus>;
  in?: InputMaybe<Array<ProfileStatus>>;
  not?: InputMaybe<NestedEnumProfileStatusFilter>;
  notIn?: InputMaybe<Array<ProfileStatus>>;
};

export type NestedEnumRedemptionExtentNullableFilter = {
  equals?: InputMaybe<RedemptionExtent>;
  in?: InputMaybe<Array<RedemptionExtent>>;
  not?: InputMaybe<NestedEnumRedemptionExtentNullableFilter>;
  notIn?: InputMaybe<Array<RedemptionExtent>>;
};

export type NestedEnumRiskProfilesNullableFilter = {
  equals?: InputMaybe<RiskProfiles>;
  in?: InputMaybe<Array<RiskProfiles>>;
  not?: InputMaybe<NestedEnumRiskProfilesNullableFilter>;
  notIn?: InputMaybe<Array<RiskProfiles>>;
};

export type NestedEnumSignatoryProviderFilter = {
  equals?: InputMaybe<SignatoryProvider>;
  in?: InputMaybe<Array<SignatoryProvider>>;
  not?: InputMaybe<NestedEnumSignatoryProviderFilter>;
  notIn?: InputMaybe<Array<SignatoryProvider>>;
};

export type NestedEnumSignatoryStatusFilter = {
  equals?: InputMaybe<SignatoryStatus>;
  in?: InputMaybe<Array<SignatoryStatus>>;
  not?: InputMaybe<NestedEnumSignatoryStatusFilter>;
  notIn?: InputMaybe<Array<SignatoryStatus>>;
};

export type NestedEnumStatementDocumentLocationNullableFilter = {
  equals?: InputMaybe<StatementDocumentLocation>;
  in?: InputMaybe<Array<StatementDocumentLocation>>;
  not?: InputMaybe<NestedEnumStatementDocumentLocationNullableFilter>;
  notIn?: InputMaybe<Array<StatementDocumentLocation>>;
};

export type NestedEnumStatementSourceFilter = {
  equals?: InputMaybe<StatementSource>;
  in?: InputMaybe<Array<StatementSource>>;
  not?: InputMaybe<NestedEnumStatementSourceFilter>;
  notIn?: InputMaybe<Array<StatementSource>>;
};

export type NestedEnumStatementStatusFilter = {
  equals?: InputMaybe<StatementStatus>;
  in?: InputMaybe<Array<StatementStatus>>;
  not?: InputMaybe<NestedEnumStatementStatusFilter>;
  notIn?: InputMaybe<Array<StatementStatus>>;
};

export type NestedEnumStatementSubTypeFilter = {
  equals?: InputMaybe<StatementSubType>;
  in?: InputMaybe<Array<StatementSubType>>;
  not?: InputMaybe<NestedEnumStatementSubTypeFilter>;
  notIn?: InputMaybe<Array<StatementSubType>>;
};

export type NestedEnumStatementTypeFilter = {
  equals?: InputMaybe<StatementType>;
  in?: InputMaybe<Array<StatementType>>;
  not?: InputMaybe<NestedEnumStatementTypeFilter>;
  notIn?: InputMaybe<Array<StatementType>>;
};

export type NestedEnumTomswinSyncBatchStatusFilter = {
  equals?: InputMaybe<TomswinSyncBatchStatus>;
  in?: InputMaybe<Array<TomswinSyncBatchStatus>>;
  not?: InputMaybe<NestedEnumTomswinSyncBatchStatusFilter>;
  notIn?: InputMaybe<Array<TomswinSyncBatchStatus>>;
};

export type NestedEnumTomswinSyncStatusFilter = {
  equals?: InputMaybe<TomswinSyncStatus>;
  in?: InputMaybe<Array<TomswinSyncStatus>>;
  not?: InputMaybe<NestedEnumTomswinSyncStatusFilter>;
  notIn?: InputMaybe<Array<TomswinSyncStatus>>;
};

export type NestedEnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumTransactionTypeFilter = {
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  not?: InputMaybe<NestedEnumTransactionTypeFilter>;
  notIn?: InputMaybe<Array<TransactionType>>;
};

export type NestedEnumUserStatusFilter = {
  equals?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  not?: InputMaybe<NestedEnumUserStatusFilter>;
  notIn?: InputMaybe<Array<UserStatus>>;
};

export type NestedEnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<UserType>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type OnboardCorporateUserInput = {
  email: Scalars['String']['input'];
  otpChallengeCode: Scalars['String']['input'];
  otpChallengeId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  securityImageId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type OnboardedCompanyRow = {
  __typename?: 'OnboardedCompanyRow';
  companyName: Scalars['String']['output'];
  idNo: Scalars['String']['output'];
  onboardedDate: Scalars['DateTime']['output'];
};

export type Order = {
  __typename?: 'Order';
  _count?: Maybe<OrderCount>;
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<OrderDocument>;
  fatcaSignedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  originId?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  referenceNo: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  requireManualProcessing: Scalars['Boolean']['output'];
  signatories: Array<Signatory>;
  status: OrderStatus;
  tocSignedAt?: Maybe<Scalars['DateTime']['output']>;
  transactionType: TransactionType;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};


export type OrderBankAccountArgs = {
  where?: InputMaybe<BankAccountWhereInput>;
};


export type OrderDocumentsArgs = {
  cursor?: InputMaybe<OrderDocumentWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDocumentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDocumentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDocumentWhereInput>;
};


export type OrderPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type OrderSignatoriesArgs = {
  cursor?: InputMaybe<SignatoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<SignatoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SignatoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SignatoryWhereInput>;
};


export type OrderTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};

export type OrderConfigs = {
  __typename?: 'OrderConfigs';
  orderSignatoryEnabled: Scalars['Boolean']['output'];
};

export type OrderCount = {
  __typename?: 'OrderCount';
  documents: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
  signatories: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int']['output'];
  accountMasterAccountNo: Scalars['Int']['output'];
  bankAccountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  fatcaSignedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  originId: Scalars['Int']['output'];
  referenceNo: Scalars['Int']['output'];
  remarks: Scalars['Int']['output'];
  requireManualProcessing: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  tocSignedAt: Scalars['Int']['output'];
  transactionType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedById: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type OrderCreateManyBankAccountInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderCreateManyBankAccountInputEnvelope = {
  data: Array<OrderCreateManyBankAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateNestedManyWithoutBankAccountInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutBankAccountInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutBankAccountInput>>;
  createMany?: InputMaybe<OrderCreateManyBankAccountInputEnvelope>;
};

export type OrderCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<OrderUncheckedCreateWithoutPaymentsInput>;
};

export type OrderCreateNestedOneWithoutSignatoriesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutSignatoriesInput>;
  create?: InputMaybe<OrderUncheckedCreateWithoutSignatoriesInput>;
};

export type OrderCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<OrderUncheckedCreateWithoutTransactionsInput>;
};

export type OrderCreateOrConnectWithoutBankAccountInput = {
  create: OrderUncheckedCreateWithoutBankAccountInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPaymentsInput = {
  create: OrderUncheckedCreateWithoutPaymentsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutSignatoriesInput = {
  create: OrderUncheckedCreateWithoutSignatoriesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutTransactionsInput = {
  create: OrderUncheckedCreateWithoutTransactionsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutBankAccountInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
};

export type OrderDocument = {
  __typename?: 'OrderDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentType: OrderDocumentType;
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  status: OrderDocumentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderDocumentCountAggregate = {
  __typename?: 'OrderDocumentCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  documentId: Scalars['Int']['output'];
  documentType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  referenceId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderDocumentCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType: OrderDocumentType;
  id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentCreateManyOrderInputEnvelope = {
  data: Array<OrderDocumentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderDocumentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDocumentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderDocumentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderDocumentCreateManyOrderInputEnvelope>;
};

export type OrderDocumentCreateOrConnectWithoutOrderInput = {
  create: OrderDocumentUncheckedCreateWithoutOrderInput;
  where: OrderDocumentWhereUniqueInput;
};

export type OrderDocumentCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType: OrderDocumentType;
  id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentListRelationFilter = {
  every?: InputMaybe<OrderDocumentWhereInput>;
  none?: InputMaybe<OrderDocumentWhereInput>;
  some?: InputMaybe<OrderDocumentWhereInput>;
};

export type OrderDocumentMaxAggregate = {
  __typename?: 'OrderDocumentMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<OrderDocumentType>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderDocumentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderDocumentMinAggregate = {
  __typename?: 'OrderDocumentMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<OrderDocumentType>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderDocumentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderDocumentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderDocumentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentId?: InputMaybe<SortOrderInput>;
  documentType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  referenceId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum OrderDocumentScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentId = 'documentId',
  DocumentType = 'documentType',
  Id = 'id',
  OrderId = 'orderId',
  ReferenceId = 'referenceId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type OrderDocumentScalarWhereInput = {
  AND?: InputMaybe<Array<OrderDocumentScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderDocumentScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderDocumentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentId?: InputMaybe<StringNullableFilter>;
  documentType?: InputMaybe<EnumOrderDocumentTypeFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  referenceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderDocumentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum OrderDocumentStatus {
  Completed = 'Completed',
  Declined = 'Declined',
  Pending = 'Pending',
  Sent = 'Sent',
  Voided = 'Voided'
}

export enum OrderDocumentType {
  TransactionForm = 'TransactionForm'
}

export type OrderDocumentUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType: OrderDocumentType;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentUncheckedCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDocumentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderDocumentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderDocumentCreateManyOrderInputEnvelope>;
};

export type OrderDocumentUncheckedCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType: OrderDocumentType;
  id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentUncheckedUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<OrderDocumentType>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentUncheckedUpdateManyWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<OrderDocumentType>;
  id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentUncheckedUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDocumentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderDocumentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderDocumentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderDocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderDocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderDocumentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderDocumentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderDocumentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderDocumentUncheckedUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<OrderDocumentType>;
  id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderDocumentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderDocumentUpdateManyWithWhereWithoutOrderInput = {
  data: OrderDocumentUncheckedUpdateManyWithoutOrderInput;
  where: OrderDocumentScalarWhereInput;
};

export type OrderDocumentUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderDocumentUncheckedUpdateWithoutOrderInput;
  where: OrderDocumentWhereUniqueInput;
};

export type OrderDocumentUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderDocumentUncheckedCreateWithoutOrderInput;
  update: OrderDocumentUncheckedUpdateWithoutOrderInput;
  where: OrderDocumentWhereUniqueInput;
};

export type OrderDocumentWhereInput = {
  AND?: InputMaybe<Array<OrderDocumentWhereInput>>;
  NOT?: InputMaybe<Array<OrderDocumentWhereInput>>;
  OR?: InputMaybe<Array<OrderDocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentId?: InputMaybe<StringNullableFilter>;
  documentType?: InputMaybe<EnumOrderDocumentTypeFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  referenceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderDocumentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderDocumentWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderDocumentWhereInput>>;
  NOT?: InputMaybe<Array<OrderDocumentWhereInput>>;
  OR?: InputMaybe<Array<OrderDocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentId?: InputMaybe<StringNullableFilter>;
  documentType?: InputMaybe<EnumOrderDocumentTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumOrderDocumentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderInput = {
  originId?: InputMaybe<Scalars['String']['input']>;
  payments: Array<PaymentInput>;
  purchaseTransactions: Array<PurchaseTransactionInput>;
  signatories: Array<SignatoryInput>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fatcaSignedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  requireManualProcessing?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<OrderStatus>;
  tocSignedAt?: Maybe<Scalars['DateTime']['output']>;
  transactionType?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fatcaSignedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  requireManualProcessing?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<OrderStatus>;
  tocSignedAt?: Maybe<Scalars['DateTime']['output']>;
  transactionType?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OrderNullableRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  accountMasterAccountNo?: InputMaybe<SortOrderInput>;
  bankAccount?: InputMaybe<BankAccountOrderByWithRelationInput>;
  bankAccountId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  documents?: InputMaybe<OrderDocumentOrderByRelationAggregateInput>;
  fatcaSignedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  originId?: InputMaybe<SortOrderInput>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  referenceNo?: InputMaybe<SortOrder>;
  remarks?: InputMaybe<SortOrderInput>;
  requireManualProcessing?: InputMaybe<SortOrder>;
  signatories?: InputMaybe<SignatoryOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  tocSignedAt?: InputMaybe<SortOrderInput>;
  transactionType?: InputMaybe<SortOrder>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedById?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export enum OrderScalarFieldEnum {
  AccountMasterAccountNo = 'accountMasterAccountNo',
  BankAccountId = 'bankAccountId',
  CreatedAt = 'createdAt',
  FatcaSignedAt = 'fatcaSignedAt',
  Id = 'id',
  OriginId = 'originId',
  ReferenceNo = 'referenceNo',
  Remarks = 'remarks',
  RequireManualProcessing = 'requireManualProcessing',
  Status = 'status',
  TocSignedAt = 'tocSignedAt',
  TransactionType = 'transactionType',
  UpdatedAt = 'updatedAt',
  UpdatedById = 'updatedById',
  UserId = 'userId'
}

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  bankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fatcaSignedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  originId?: InputMaybe<StringNullableFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  requireManualProcessing?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  tocSignedAt?: InputMaybe<DateTimeNullableFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedById?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type OrderStatsAllTime = {
  __typename?: 'OrderStatsAllTime';
  orderStatusRows: Array<CountRow>;
};

export enum OrderStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Created = 'Created',
  Pending = 'Pending',
  PendingOpsConfirmation = 'PendingOpsConfirmation',
  PendingPaymentVerification = 'PendingPaymentVerification',
  PendingSignature = 'PendingSignature',
  PendingSubmission = 'PendingSubmission',
  Rejected = 'Rejected',
  Voided = 'Voided'
}

export type OrderUncheckedCreateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutOrderInput>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderUncheckedCreateNestedManyWithoutBankAccountInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutBankAccountInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutBankAccountInput>>;
  createMany?: InputMaybe<OrderCreateManyBankAccountInputEnvelope>;
};

export type OrderUncheckedCreateWithoutBankAccountInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutOrderInput>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderUncheckedCreateWithoutPaymentsInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderUncheckedCreateWithoutSignatoriesInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutOrderInput>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  transactions?: InputMaybe<TransactionUncheckedCreateNestedManyWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderUncheckedCreateWithoutTransactionsInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedCreateNestedManyWithoutOrderInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutOrderInput>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType: TransactionType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderUncheckedUpdateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedUpdateManyWithoutOrderNestedInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutOrderNestedInput>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderUncheckedUpdateManyWithoutBankAccountInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderUncheckedUpdateManyWithoutBankAccountNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutBankAccountInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutBankAccountInput>>;
  createMany?: InputMaybe<OrderCreateManyBankAccountInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutBankAccountInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutBankAccountInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutBankAccountInput>>;
};

export type OrderUncheckedUpdateWithoutBankAccountInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<OrderDocumentUncheckedUpdateManyWithoutOrderNestedInput>;
  fatcaSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutOrderNestedInput>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  requireManualProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  signatories?: InputMaybe<SignatoryUncheckedUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<OrderStatus>;
  tocSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  transactions?: InputMaybe<TransactionUncheckedUpdateManyWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderUpdateManyWithWhereWithoutBankAccountInput = {
  data: OrderUncheckedUpdateManyWithoutBankAccountInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateWithWhereUniqueWithoutBankAccountInput = {
  data: OrderUncheckedUpdateWithoutBankAccountInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutBankAccountInput = {
  create: OrderUncheckedCreateWithoutBankAccountInput;
  update: OrderUncheckedUpdateWithoutBankAccountInput;
  where: OrderWhereUniqueInput;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  bankAccount?: InputMaybe<BankAccountNullableRelationFilter>;
  bankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documents?: InputMaybe<OrderDocumentListRelationFilter>;
  fatcaSignedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  originId?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  requireManualProcessing?: InputMaybe<BoolFilter>;
  signatories?: InputMaybe<SignatoryListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  tocSignedAt?: InputMaybe<DateTimeNullableFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedById?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  bankAccount?: InputMaybe<BankAccountNullableRelationFilter>;
  bankAccountId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documents?: InputMaybe<OrderDocumentListRelationFilter>;
  fatcaSignedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<StringNullableFilter>;
  requireManualProcessing?: InputMaybe<BoolFilter>;
  signatories?: InputMaybe<SignatoryListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  tocSignedAt?: InputMaybe<DateTimeNullableFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedById?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type OtpChallenge = {
  __typename?: 'OtpChallenge';
  code: Scalars['String']['output'];
  consumer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiredOn: Scalars['DateTime']['output'];
  flow: OtpFlow;
  id: Scalars['ID']['output'];
  mcasVerificationCode?: Maybe<Scalars['String']['output']>;
  method: OtpMethod;
  purpose: OtpPurpose;
  remainingAttempts?: Maybe<Scalars['Int']['output']>;
  retryWaitSeconds: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OtpChallengeAvgAggregate = {
  __typename?: 'OtpChallengeAvgAggregate';
  remainingAttempts?: Maybe<Scalars['Float']['output']>;
};

export type OtpChallengeCountAggregate = {
  __typename?: 'OtpChallengeCountAggregate';
  _all: Scalars['Int']['output'];
  clientIp: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  consumer: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiredOn: Scalars['Int']['output'];
  flow: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mcasVerificationCode: Scalars['Int']['output'];
  method: Scalars['Int']['output'];
  nextRequestOn: Scalars['Int']['output'];
  purpose: Scalars['Int']['output'];
  remainingAttempts: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type OtpChallengeMaxAggregate = {
  __typename?: 'OtpChallengeMaxAggregate';
  clientIp?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiredOn?: Maybe<Scalars['DateTime']['output']>;
  flow?: Maybe<OtpFlow>;
  id?: Maybe<Scalars['String']['output']>;
  mcasVerificationCode?: Maybe<Scalars['String']['output']>;
  method?: Maybe<OtpMethod>;
  nextRequestOn?: Maybe<Scalars['DateTime']['output']>;
  purpose?: Maybe<OtpPurpose>;
  remainingAttempts?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OtpChallengeMinAggregate = {
  __typename?: 'OtpChallengeMinAggregate';
  clientIp?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiredOn?: Maybe<Scalars['DateTime']['output']>;
  flow?: Maybe<OtpFlow>;
  id?: Maybe<Scalars['String']['output']>;
  mcasVerificationCode?: Maybe<Scalars['String']['output']>;
  method?: Maybe<OtpMethod>;
  nextRequestOn?: Maybe<Scalars['DateTime']['output']>;
  purpose?: Maybe<OtpPurpose>;
  remainingAttempts?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OtpChallengeOrderByWithRelationInput = {
  clientIp?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrder>;
  consumer?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  expiredOn?: InputMaybe<SortOrder>;
  flow?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mcasVerificationCode?: InputMaybe<SortOrderInput>;
  method?: InputMaybe<SortOrder>;
  nextRequestOn?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  remainingAttempts?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export type OtpChallengeSumAggregate = {
  __typename?: 'OtpChallengeSumAggregate';
  remainingAttempts?: Maybe<Scalars['Int']['output']>;
};

export type OtpChallengeWhereInput = {
  AND?: InputMaybe<Array<OtpChallengeWhereInput>>;
  NOT?: InputMaybe<Array<OtpChallengeWhereInput>>;
  OR?: InputMaybe<Array<OtpChallengeWhereInput>>;
  clientIp?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringFilter>;
  consumer?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiredOn?: InputMaybe<DateTimeFilter>;
  flow?: InputMaybe<EnumOtpFlowFilter>;
  id?: InputMaybe<StringFilter>;
  mcasVerificationCode?: InputMaybe<StringNullableFilter>;
  method?: InputMaybe<EnumOtpMethodFilter>;
  nextRequestOn?: InputMaybe<DateTimeFilter>;
  purpose?: InputMaybe<EnumOtpPurposeFilter>;
  remainingAttempts?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export enum OtpFlow {
  Code = 'Code',
  Link = 'Link'
}

export enum OtpMethod {
  Email = 'Email',
  Sms = 'SMS'
}

export enum OtpProvider {
  Mcas = 'MCAS'
}

export enum OtpPurpose {
  Login = 'Login',
  PasswordReset = 'PasswordReset',
  Registration = 'Registration'
}

export type PaginatationMetadata = {
  __typename?: 'PaginatationMetadata';
  currentPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAccount = {
  __typename?: 'PaginatedAccount';
  items?: Maybe<Array<Account>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAccountPortfolio = {
  __typename?: 'PaginatedAccountPortfolio';
  items?: Maybe<Array<AccountPortfolio>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAccountRequest = {
  __typename?: 'PaginatedAccountRequest';
  items?: Maybe<Array<AccountRequest>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAdminPermission = {
  __typename?: 'PaginatedAdminPermission';
  items?: Maybe<Array<AdminPermission>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAdminRole = {
  __typename?: 'PaginatedAdminRole';
  items?: Maybe<Array<AdminRole>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAdminUser = {
  __typename?: 'PaginatedAdminUser';
  items?: Maybe<Array<AdminUser>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAnnouncement = {
  __typename?: 'PaginatedAnnouncement';
  items?: Maybe<Array<Announcement>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAuditTrail = {
  __typename?: 'PaginatedAuditTrail';
  items?: Maybe<Array<AuditTrail>>;
  metadata: PaginatationMetadata;
};

export type PaginatedAuthorisedSignatory = {
  __typename?: 'PaginatedAuthorisedSignatory';
  items?: Maybe<Array<AuthorisedSignatory>>;
  metadata: PaginatationMetadata;
};

export type PaginatedBank = {
  __typename?: 'PaginatedBank';
  items?: Maybe<Array<Bank>>;
  metadata: PaginatationMetadata;
};

export type PaginatedCollectionBankAccount = {
  __typename?: 'PaginatedCollectionBankAccount';
  items?: Maybe<Array<CollectionBankAccount>>;
  metadata: PaginatationMetadata;
};

export type PaginatedCombineTransactionDto = {
  __typename?: 'PaginatedCombineTransactionDto';
  items?: Maybe<Array<CombineTransactionDto>>;
  metadata: PaginatationMetadata;
};

export type PaginatedDocument = {
  __typename?: 'PaginatedDocument';
  items?: Maybe<Array<Document>>;
  metadata: PaginatationMetadata;
};

export type PaginatedFund = {
  __typename?: 'PaginatedFund';
  items?: Maybe<Array<Fund>>;
  metadata: PaginatationMetadata;
};

export type PaginatedFundDocument = {
  __typename?: 'PaginatedFundDocument';
  items?: Maybe<Array<FundDocument>>;
  metadata: PaginatationMetadata;
};

export type PaginatedFundHoliday = {
  __typename?: 'PaginatedFundHoliday';
  items?: Maybe<Array<FundHoliday>>;
  metadata: PaginatationMetadata;
};

export type PaginatedFundPolicy = {
  __typename?: 'PaginatedFundPolicy';
  items?: Maybe<Array<FundPolicy>>;
  metadata: PaginatationMetadata;
};

export type PaginatedFundPrice = {
  __typename?: 'PaginatedFundPrice';
  items?: Maybe<Array<FundPrice>>;
  metadata: PaginatationMetadata;
};

export type PaginatedModificationModel = {
  __typename?: 'PaginatedModificationModel';
  items?: Maybe<Array<ModificationModel>>;
  metadata: PaginatationMetadata;
};

export type PaginatedOrder = {
  __typename?: 'PaginatedOrder';
  items?: Maybe<Array<Order>>;
  metadata: PaginatationMetadata;
};

export type PaginatedOrderDocument = {
  __typename?: 'PaginatedOrderDocument';
  items?: Maybe<Array<OrderDocument>>;
  metadata: PaginatationMetadata;
};

export type PaginatedOtpChallenge = {
  __typename?: 'PaginatedOtpChallenge';
  items?: Maybe<Array<OtpChallenge>>;
  metadata: PaginatationMetadata;
};

export type PaginatedPayment = {
  __typename?: 'PaginatedPayment';
  items?: Maybe<Array<Payment>>;
  metadata: PaginatationMetadata;
};

export type PaginatedProfile = {
  __typename?: 'PaginatedProfile';
  items?: Maybe<Array<Profile>>;
  metadata: PaginatationMetadata;
};

export type PaginatedProfileConsent = {
  __typename?: 'PaginatedProfileConsent';
  items?: Maybe<Array<ProfileConsent>>;
  metadata: PaginatationMetadata;
};

export type PaginatedPublicHoliday = {
  __typename?: 'PaginatedPublicHoliday';
  items?: Maybe<Array<PublicHoliday>>;
  metadata: PaginatationMetadata;
};

export type PaginatedSignatory = {
  __typename?: 'PaginatedSignatory';
  items?: Maybe<Array<Signatory>>;
  metadata: PaginatationMetadata;
};

export type PaginatedStatement = {
  __typename?: 'PaginatedStatement';
  items?: Maybe<Array<Statement>>;
  metadata: PaginatationMetadata;
};

export type PaginatedTomswinSync = {
  __typename?: 'PaginatedTomswinSync';
  items?: Maybe<Array<TomswinSync>>;
  metadata: PaginatationMetadata;
};

export type PaginatedTomswinSyncBatch = {
  __typename?: 'PaginatedTomswinSyncBatch';
  items?: Maybe<Array<TomswinSyncBatch>>;
  metadata: PaginatationMetadata;
};

export type PaginatedTransaction = {
  __typename?: 'PaginatedTransaction';
  items?: Maybe<Array<Transaction>>;
  metadata: PaginatationMetadata;
};

export type PaginatedTrustee = {
  __typename?: 'PaginatedTrustee';
  items?: Maybe<Array<Trustee>>;
  metadata: PaginatationMetadata;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  items?: Maybe<Array<User>>;
  metadata: PaginatationMetadata;
};

export type PartitionedSeqNumberAvgAggregate = {
  __typename?: 'PartitionedSeqNumberAvgAggregate';
  seqNumber?: Maybe<Scalars['Float']['output']>;
};

export type PartitionedSeqNumberCountAggregate = {
  __typename?: 'PartitionedSeqNumberCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partitionKey: Scalars['Int']['output'];
  seqNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PartitionedSeqNumberMaxAggregate = {
  __typename?: 'PartitionedSeqNumberMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partitionKey?: Maybe<Scalars['String']['output']>;
  seqNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartitionedSeqNumberMinAggregate = {
  __typename?: 'PartitionedSeqNumberMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partitionKey?: Maybe<Scalars['String']['output']>;
  seqNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartitionedSeqNumberSumAggregate = {
  __typename?: 'PartitionedSeqNumberSumAggregate';
  seqNumber?: Maybe<Scalars['Int']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  _count?: Maybe<PaymentCount>;
  amount: Scalars['Decimal']['output'];
  collectionBankAccount?: Maybe<CollectionBankAccount>;
  collectionBankAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  externalReferenceNo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  paymentProof?: Maybe<Scalars['String']['output']>;
  paymentProofId?: Maybe<Scalars['String']['output']>;
  referenceNo: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  transactedAt: Scalars['DateTime']['output'];
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PaymentCollectionBankAccountArgs = {
  where?: InputMaybe<CollectionBankAccountWhereInput>;
};


export type PaymentTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};

export type PaymentAvgAggregate = {
  __typename?: 'PaymentAvgAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  amount: Scalars['Float']['output'];
  metadata: PaymentConfigMetadata;
  paymentProvider: Scalars['String']['output'];
};

export type PaymentConfigMetadata = {
  __typename?: 'PaymentConfigMetadata';
  accountNo: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  beneficiaryName: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  fundNames: Array<Scalars['String']['output']>;
};

export type PaymentCount = {
  __typename?: 'PaymentCount';
  transactions: Scalars['Int']['output'];
};

export type PaymentCountAggregate = {
  __typename?: 'PaymentCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  collectionBankAccountNo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  externalReferenceNo: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  paymentMethod: Scalars['Int']['output'];
  paymentProofId: Scalars['Int']['output'];
  referenceNo: Scalars['Int']['output'];
  remarks: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  transactedAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PaymentCreateManyCollectionBankAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateManyCollectionBankAccountInputEnvelope = {
  data: Array<PaymentCreateManyCollectionBankAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateManyOrderInput = {
  amount: Scalars['Decimal']['input'];
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateManyOrderInputEnvelope = {
  data: Array<PaymentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaymentCreateManyOrderInputEnvelope>;
};

export type PaymentCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<PaymentUncheckedCreateWithoutTransactionsInput>;
};

export type PaymentCreateOrConnectWithoutCollectionBankAccountInput = {
  create: PaymentUncheckedCreateWithoutCollectionBankAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutOrderInput = {
  create: PaymentUncheckedCreateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutTransactionsInput = {
  create: PaymentUncheckedCreateWithoutTransactionsInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutCollectionBankAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutPaymentsInput;
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateWithoutOrderInput = {
  amount: Scalars['Decimal']['input'];
  collectionBankAccount?: InputMaybe<CollectionBankAccountCreateNestedOneWithoutPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  paymentMethod: CorporatePaymentMethod;
  paymentProofDocumentId?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['DateTime']['input'];
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMaxAggregate = {
  __typename?: 'PaymentMaxAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  collectionBankAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  externalReferenceNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentProofId?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  transactedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentMethod {
  BankCheque = 'BankCheque',
  Fpx = 'FPX',
  OnlineBanking = 'OnlineBanking',
  OnlineTransfer = 'OnlineTransfer',
  TelegraphicTransfer = 'TelegraphicTransfer'
}

export type PaymentMinAggregate = {
  __typename?: 'PaymentMinAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  collectionBankAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  externalReferenceNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentProofId?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  transactedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentNullableRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountOrderByWithRelationInput>;
  collectionBankAccountNo?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  externalReferenceNo?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  paymentMethod?: InputMaybe<SortOrder>;
  paymentProofId?: InputMaybe<SortOrderInput>;
  referenceNo?: InputMaybe<SortOrder>;
  remarks?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  transactedAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentScalarFieldEnum {
  Amount = 'amount',
  CollectionBankAccountNo = 'collectionBankAccountNo',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  ExternalReferenceNo = 'externalReferenceNo',
  Id = 'id',
  OrderId = 'orderId',
  PaymentMethod = 'paymentMethod',
  PaymentProofId = 'paymentProofId',
  ReferenceNo = 'referenceNo',
  Remarks = 'remarks',
  Status = 'status',
  TransactedAt = 'transactedAt',
  UpdatedAt = 'updatedAt'
}

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  collectionBankAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  externalReferenceNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethod?: InputMaybe<EnumPaymentMethodFilter>;
  paymentProofId?: InputMaybe<StringNullableFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  transactedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PaymentStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type PaymentSumAggregate = {
  __typename?: 'PaymentSumAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentUncheckedCreateInput = {
  amount: Scalars['Decimal']['input'];
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedCreateNestedManyWithoutCollectionBankAccountInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCollectionBankAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCollectionBankAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyCollectionBankAccountInputEnvelope>;
};

export type PaymentUncheckedCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaymentCreateManyOrderInputEnvelope>;
};

export type PaymentUncheckedCreateWithoutCollectionBankAccountInput = {
  amount: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedCreateWithoutOrderInput = {
  amount: Scalars['Decimal']['input'];
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedCreateWithoutTransactionsInput = {
  amount: Scalars['Decimal']['input'];
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateManyWithoutCollectionBankAccountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateManyWithoutCollectionBankAccountNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCollectionBankAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCollectionBankAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyCollectionBankAccountInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutCollectionBankAccountInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutCollectionBankAccountInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutCollectionBankAccountInput>>;
};

export type PaymentUncheckedUpdateManyWithoutOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaymentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type PaymentUncheckedUpdateWithoutCollectionBankAccountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateWithoutOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  collectionBankAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProofId?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUpdateManyWithWhereWithoutCollectionBankAccountInput = {
  data: PaymentUncheckedUpdateManyWithoutCollectionBankAccountInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutOrderInput = {
  data: PaymentUncheckedUpdateManyWithoutOrderInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateWithWhereUniqueWithoutCollectionBankAccountInput = {
  data: PaymentUncheckedUpdateWithoutCollectionBankAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutOrderInput = {
  data: PaymentUncheckedUpdateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutCollectionBankAccountInput = {
  create: PaymentUncheckedCreateWithoutCollectionBankAccountInput;
  update: PaymentUncheckedUpdateWithoutCollectionBankAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutOrderInput = {
  create: PaymentUncheckedCreateWithoutOrderInput;
  update: PaymentUncheckedUpdateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountNullableRelationFilter>;
  collectionBankAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  externalReferenceNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethod?: InputMaybe<EnumPaymentMethodFilter>;
  paymentProofId?: InputMaybe<StringNullableFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  transactedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  collectionBankAccount?: InputMaybe<CollectionBankAccountNullableRelationFilter>;
  collectionBankAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  externalReferenceNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethod?: InputMaybe<EnumPaymentMethodFilter>;
  paymentProofId?: InputMaybe<StringNullableFilter>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  transactedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PermissionGrant = {
  __typename?: 'PermissionGrant';
  action: Scalars['String']['output'];
  code: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type ProcessFlow = {
  __typename?: 'ProcessFlow';
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  _count?: Maybe<ProfileCount>;
  accounts: Array<Account>;
  amlSanctionScreeningPoint?: Maybe<Scalars['Int']['output']>;
  annualIncome?: Maybe<Scalars['Decimal']['output']>;
  authorisedSignatories: Array<AuthorisedSignatory>;
  bankAccounts: Array<BankAccount>;
  bankDetails?: Maybe<Array<BankDetails>>;
  bumiputera?: Maybe<Scalars['Boolean']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  businessCategoryDisplay?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  cityOfBirth?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyAddresses?: Maybe<CompanyAddresses>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonEmail2?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo2?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  contactPersonName2?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo2?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  declaration: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  employmentStatus?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  estimatedNetWorth?: Maybe<Scalars['Decimal']['output']>;
  expectedInvestmentAmount?: Maybe<Scalars['Decimal']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  frequencyOfTransaction?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  highNetWorth?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  idExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  idNo: Scalars['String']['output'];
  idType: IdType;
  issuedConsents: Array<ProfileConsent>;
  jobIndustry?: Maybe<Scalars['String']['output']>;
  mailingAddress: Scalars['String']['output'];
  maritalStatus?: Maybe<Scalars['String']['output']>;
  marketingPush: Scalars['Boolean']['output'];
  monthlyIncome?: Maybe<Scalars['Decimal']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  natureOfBusiness?: Maybe<Scalars['String']['output']>;
  natureOfBusinessDisplay?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  officePhoneNo?: Maybe<Scalars['String']['output']>;
  permanentAddress: Scalars['String']['output'];
  phoneNo: Scalars['String']['output'];
  politicalExposedPerson?: Maybe<Scalars['Boolean']['output']>;
  postcode: Scalars['String']['output'];
  profession?: Maybe<Scalars['String']['output']>;
  prominentRole?: Maybe<Scalars['Boolean']['output']>;
  purposeOfInvestment?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  receivedConsents: Array<ProfileConsent>;
  religion?: Maybe<Scalars['String']['output']>;
  riskProfile?: Maybe<RiskProfiles>;
  riskProfileAttachment?: Maybe<Scalars['String']['output']>;
  riskProfileAttachmentId?: Maybe<Scalars['String']['output']>;
  riskProfileUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  safRating?: Maybe<Scalars['Int']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  sourceOfFund?: Maybe<Scalars['String']['output']>;
  sourceOfFundDisplay?: Maybe<Scalars['String']['output']>;
  sourceOfWealth?: Maybe<Scalars['String']['output']>;
  sourceOfWealthDisplay?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  statements: Array<Statement>;
  status: ProfileStatus;
  taxResidency?: Maybe<Scalars['String']['output']>;
  type: AccountType;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};


export type ProfileAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type ProfileAuthorisedSignatoriesArgs = {
  cursor?: InputMaybe<AuthorisedSignatoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuthorisedSignatoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuthorisedSignatoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorisedSignatoryWhereInput>;
};


export type ProfileBankAccountsArgs = {
  cursor?: InputMaybe<BankAccountWhereUniqueInput>;
  distinct?: InputMaybe<Array<BankAccountScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BankAccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BankAccountWhereInput>;
};


export type ProfileIssuedConsentsArgs = {
  cursor?: InputMaybe<ProfileConsentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProfileConsentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProfileConsentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileConsentWhereInput>;
};


export type ProfileReceivedConsentsArgs = {
  cursor?: InputMaybe<ProfileConsentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProfileConsentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProfileConsentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileConsentWhereInput>;
};


export type ProfileStatementsArgs = {
  cursor?: InputMaybe<StatementWhereUniqueInput>;
  distinct?: InputMaybe<Array<StatementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StatementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StatementWhereInput>;
};


export type ProfileUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type ProfileAvgAggregate = {
  __typename?: 'ProfileAvgAggregate';
  amlSanctionScreeningPoint?: Maybe<Scalars['Float']['output']>;
  annualIncome?: Maybe<Scalars['Decimal']['output']>;
  estimatedNetWorth?: Maybe<Scalars['Decimal']['output']>;
  expectedInvestmentAmount?: Maybe<Scalars['Decimal']['output']>;
  monthlyIncome?: Maybe<Scalars['Decimal']['output']>;
  safRating?: Maybe<Scalars['Float']['output']>;
};

export type ProfileConsent = {
  __typename?: 'ProfileConsent';
  approvedEmail?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  consentType: ConsentType;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issuerProfile?: Maybe<Profile>;
  issuerProfileId?: Maybe<Scalars['String']['output']>;
  recipientProfile?: Maybe<Profile>;
  recipientProfileId?: Maybe<Scalars['String']['output']>;
  status: ConsentStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type ProfileConsentIssuerProfileArgs = {
  where?: InputMaybe<ProfileWhereInput>;
};


export type ProfileConsentRecipientProfileArgs = {
  where?: InputMaybe<ProfileWhereInput>;
};

export type ProfileConsentCountAggregate = {
  __typename?: 'ProfileConsentCountAggregate';
  _all: Scalars['Int']['output'];
  approvedEmail: Scalars['Int']['output'];
  attachmentId: Scalars['Int']['output'];
  consentType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  issuerProfileId: Scalars['Int']['output'];
  recipientProfileId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProfileConsentCreateManyIssuerProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipientProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentCreateManyIssuerProfileInputEnvelope = {
  data: Array<ProfileConsentCreateManyIssuerProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileConsentCreateManyRecipientProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentCreateManyRecipientProfileInputEnvelope = {
  data: Array<ProfileConsentCreateManyRecipientProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileConsentCreateNestedManyWithoutIssuerProfileInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutIssuerProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutIssuerProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyIssuerProfileInputEnvelope>;
};

export type ProfileConsentCreateNestedManyWithoutRecipientProfileInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutRecipientProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutRecipientProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyRecipientProfileInputEnvelope>;
};

export type ProfileConsentCreateOrConnectWithoutIssuerProfileInput = {
  create: ProfileConsentUncheckedCreateWithoutIssuerProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentCreateOrConnectWithoutRecipientProfileInput = {
  create: ProfileConsentUncheckedCreateWithoutRecipientProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentCreateWithoutIssuerProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipientProfile?: InputMaybe<ProfileCreateNestedOneWithoutReceivedConsentsInput>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentCreateWithoutRecipientProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfile?: InputMaybe<ProfileCreateNestedOneWithoutIssuedConsentsInput>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentListRelationFilter = {
  every?: InputMaybe<ProfileConsentWhereInput>;
  none?: InputMaybe<ProfileConsentWhereInput>;
  some?: InputMaybe<ProfileConsentWhereInput>;
};

export type ProfileConsentMaxAggregate = {
  __typename?: 'ProfileConsentMaxAggregate';
  approvedEmail?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  consentType?: Maybe<ConsentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuerProfileId?: Maybe<Scalars['String']['output']>;
  recipientProfileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConsentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileConsentMinAggregate = {
  __typename?: 'ProfileConsentMinAggregate';
  approvedEmail?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  consentType?: Maybe<ConsentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuerProfileId?: Maybe<Scalars['String']['output']>;
  recipientProfileId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConsentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileConsentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProfileConsentOrderByWithRelationInput = {
  approvedEmail?: InputMaybe<SortOrderInput>;
  attachmentId?: InputMaybe<SortOrderInput>;
  consentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  issuerProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  issuerProfileId?: InputMaybe<SortOrderInput>;
  recipientProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  recipientProfileId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProfileConsentScalarFieldEnum {
  ApprovedEmail = 'approvedEmail',
  AttachmentId = 'attachmentId',
  ConsentType = 'consentType',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IssuerProfileId = 'issuerProfileId',
  RecipientProfileId = 'recipientProfileId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ProfileConsentScalarWhereInput = {
  AND?: InputMaybe<Array<ProfileConsentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProfileConsentScalarWhereInput>>;
  OR?: InputMaybe<Array<ProfileConsentScalarWhereInput>>;
  approvedEmail?: InputMaybe<StringNullableFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  consentType?: InputMaybe<EnumConsentTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  id?: InputMaybe<StringFilter>;
  issuerProfileId?: InputMaybe<StringNullableFilter>;
  recipientProfileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumConsentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProfileConsentUncheckedCreateInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<CreateOneDocumentInput>;
  consentType: ConsentType;
  issuerId: Scalars['String']['input'];
  recipientId: Scalars['String']['input'];
};

export type ProfileConsentUncheckedCreateNestedManyWithoutIssuerProfileInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutIssuerProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutIssuerProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyIssuerProfileInputEnvelope>;
};

export type ProfileConsentUncheckedCreateNestedManyWithoutRecipientProfileInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutRecipientProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutRecipientProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyRecipientProfileInputEnvelope>;
};

export type ProfileConsentUncheckedCreateWithoutIssuerProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipientProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedCreateWithoutRecipientProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType: ConsentType;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedUpdateInput = {
  attachment?: InputMaybe<CreateOneDocumentInput>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedUpdateManyWithoutIssuerProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ConsentType>;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipientProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedUpdateManyWithoutIssuerProfileNestedInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutIssuerProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutIssuerProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyIssuerProfileInputEnvelope>;
  delete?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProfileConsentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  set?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  update?: InputMaybe<Array<ProfileConsentUpdateWithWhereUniqueWithoutIssuerProfileInput>>;
  updateMany?: InputMaybe<Array<ProfileConsentUpdateManyWithWhereWithoutIssuerProfileInput>>;
  upsert?: InputMaybe<Array<ProfileConsentUpsertWithWhereUniqueWithoutIssuerProfileInput>>;
};

export type ProfileConsentUncheckedUpdateManyWithoutRecipientProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ConsentType>;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedUpdateManyWithoutRecipientProfileNestedInput = {
  connect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileConsentCreateOrConnectWithoutRecipientProfileInput>>;
  create?: InputMaybe<Array<ProfileConsentCreateWithoutRecipientProfileInput>>;
  createMany?: InputMaybe<ProfileConsentCreateManyRecipientProfileInputEnvelope>;
  delete?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProfileConsentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  set?: InputMaybe<Array<ProfileConsentWhereUniqueInput>>;
  update?: InputMaybe<Array<ProfileConsentUpdateWithWhereUniqueWithoutRecipientProfileInput>>;
  updateMany?: InputMaybe<Array<ProfileConsentUpdateManyWithWhereWithoutRecipientProfileInput>>;
  upsert?: InputMaybe<Array<ProfileConsentUpsertWithWhereUniqueWithoutRecipientProfileInput>>;
};

export type ProfileConsentUncheckedUpdateWithoutIssuerProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ConsentType>;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipientProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUncheckedUpdateWithoutRecipientProfileInput = {
  approvedEmail?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ConsentType>;
  creationStatus?: InputMaybe<CreationStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfileId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsentStatus>;
};

export type ProfileConsentUpdateManyWithWhereWithoutIssuerProfileInput = {
  data: ProfileConsentUncheckedUpdateManyWithoutIssuerProfileInput;
  where: ProfileConsentScalarWhereInput;
};

export type ProfileConsentUpdateManyWithWhereWithoutRecipientProfileInput = {
  data: ProfileConsentUncheckedUpdateManyWithoutRecipientProfileInput;
  where: ProfileConsentScalarWhereInput;
};

export type ProfileConsentUpdateWithWhereUniqueWithoutIssuerProfileInput = {
  data: ProfileConsentUncheckedUpdateWithoutIssuerProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentUpdateWithWhereUniqueWithoutRecipientProfileInput = {
  data: ProfileConsentUncheckedUpdateWithoutRecipientProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentUpsertWithWhereUniqueWithoutIssuerProfileInput = {
  create: ProfileConsentUncheckedCreateWithoutIssuerProfileInput;
  update: ProfileConsentUncheckedUpdateWithoutIssuerProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentUpsertWithWhereUniqueWithoutRecipientProfileInput = {
  create: ProfileConsentUncheckedCreateWithoutRecipientProfileInput;
  update: ProfileConsentUncheckedUpdateWithoutRecipientProfileInput;
  where: ProfileConsentWhereUniqueInput;
};

export type ProfileConsentWhereInput = {
  AND?: InputMaybe<Array<ProfileConsentWhereInput>>;
  NOT?: InputMaybe<Array<ProfileConsentWhereInput>>;
  OR?: InputMaybe<Array<ProfileConsentWhereInput>>;
  approvedEmail?: InputMaybe<StringNullableFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  consentType?: InputMaybe<EnumConsentTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  id?: InputMaybe<StringFilter>;
  issuerProfile?: InputMaybe<ProfileNullableRelationFilter>;
  issuerProfileId?: InputMaybe<StringNullableFilter>;
  recipientProfile?: InputMaybe<ProfileNullableRelationFilter>;
  recipientProfileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumConsentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProfileConsentWhereUniqueInput = {
  AND?: InputMaybe<Array<ProfileConsentWhereInput>>;
  NOT?: InputMaybe<Array<ProfileConsentWhereInput>>;
  OR?: InputMaybe<Array<ProfileConsentWhereInput>>;
  approvedEmail?: InputMaybe<StringNullableFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  consentType?: InputMaybe<EnumConsentTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  issuerProfile?: InputMaybe<ProfileNullableRelationFilter>;
  issuerProfileId?: InputMaybe<StringNullableFilter>;
  recipientProfile?: InputMaybe<ProfileNullableRelationFilter>;
  recipientProfileId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumConsentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProfileCount = {
  __typename?: 'ProfileCount';
  accounts: Scalars['Int']['output'];
  authorisedSignatories: Scalars['Int']['output'];
  bankAccounts: Scalars['Int']['output'];
  issuedConsents: Scalars['Int']['output'];
  receivedConsents: Scalars['Int']['output'];
  statements: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type ProfileCountAggregate = {
  __typename?: 'ProfileCountAggregate';
  _all: Scalars['Int']['output'];
  amlSanctionScreeningPoint: Scalars['Int']['output'];
  annualIncome: Scalars['Int']['output'];
  bumiputera: Scalars['Int']['output'];
  businessCategory: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  cityOfBirth: Scalars['Int']['output'];
  companyAddress: Scalars['Int']['output'];
  companyName: Scalars['Int']['output'];
  contactPersonEmail: Scalars['Int']['output'];
  contactPersonEmail2: Scalars['Int']['output'];
  contactPersonHpNo: Scalars['Int']['output'];
  contactPersonHpNo2: Scalars['Int']['output'];
  contactPersonName: Scalars['Int']['output'];
  contactPersonName2: Scalars['Int']['output'];
  contactPersonTelNo: Scalars['Int']['output'];
  contactPersonTelNo2: Scalars['Int']['output'];
  countryOfBirth: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  dateOfBirth: Scalars['Int']['output'];
  declaration: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  employmentStatus: Scalars['Int']['output'];
  employmentType: Scalars['Int']['output'];
  estimatedNetWorth: Scalars['Int']['output'];
  expectedInvestmentAmount: Scalars['Int']['output'];
  faxNo: Scalars['Int']['output'];
  frequencyOfTransaction: Scalars['Int']['output'];
  fullName: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  highNetWorth: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idExpiryDate: Scalars['Int']['output'];
  idNo: Scalars['Int']['output'];
  idType: Scalars['Int']['output'];
  jobIndustry: Scalars['Int']['output'];
  mailingAddress: Scalars['Int']['output'];
  maritalStatus: Scalars['Int']['output'];
  marketingPush: Scalars['Int']['output'];
  monthlyIncome: Scalars['Int']['output'];
  mothersMaidenName: Scalars['Int']['output'];
  nationality: Scalars['Int']['output'];
  natureOfBusiness: Scalars['Int']['output'];
  occupation: Scalars['Int']['output'];
  officePhoneNo: Scalars['Int']['output'];
  permanentAddress: Scalars['Int']['output'];
  phoneNo: Scalars['Int']['output'];
  politicalExposedPerson: Scalars['Int']['output'];
  postcode: Scalars['Int']['output'];
  profession: Scalars['Int']['output'];
  prominentRole: Scalars['Int']['output'];
  purposeOfInvestment: Scalars['Int']['output'];
  race: Scalars['Int']['output'];
  religion: Scalars['Int']['output'];
  riskProfile: Scalars['Int']['output'];
  riskProfileAttachmentId: Scalars['Int']['output'];
  riskProfileUpdatedAt: Scalars['Int']['output'];
  safRating: Scalars['Int']['output'];
  salutation: Scalars['Int']['output'];
  sourceOfFund: Scalars['Int']['output'];
  sourceOfWealth: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  taxResidency: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProfileCreateNestedOneWithoutBankAccountsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutBankAccountsInput>;
  create?: InputMaybe<ProfileUncheckedCreateWithoutBankAccountsInput>;
};

export type ProfileCreateNestedOneWithoutIssuedConsentsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutIssuedConsentsInput>;
  create?: InputMaybe<ProfileUncheckedCreateWithoutIssuedConsentsInput>;
};

export type ProfileCreateNestedOneWithoutReceivedConsentsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfileCreateOrConnectWithoutReceivedConsentsInput>;
  create?: InputMaybe<ProfileUncheckedCreateWithoutReceivedConsentsInput>;
};

export type ProfileCreateOrConnectWithoutBankAccountsInput = {
  create: ProfileUncheckedCreateWithoutBankAccountsInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutIssuedConsentsInput = {
  create: ProfileUncheckedCreateWithoutIssuedConsentsInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutReceivedConsentsInput = {
  create: ProfileUncheckedCreateWithoutReceivedConsentsInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateOrConnectWithoutUsersInput = {
  create: ProfileUncheckedCreateWithoutUsersInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileCreateWithoutUsersInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryCreateNestedManyWithoutCompanyProfileInput>;
  bankAccounts?: InputMaybe<BankAccountCreateNestedManyWithoutProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  issuedConsents?: InputMaybe<ProfileConsentCreateNestedManyWithoutIssuerProfileInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentCreateNestedManyWithoutRecipientProfileInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
};

export type ProfileListRelationFilter = {
  every?: InputMaybe<ProfileWhereInput>;
  none?: InputMaybe<ProfileWhereInput>;
  some?: InputMaybe<ProfileWhereInput>;
};

export type ProfileMaxAggregate = {
  __typename?: 'ProfileMaxAggregate';
  amlSanctionScreeningPoint?: Maybe<Scalars['Int']['output']>;
  annualIncome?: Maybe<Scalars['Decimal']['output']>;
  bumiputera?: Maybe<Scalars['Boolean']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityOfBirth?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonEmail2?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo2?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  contactPersonName2?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo2?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  declaration?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  estimatedNetWorth?: Maybe<Scalars['Decimal']['output']>;
  expectedInvestmentAmount?: Maybe<Scalars['Decimal']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  frequencyOfTransaction?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  highNetWorth?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<IdType>;
  jobIndustry?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  marketingPush?: Maybe<Scalars['Boolean']['output']>;
  monthlyIncome?: Maybe<Scalars['Decimal']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  natureOfBusiness?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  officePhoneNo?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  politicalExposedPerson?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  prominentRole?: Maybe<Scalars['Boolean']['output']>;
  purposeOfInvestment?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  riskProfile?: Maybe<RiskProfiles>;
  riskProfileAttachmentId?: Maybe<Scalars['String']['output']>;
  riskProfileUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  safRating?: Maybe<Scalars['Int']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  sourceOfFund?: Maybe<Scalars['String']['output']>;
  sourceOfWealth?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProfileStatus>;
  taxResidency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileMinAggregate = {
  __typename?: 'ProfileMinAggregate';
  amlSanctionScreeningPoint?: Maybe<Scalars['Int']['output']>;
  annualIncome?: Maybe<Scalars['Decimal']['output']>;
  bumiputera?: Maybe<Scalars['Boolean']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityOfBirth?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonEmail2?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo?: Maybe<Scalars['String']['output']>;
  contactPersonHpNo2?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  contactPersonName2?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo?: Maybe<Scalars['String']['output']>;
  contactPersonTelNo2?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  declaration?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  estimatedNetWorth?: Maybe<Scalars['Decimal']['output']>;
  expectedInvestmentAmount?: Maybe<Scalars['Decimal']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  frequencyOfTransaction?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  highNetWorth?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  idNo?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<IdType>;
  jobIndustry?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  marketingPush?: Maybe<Scalars['Boolean']['output']>;
  monthlyIncome?: Maybe<Scalars['Decimal']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  natureOfBusiness?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  officePhoneNo?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  politicalExposedPerson?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  prominentRole?: Maybe<Scalars['Boolean']['output']>;
  purposeOfInvestment?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  riskProfile?: Maybe<RiskProfiles>;
  riskProfileAttachmentId?: Maybe<Scalars['String']['output']>;
  riskProfileUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  safRating?: Maybe<Scalars['Int']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  sourceOfFund?: Maybe<Scalars['String']['output']>;
  sourceOfWealth?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProfileStatus>;
  taxResidency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileNullableRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export type ProfileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProfileOrderByWithRelationInput = {
  accounts?: InputMaybe<AccountOrderByRelationAggregateInput>;
  amlSanctionScreeningPoint?: InputMaybe<SortOrderInput>;
  annualIncome?: InputMaybe<SortOrderInput>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryOrderByRelationAggregateInput>;
  bankAccounts?: InputMaybe<BankAccountOrderByRelationAggregateInput>;
  bumiputera?: InputMaybe<SortOrderInput>;
  businessCategory?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrder>;
  cityOfBirth?: InputMaybe<SortOrderInput>;
  companyAddress?: InputMaybe<SortOrderInput>;
  companyName?: InputMaybe<SortOrderInput>;
  contactPersonEmail?: InputMaybe<SortOrderInput>;
  contactPersonEmail2?: InputMaybe<SortOrderInput>;
  contactPersonHpNo?: InputMaybe<SortOrderInput>;
  contactPersonHpNo2?: InputMaybe<SortOrderInput>;
  contactPersonName?: InputMaybe<SortOrderInput>;
  contactPersonName2?: InputMaybe<SortOrderInput>;
  contactPersonTelNo?: InputMaybe<SortOrderInput>;
  contactPersonTelNo2?: InputMaybe<SortOrderInput>;
  countryOfBirth?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrderInput>;
  declaration?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employmentStatus?: InputMaybe<SortOrderInput>;
  employmentType?: InputMaybe<SortOrderInput>;
  estimatedNetWorth?: InputMaybe<SortOrderInput>;
  expectedInvestmentAmount?: InputMaybe<SortOrderInput>;
  faxNo?: InputMaybe<SortOrderInput>;
  frequencyOfTransaction?: InputMaybe<SortOrderInput>;
  fullName?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  highNetWorth?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  idExpiryDate?: InputMaybe<SortOrderInput>;
  idNo?: InputMaybe<SortOrder>;
  idType?: InputMaybe<SortOrder>;
  issuedConsents?: InputMaybe<ProfileConsentOrderByRelationAggregateInput>;
  jobIndustry?: InputMaybe<SortOrderInput>;
  mailingAddress?: InputMaybe<SortOrder>;
  maritalStatus?: InputMaybe<SortOrderInput>;
  marketingPush?: InputMaybe<SortOrder>;
  monthlyIncome?: InputMaybe<SortOrderInput>;
  mothersMaidenName?: InputMaybe<SortOrderInput>;
  nationality?: InputMaybe<SortOrderInput>;
  natureOfBusiness?: InputMaybe<SortOrderInput>;
  occupation?: InputMaybe<SortOrderInput>;
  officePhoneNo?: InputMaybe<SortOrderInput>;
  permanentAddress?: InputMaybe<SortOrder>;
  phoneNo?: InputMaybe<SortOrder>;
  politicalExposedPerson?: InputMaybe<SortOrderInput>;
  postcode?: InputMaybe<SortOrder>;
  profession?: InputMaybe<SortOrderInput>;
  prominentRole?: InputMaybe<SortOrderInput>;
  purposeOfInvestment?: InputMaybe<SortOrderInput>;
  race?: InputMaybe<SortOrderInput>;
  receivedConsents?: InputMaybe<ProfileConsentOrderByRelationAggregateInput>;
  religion?: InputMaybe<SortOrderInput>;
  riskProfile?: InputMaybe<SortOrderInput>;
  riskProfileAttachmentId?: InputMaybe<SortOrderInput>;
  riskProfileUpdatedAt?: InputMaybe<SortOrderInput>;
  safRating?: InputMaybe<SortOrderInput>;
  salutation?: InputMaybe<SortOrderInput>;
  sourceOfFund?: InputMaybe<SortOrderInput>;
  sourceOfWealth?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<SortOrder>;
  statements?: InputMaybe<StatementOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  taxResidency?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type ProfileRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export enum ProfileScalarFieldEnum {
  AmlSanctionScreeningPoint = 'amlSanctionScreeningPoint',
  AnnualIncome = 'annualIncome',
  Bumiputera = 'bumiputera',
  BusinessCategory = 'businessCategory',
  City = 'city',
  CityOfBirth = 'cityOfBirth',
  CompanyAddress = 'companyAddress',
  CompanyName = 'companyName',
  ContactPersonEmail = 'contactPersonEmail',
  ContactPersonEmail2 = 'contactPersonEmail2',
  ContactPersonHpNo = 'contactPersonHpNo',
  ContactPersonHpNo2 = 'contactPersonHpNo2',
  ContactPersonName = 'contactPersonName',
  ContactPersonName2 = 'contactPersonName2',
  ContactPersonTelNo = 'contactPersonTelNo',
  ContactPersonTelNo2 = 'contactPersonTelNo2',
  CountryOfBirth = 'countryOfBirth',
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DateOfBirth = 'dateOfBirth',
  Declaration = 'declaration',
  DeletedAt = 'deletedAt',
  Email = 'email',
  EmploymentStatus = 'employmentStatus',
  EmploymentType = 'employmentType',
  EstimatedNetWorth = 'estimatedNetWorth',
  ExpectedInvestmentAmount = 'expectedInvestmentAmount',
  FaxNo = 'faxNo',
  FrequencyOfTransaction = 'frequencyOfTransaction',
  FullName = 'fullName',
  Gender = 'gender',
  HighNetWorth = 'highNetWorth',
  Id = 'id',
  IdExpiryDate = 'idExpiryDate',
  IdNo = 'idNo',
  IdType = 'idType',
  JobIndustry = 'jobIndustry',
  MailingAddress = 'mailingAddress',
  MaritalStatus = 'maritalStatus',
  MarketingPush = 'marketingPush',
  MonthlyIncome = 'monthlyIncome',
  MothersMaidenName = 'mothersMaidenName',
  Nationality = 'nationality',
  NatureOfBusiness = 'natureOfBusiness',
  Occupation = 'occupation',
  OfficePhoneNo = 'officePhoneNo',
  PermanentAddress = 'permanentAddress',
  PhoneNo = 'phoneNo',
  PoliticalExposedPerson = 'politicalExposedPerson',
  Postcode = 'postcode',
  Profession = 'profession',
  ProminentRole = 'prominentRole',
  PurposeOfInvestment = 'purposeOfInvestment',
  Race = 'race',
  Religion = 'religion',
  RiskProfile = 'riskProfile',
  RiskProfileAttachmentId = 'riskProfileAttachmentId',
  RiskProfileUpdatedAt = 'riskProfileUpdatedAt',
  SafRating = 'safRating',
  Salutation = 'salutation',
  SourceOfFund = 'sourceOfFund',
  SourceOfWealth = 'sourceOfWealth',
  State = 'state',
  Status = 'status',
  TaxResidency = 'taxResidency',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ProfileScalarWhereInput = {
  AND?: InputMaybe<Array<ProfileScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProfileScalarWhereInput>>;
  OR?: InputMaybe<Array<ProfileScalarWhereInput>>;
  amlSanctionScreeningPoint?: InputMaybe<IntNullableFilter>;
  annualIncome?: InputMaybe<DecimalNullableFilter>;
  bumiputera?: InputMaybe<BoolNullableFilter>;
  businessCategory?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  cityOfBirth?: InputMaybe<StringNullableFilter>;
  companyAddress?: InputMaybe<StringNullableFilter>;
  companyName?: InputMaybe<StringNullableFilter>;
  contactPersonEmail?: InputMaybe<StringNullableFilter>;
  contactPersonEmail2?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo2?: InputMaybe<StringNullableFilter>;
  contactPersonName?: InputMaybe<StringNullableFilter>;
  contactPersonName2?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo2?: InputMaybe<StringNullableFilter>;
  countryOfBirth?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  declaration?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringFilter>;
  employmentStatus?: InputMaybe<StringNullableFilter>;
  employmentType?: InputMaybe<StringNullableFilter>;
  estimatedNetWorth?: InputMaybe<DecimalNullableFilter>;
  expectedInvestmentAmount?: InputMaybe<DecimalNullableFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  frequencyOfTransaction?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  highNetWorth?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  idExpiryDate?: InputMaybe<DateTimeNullableFilter>;
  idNo?: InputMaybe<StringFilter>;
  idType?: InputMaybe<EnumIdTypeFilter>;
  jobIndustry?: InputMaybe<StringNullableFilter>;
  mailingAddress?: InputMaybe<StringFilter>;
  maritalStatus?: InputMaybe<StringNullableFilter>;
  marketingPush?: InputMaybe<BoolFilter>;
  monthlyIncome?: InputMaybe<DecimalNullableFilter>;
  mothersMaidenName?: InputMaybe<StringNullableFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  natureOfBusiness?: InputMaybe<StringNullableFilter>;
  occupation?: InputMaybe<StringNullableFilter>;
  officePhoneNo?: InputMaybe<StringNullableFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  phoneNo?: InputMaybe<StringFilter>;
  politicalExposedPerson?: InputMaybe<BoolNullableFilter>;
  postcode?: InputMaybe<StringFilter>;
  profession?: InputMaybe<StringNullableFilter>;
  prominentRole?: InputMaybe<BoolNullableFilter>;
  purposeOfInvestment?: InputMaybe<StringNullableFilter>;
  race?: InputMaybe<StringNullableFilter>;
  religion?: InputMaybe<StringNullableFilter>;
  riskProfile?: InputMaybe<EnumRiskProfilesNullableFilter>;
  riskProfileAttachmentId?: InputMaybe<StringNullableFilter>;
  riskProfileUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  safRating?: InputMaybe<IntNullableFilter>;
  salutation?: InputMaybe<StringNullableFilter>;
  sourceOfFund?: InputMaybe<StringNullableFilter>;
  sourceOfWealth?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumProfileStatusFilter>;
  taxResidency?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ProfileStatus {
  Active = 'Active',
  Bankrupt = 'Bankrupt',
  Closed = 'Closed',
  Deceased = 'Deceased',
  Dormant = 'Dormant',
  Inactive = 'Inactive',
  Legal = 'Legal',
  Suspended = 'Suspended'
}

export type ProfileSumAggregate = {
  __typename?: 'ProfileSumAggregate';
  amlSanctionScreeningPoint?: Maybe<Scalars['Int']['output']>;
  annualIncome?: Maybe<Scalars['Decimal']['output']>;
  estimatedNetWorth?: Maybe<Scalars['Decimal']['output']>;
  expectedInvestmentAmount?: Maybe<Scalars['Decimal']['output']>;
  monthlyIncome?: Maybe<Scalars['Decimal']['output']>;
  safRating?: Maybe<Scalars['Int']['output']>;
};

export type ProfileUncheckedCreateInput = {
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedCreateNestedManyWithoutProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutIssuerProfileInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutRecipientProfileInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementUncheckedCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfilesInput>;
};

export type ProfileUncheckedCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<ProfileCreateWithoutUsersInput>>;
};

export type ProfileUncheckedCreateWithoutBankAccountsInput = {
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutIssuerProfileInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutRecipientProfileInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementUncheckedCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfilesInput>;
};

export type ProfileUncheckedCreateWithoutIssuedConsentsInput = {
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedCreateNestedManyWithoutProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutRecipientProfileInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementUncheckedCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfilesInput>;
};

export type ProfileUncheckedCreateWithoutReceivedConsentsInput = {
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedCreateNestedManyWithoutProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutIssuerProfileInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementUncheckedCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfilesInput>;
};

export type ProfileUncheckedCreateWithoutUsersInput = {
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutProfileInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedCreateNestedManyWithoutCompanyProfileInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedCreateNestedManyWithoutProfileInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo: Scalars['String']['input'];
  idType: IdType;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutIssuerProfileInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode: Scalars['String']['input'];
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedCreateNestedManyWithoutRecipientProfileInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  statements?: InputMaybe<StatementUncheckedCreateNestedManyWithoutProfileInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type: AccountType;
};

export type ProfileUncheckedUpdateInput = {
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutProfileNestedInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedUpdateManyWithoutCompanyProfileNestedInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedUpdateManyWithoutProfileNestedInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdType>;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedUpdateManyWithoutIssuerProfileNestedInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedUpdateManyWithoutRecipientProfileNestedInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachment?: InputMaybe<CreateOneDocumentInput>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  statements?: InputMaybe<StatementUncheckedUpdateManyWithoutProfileNestedInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfilesNestedInput>;
};

export type ProfileUncheckedUpdateManyWithoutUsersInput = {
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdType>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export type ProfileUncheckedUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<ProfileCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<ProfileUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<ProfileUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<ProfileUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type ProfileUncheckedUpdateWithoutUsersInput = {
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutProfileNestedInput>;
  amlSanctionScreeningPoint?: InputMaybe<Scalars['Int']['input']>;
  annualIncome?: InputMaybe<Scalars['Decimal']['input']>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryUncheckedUpdateManyWithoutCompanyProfileNestedInput>;
  bankAccounts?: InputMaybe<BankAccountUncheckedUpdateManyWithoutProfileNestedInput>;
  bumiputera?: InputMaybe<Scalars['Boolean']['input']>;
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonEmail2?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonHpNo2?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonName2?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo?: InputMaybe<Scalars['String']['input']>;
  contactPersonTelNo2?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  creationStatus?: InputMaybe<CreationStatus>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  declaration?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  estimatedNetWorth?: InputMaybe<Scalars['Decimal']['input']>;
  expectedInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  frequencyOfTransaction?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  highNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdType>;
  issuedConsents?: InputMaybe<ProfileConsentUncheckedUpdateManyWithoutIssuerProfileNestedInput>;
  jobIndustry?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  marketingPush?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['Decimal']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  officePhoneNo?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  politicalExposedPerson?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  prominentRole?: InputMaybe<Scalars['Boolean']['input']>;
  purposeOfInvestment?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  receivedConsents?: InputMaybe<ProfileConsentUncheckedUpdateManyWithoutRecipientProfileNestedInput>;
  religion?: InputMaybe<Scalars['String']['input']>;
  riskProfile?: InputMaybe<RiskProfiles>;
  riskProfileAttachmentId?: InputMaybe<Scalars['String']['input']>;
  riskProfileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safRating?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  sourceOfFund?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  statements?: InputMaybe<StatementUncheckedUpdateManyWithoutProfileNestedInput>;
  status?: InputMaybe<ProfileStatus>;
  taxResidency?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export type ProfileUpdateManyWithWhereWithoutUsersInput = {
  data: ProfileUncheckedUpdateManyWithoutUsersInput;
  where: ProfileScalarWhereInput;
};

export type ProfileUpdateWithWhereUniqueWithoutUsersInput = {
  data: ProfileUncheckedUpdateWithoutUsersInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileUpsertWithWhereUniqueWithoutUsersInput = {
  create: ProfileUncheckedCreateWithoutUsersInput;
  update: ProfileUncheckedUpdateWithoutUsersInput;
  where: ProfileWhereUniqueInput;
};

export type ProfileWhereInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  amlSanctionScreeningPoint?: InputMaybe<IntNullableFilter>;
  annualIncome?: InputMaybe<DecimalNullableFilter>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryListRelationFilter>;
  bankAccounts?: InputMaybe<BankAccountListRelationFilter>;
  bumiputera?: InputMaybe<BoolNullableFilter>;
  businessCategory?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  cityOfBirth?: InputMaybe<StringNullableFilter>;
  companyAddress?: InputMaybe<StringNullableFilter>;
  companyName?: InputMaybe<StringNullableFilter>;
  contactPersonEmail?: InputMaybe<StringNullableFilter>;
  contactPersonEmail2?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo2?: InputMaybe<StringNullableFilter>;
  contactPersonName?: InputMaybe<StringNullableFilter>;
  contactPersonName2?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo2?: InputMaybe<StringNullableFilter>;
  countryOfBirth?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  declaration?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringFilter>;
  employmentStatus?: InputMaybe<StringNullableFilter>;
  employmentType?: InputMaybe<StringNullableFilter>;
  estimatedNetWorth?: InputMaybe<DecimalNullableFilter>;
  expectedInvestmentAmount?: InputMaybe<DecimalNullableFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  frequencyOfTransaction?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  highNetWorth?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  idExpiryDate?: InputMaybe<DateTimeNullableFilter>;
  idNo?: InputMaybe<StringFilter>;
  idType?: InputMaybe<EnumIdTypeFilter>;
  issuedConsents?: InputMaybe<ProfileConsentListRelationFilter>;
  jobIndustry?: InputMaybe<StringNullableFilter>;
  mailingAddress?: InputMaybe<StringFilter>;
  maritalStatus?: InputMaybe<StringNullableFilter>;
  marketingPush?: InputMaybe<BoolFilter>;
  monthlyIncome?: InputMaybe<DecimalNullableFilter>;
  mothersMaidenName?: InputMaybe<StringNullableFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  natureOfBusiness?: InputMaybe<StringNullableFilter>;
  occupation?: InputMaybe<StringNullableFilter>;
  officePhoneNo?: InputMaybe<StringNullableFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  phoneNo?: InputMaybe<StringFilter>;
  politicalExposedPerson?: InputMaybe<BoolNullableFilter>;
  postcode?: InputMaybe<StringFilter>;
  profession?: InputMaybe<StringNullableFilter>;
  prominentRole?: InputMaybe<BoolNullableFilter>;
  purposeOfInvestment?: InputMaybe<StringNullableFilter>;
  race?: InputMaybe<StringNullableFilter>;
  receivedConsents?: InputMaybe<ProfileConsentListRelationFilter>;
  religion?: InputMaybe<StringNullableFilter>;
  riskProfile?: InputMaybe<EnumRiskProfilesNullableFilter>;
  riskProfileAttachmentId?: InputMaybe<StringNullableFilter>;
  riskProfileUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  safRating?: InputMaybe<IntNullableFilter>;
  salutation?: InputMaybe<StringNullableFilter>;
  sourceOfFund?: InputMaybe<StringNullableFilter>;
  sourceOfWealth?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringFilter>;
  statements?: InputMaybe<StatementListRelationFilter>;
  status?: InputMaybe<EnumProfileStatusFilter>;
  taxResidency?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type ProfileWhereUniqueInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  amlSanctionScreeningPoint?: InputMaybe<IntNullableFilter>;
  annualIncome?: InputMaybe<DecimalNullableFilter>;
  authorisedSignatories?: InputMaybe<AuthorisedSignatoryListRelationFilter>;
  bankAccounts?: InputMaybe<BankAccountListRelationFilter>;
  bumiputera?: InputMaybe<BoolNullableFilter>;
  businessCategory?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  cityOfBirth?: InputMaybe<StringNullableFilter>;
  companyAddress?: InputMaybe<StringNullableFilter>;
  companyName?: InputMaybe<StringNullableFilter>;
  contactPersonEmail?: InputMaybe<StringNullableFilter>;
  contactPersonEmail2?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo?: InputMaybe<StringNullableFilter>;
  contactPersonHpNo2?: InputMaybe<StringNullableFilter>;
  contactPersonName?: InputMaybe<StringNullableFilter>;
  contactPersonName2?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo?: InputMaybe<StringNullableFilter>;
  contactPersonTelNo2?: InputMaybe<StringNullableFilter>;
  countryOfBirth?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  declaration?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringFilter>;
  employmentStatus?: InputMaybe<StringNullableFilter>;
  employmentType?: InputMaybe<StringNullableFilter>;
  estimatedNetWorth?: InputMaybe<DecimalNullableFilter>;
  expectedInvestmentAmount?: InputMaybe<DecimalNullableFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  frequencyOfTransaction?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  highNetWorth?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryDate?: InputMaybe<DateTimeNullableFilter>;
  idNo?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<EnumIdTypeFilter>;
  issuedConsents?: InputMaybe<ProfileConsentListRelationFilter>;
  jobIndustry?: InputMaybe<StringNullableFilter>;
  mailingAddress?: InputMaybe<StringFilter>;
  maritalStatus?: InputMaybe<StringNullableFilter>;
  marketingPush?: InputMaybe<BoolFilter>;
  monthlyIncome?: InputMaybe<DecimalNullableFilter>;
  mothersMaidenName?: InputMaybe<StringNullableFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  natureOfBusiness?: InputMaybe<StringNullableFilter>;
  occupation?: InputMaybe<StringNullableFilter>;
  officePhoneNo?: InputMaybe<StringNullableFilter>;
  permanentAddress?: InputMaybe<StringFilter>;
  phoneNo?: InputMaybe<StringFilter>;
  politicalExposedPerson?: InputMaybe<BoolNullableFilter>;
  postcode?: InputMaybe<StringFilter>;
  profession?: InputMaybe<StringNullableFilter>;
  prominentRole?: InputMaybe<BoolNullableFilter>;
  purposeOfInvestment?: InputMaybe<StringNullableFilter>;
  race?: InputMaybe<StringNullableFilter>;
  receivedConsents?: InputMaybe<ProfileConsentListRelationFilter>;
  religion?: InputMaybe<StringNullableFilter>;
  riskProfile?: InputMaybe<EnumRiskProfilesNullableFilter>;
  riskProfileAttachmentId?: InputMaybe<StringNullableFilter>;
  riskProfileUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  safRating?: InputMaybe<IntNullableFilter>;
  salutation?: InputMaybe<StringNullableFilter>;
  sourceOfFund?: InputMaybe<StringNullableFilter>;
  sourceOfWealth?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringFilter>;
  statements?: InputMaybe<StatementListRelationFilter>;
  status?: InputMaybe<EnumProfileStatusFilter>;
  taxResidency?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type ProfitAndLossValue = {
  __typename?: 'ProfitAndLossValue';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  profitAndLossPercentage: Scalars['Decimal']['output'];
};

export type PublicHoliday = {
  __typename?: 'PublicHoliday';
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PublicHolidayCountAggregate = {
  __typename?: 'PublicHolidayCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  remarks: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PublicHolidayMaxAggregate = {
  __typename?: 'PublicHolidayMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicHolidayMinAggregate = {
  __typename?: 'PublicHolidayMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicHolidayOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  remarks?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PublicHolidayUncheckedCreateInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type PublicHolidayUncheckedUpdateInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PublicHolidayWhereInput = {
  AND?: InputMaybe<Array<PublicHolidayWhereInput>>;
  NOT?: InputMaybe<Array<PublicHolidayWhereInput>>;
  OR?: InputMaybe<Array<PublicHolidayWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PublicHolidayWhereUniqueInput = {
  AND?: InputMaybe<Array<PublicHolidayWhereInput>>;
  NOT?: InputMaybe<Array<PublicHolidayWhereInput>>;
  OR?: InputMaybe<Array<PublicHolidayWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PurchaseTransactionInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  distributionInstruction?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  holdingUnit: Scalars['Float']['input'];
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountPortfolio?: Maybe<AccountPortfolio>;
  accountPortfolios: PaginatedAccountPortfolio;
  accountRequest?: Maybe<AccountRequest>;
  accountRequests: PaginatedAccountRequest;
  accounts: PaginatedAccount;
  adminPermission?: Maybe<AdminPermission>;
  adminPermissions: PaginatedAdminPermission;
  adminRole?: Maybe<AdminRole>;
  adminRoles: PaginatedAdminRole;
  adminUser?: Maybe<AdminUser>;
  adminUsers: PaginatedAdminUser;
  announcement?: Maybe<Announcement>;
  announcements: PaginatedAnnouncement;
  auditTrail?: Maybe<AuditTrail>;
  auditTrails: PaginatedAuditTrail;
  authSecurityImage: Document;
  authorisedSignatories: PaginatedAuthorisedSignatory;
  authorisedSignatory?: Maybe<AuthorisedSignatory>;
  bank?: Maybe<Bank>;
  banks: PaginatedBank;
  collectionBankAccount?: Maybe<CollectionBankAccount>;
  collectionBankAccounts: PaginatedCollectionBankAccount;
  /** Get consolidated daily statistics within a date range (admin only) */
  dailyStatisticsInRange: DailyStatisticsInRange;
  document?: Maybe<Document>;
  documents: PaginatedDocument;
  fund?: Maybe<Fund>;
  fundCategories?: Maybe<Array<FundCategory>>;
  fundDocument?: Maybe<FundDocument>;
  fundDocuments: PaginatedFundDocument;
  fundHoliday?: Maybe<FundHoliday>;
  fundHolidays: PaginatedFundHoliday;
  fundPolicies: PaginatedFundPolicy;
  fundPolicy?: Maybe<FundPolicy>;
  fundPrice?: Maybe<FundPrice>;
  fundPrices: PaginatedFundPrice;
  funds: PaginatedFund;
  getDocuSignEnvelopeStatus: EnvelopeStatus;
  health: Scalars['String']['output'];
  listBanks?: Maybe<Array<Bank>>;
  mcasRequestOtp: RequestOtpResponse;
  mcasVerifyOtp: VerifyOtpResponse;
  me: AuthUserUnion;
  modification?: Maybe<ModificationModel>;
  modifications: PaginatedModificationModel;
  myAccountPortfolios: PaginatedAccountPortfolio;
  myAccountSummary: MyAccountSummary;
  myCombinedTransactions?: Maybe<PaginatedCombineTransactionDto>;
  myConsentedProfileSummary?: Maybe<MyConsentedProfileSummary>;
  myConsentedProfiles?: Maybe<Array<ConsentedProfile>>;
  myProfile?: Maybe<Profile>;
  myProfileAccountPortfolios: PaginatedAccountPortfolio;
  myProfiles?: Maybe<Array<Profile>>;
  myStatements: PaginatedStatement;
  myTransaction?: Maybe<Transaction>;
  myTransactions: PaginatedTransaction;
  myUser?: Maybe<User>;
  /** Get companies onboarded within a date range based on earliest user onboarded date (admin only) */
  onboardedCompaniesInRange: Array<OnboardedCompanyRow>;
  order?: Maybe<Order>;
  orderConfigs: OrderConfigs;
  orderDocument?: Maybe<OrderDocument>;
  orderDocuments: PaginatedOrderDocument;
  /** Get all-time order statistics (admin only) */
  orderStatsAllTime: OrderStatsAllTime;
  orders: PaginatedOrder;
  otpChallenges: PaginatedOtpChallenge;
  payment?: Maybe<Payment>;
  paymentConfigs: Array<PaymentConfig>;
  payments: PaginatedPayment;
  profile?: Maybe<Profile>;
  profileConsent?: Maybe<ProfileConsent>;
  profileConsents: PaginatedProfileConsent;
  profiles: PaginatedProfile;
  publicAnnouncements?: Maybe<Array<Announcement>>;
  publicHoliday?: Maybe<PublicHoliday>;
  publicHolidays: PaginatedPublicHoliday;
  searchAdminUsers: PaginatedAdminUser;
  securityImages: Array<SecurityImage>;
  signatories: PaginatedSignatory;
  signatory?: Maybe<Signatory>;
  statement?: Maybe<Statement>;
  statements: PaginatedStatement;
  staticFaqs: Array<Faq>;
  tomswinGetFundAccountBalance: FundAccountBalance;
  tomswinSync: TomswinSync;
  tomswinSyncBatch: TomswinSync;
  tomswinSyncBatches: PaginatedTomswinSyncBatch;
  tomswinSyncs: PaginatedTomswinSync;
  transaction?: Maybe<Transaction>;
  /** Get transactions initiated within a date range for CSV export (admin only) */
  transactionInitiatedRowsInRange: Array<TransactionInitiatedExportRow>;
  /** Get all-time transaction statistics (admin only) */
  transactionStatsAllTime: TransactionStatsAllTime;
  transactions: PaginatedTransaction;
  trustee?: Maybe<Trustee>;
  trustees: PaginatedTrustee;
  user?: Maybe<User>;
  /** Get all-time user statistics (admin only) */
  userStatsAllTime: UserStatsAllTime;
  users: PaginatedUser;
  verifyCorporateAccountRequest?: Maybe<AccountRequest>;
  verifyCorporateProfile?: Maybe<Profile>;
};


export type QueryAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountPortfolioArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountPortfoliosArgs = {
  orderBy?: InputMaybe<Array<AccountPortfolioOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type QueryAccountRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountRequestsArgs = {
  orderBy?: InputMaybe<Array<AccountRequestOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountRequestWhereInput>;
};


export type QueryAccountsArgs = {
  orderBy?: InputMaybe<Array<AccountOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAdminPermissionArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminPermissionsArgs = {
  orderBy?: InputMaybe<Array<AdminPermissionOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  where?: InputMaybe<AdminPermissionWhereInput>;
};


export type QueryAdminRoleArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminRolesArgs = {
  orderBy?: InputMaybe<Array<AdminRoleOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  where?: InputMaybe<AdminRoleWhereInput>;
};


export type QueryAdminUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminUsersArgs = {
  orderBy?: InputMaybe<Array<AdminUserOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AdminUserWhereInput>;
};


export type QueryAnnouncementArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnouncementsArgs = {
  orderBy?: InputMaybe<Array<AnnouncementOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type QueryAuditTrailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAuditTrailsArgs = {
  orderBy?: InputMaybe<Array<AuditTrailOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AuditTrailWhereInput>;
};


export type QueryAuthSecurityImageArgs = {
  username: Scalars['String']['input'];
};


export type QueryAuthorisedSignatoriesArgs = {
  orderBy?: InputMaybe<Array<AuthorisedSignatoryOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AuthorisedSignatoryWhereInput>;
};


export type QueryAuthorisedSignatoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBankArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBanksArgs = {
  orderBy?: InputMaybe<Array<BankOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BankWhereInput>;
};


export type QueryCollectionBankAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCollectionBankAccountsArgs = {
  orderBy?: InputMaybe<Array<CollectionBankAccountOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CollectionBankAccountWhereInput>;
};


export type QueryDailyStatisticsInRangeArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentsArgs = {
  orderBy?: InputMaybe<Array<DocumentOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryFundArgs = {
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFundDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFundDocumentsArgs = {
  orderBy?: InputMaybe<Array<FundDocumentOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundDocumentWhereInput>;
};


export type QueryFundHolidayArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFundHolidaysArgs = {
  orderBy?: InputMaybe<Array<FundHolidayOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundHolidayWhereInput>;
};


export type QueryFundPoliciesArgs = {
  orderBy?: InputMaybe<Array<FundPolicyOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundPolicyWhereInput>;
};


export type QueryFundPolicyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFundPriceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFundPricesArgs = {
  orderBy?: InputMaybe<Array<FundPriceOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundPriceWhereInput>;
};


export type QueryFundsArgs = {
  orderBy?: InputMaybe<Array<FundOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<FundWhereInput>;
};


export type QueryGetDocuSignEnvelopeStatusArgs = {
  envelopeId: Scalars['String']['input'];
};


export type QueryMcasRequestOtpArgs = {
  requestOtpInput: McasRequestOtpInput;
};


export type QueryMcasVerifyOtpArgs = {
  verifyOtpInput: McasVerifyOtpInput;
};


export type QueryModificationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryModificationsArgs = {
  orderBy?: InputMaybe<Array<ModificationOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ModificationWhereInput>;
};


export type QueryMyAccountPortfoliosArgs = {
  filter?: InputMaybe<ListAccountPortfoliosByUserFilter>;
  orderBy?: InputMaybe<Array<AccountPortfolioOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type QueryMyAccountSummaryArgs = {
  accountMasterAccountNo: Scalars['String']['input'];
};


export type QueryMyCombinedTransactionsArgs = {
  filter?: InputMaybe<ListTransactionsByUserFilter>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
};


export type QueryMyProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyProfileAccountPortfoliosArgs = {
  filter: ListAccountPortfoliosByUserProfileFilter;
  orderBy?: InputMaybe<Array<AccountPortfolioOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type QueryMyStatementsArgs = {
  orderBy?: InputMaybe<Array<StatementOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<StatementWhereInput>;
};


export type QueryMyTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyTransactionsArgs = {
  filter?: InputMaybe<ListTransactionsByUserFilter>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryOnboardedCompaniesInRangeArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderDocumentsArgs = {
  orderBy?: InputMaybe<Array<OrderDocumentOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrderDocumentWhereInput>;
};


export type QueryOrdersArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOtpChallengesArgs = {
  orderBy?: InputMaybe<Array<OtpChallengeOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OtpChallengeWhereInput>;
};


export type QueryPaymentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentConfigsArgs = {
  purchaseTransactions?: InputMaybe<Array<PurchaseTransactionInput>>;
};


export type QueryPaymentsArgs = {
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProfileConsentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProfileConsentsArgs = {
  orderBy?: InputMaybe<Array<ProfileConsentOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProfileConsentWhereInput>;
};


export type QueryProfilesArgs = {
  orderBy?: InputMaybe<Array<ProfileOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryPublicHolidayArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicHolidaysArgs = {
  orderBy?: InputMaybe<Array<PublicHolidayOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PublicHolidayWhereInput>;
};


export type QuerySearchAdminUsersArgs = {
  keyword: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
};


export type QuerySecurityImagesArgs = {
  take: Scalars['Float']['input'];
};


export type QuerySignatoriesArgs = {
  orderBy?: InputMaybe<Array<SignatoryOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SignatoryWhereInput>;
};


export type QuerySignatoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStatementArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStatementsArgs = {
  orderBy?: InputMaybe<Array<StatementOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<StatementWhereInput>;
};


export type QueryTomswinGetFundAccountBalanceArgs = {
  fundAccountId: Scalars['String']['input'];
};


export type QueryTomswinSyncArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTomswinSyncBatchArgs = {
  id: Scalars['String']['input'];
};


export type QueryTomswinSyncBatchesArgs = {
  orderBy?: InputMaybe<Array<TomswinSyncBatchOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  where?: InputMaybe<TomswinSyncBatchWhereInput>;
};


export type QueryTomswinSyncsArgs = {
  orderBy?: InputMaybe<Array<TomswinSyncOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TomswinSyncWhereInput>;
};


export type QueryTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTransactionInitiatedRowsInRangeArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryTransactionsArgs = {
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryTrusteeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTrusteesArgs = {
  orderBy?: InputMaybe<Array<TrusteeOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TrusteeWhereInput>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVerifyCorporateAccountRequestArgs = {
  contactEmail: Scalars['String']['input'];
  contactNo: Scalars['String']['input'];
  invitationCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryVerifyCorporateProfileArgs = {
  verifyCorporateProfileInput: VerifyCorporateProfileInput;
};

export type Question = {
  __typename?: 'Question';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type RecoverUsernameInput = {
  email: Scalars['String']['input'];
  idNo: Scalars['String']['input'];
};

export enum RedemptionExtent {
  Full = 'Full',
  Partial = 'Partial'
}

export type RegisterInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<ProfileUncheckedCreateNestedManyWithoutUsersInput>;
  securityImageId: Scalars['String']['input'];
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RequestLoginOtpInput = {
  username: Scalars['String']['input'];
};

export type RequestOtpResp = {
  __typename?: 'RequestOTPResp';
  number: Scalars['String']['output'];
  tac: Scalars['String']['output'];
};

export type RequestOtpInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<OtpFlow>;
  isResend?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  purpose: OtpPurpose;
};

export type RequestOtpResponse = {
  __typename?: 'RequestOtpResponse';
  requestOTPResp: RequestOtpResp;
};

export type RequestSimpleOtpInput = {
  email: Scalars['String']['input'];
  fullname?: InputMaybe<Scalars['String']['input']>;
  icNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provider: OtpProvider;
  purpose: OtpPurpose;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  idNo?: InputMaybe<Scalars['String']['input']>;
  otpChallengeCode: Scalars['String']['input'];
  otpChallengeId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum RiskProfiles {
  Aggressive = 'Aggressive',
  Conservative = 'Conservative',
  Moderate = 'Moderate'
}

export type SecurityImage = {
  __typename?: 'SecurityImage';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['Byte']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  encodedData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SecurityImageCountAggregate = {
  __typename?: 'SecurityImageCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mimeType: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SecurityImageMaxAggregate = {
  __typename?: 'SecurityImageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['Byte']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SecurityImageMinAggregate = {
  __typename?: 'SecurityImageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['Byte']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Signatory = {
  __typename?: 'Signatory';
  authorisedSignatory?: Maybe<AuthorisedSignatory>;
  authorisedSignatoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  provider: SignatoryProvider;
  signature?: Maybe<Scalars['String']['output']>;
  signatureId?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SignatoryStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type SignatoryAuthorisedSignatoryArgs = {
  where?: InputMaybe<AuthorisedSignatoryWhereInput>;
};

export type SignatoryCountAggregate = {
  __typename?: 'SignatoryCountAggregate';
  _all: Scalars['Int']['output'];
  authorisedSignatoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  signatureId: Scalars['Int']['output'];
  signedAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SignatoryCreateManyAuthorisedSignatoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryCreateManyAuthorisedSignatoryInputEnvelope = {
  data: Array<SignatoryCreateManyAuthorisedSignatoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignatoryCreateManyOrderInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryCreateManyOrderInputEnvelope = {
  data: Array<SignatoryCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignatoryCreateNestedManyWithoutAuthorisedSignatoryInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutAuthorisedSignatoryInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutAuthorisedSignatoryInput>>;
  createMany?: InputMaybe<SignatoryCreateManyAuthorisedSignatoryInputEnvelope>;
};

export type SignatoryCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<SignatoryCreateManyOrderInputEnvelope>;
};

export type SignatoryCreateOrConnectWithoutAuthorisedSignatoryInput = {
  create: SignatoryUncheckedCreateWithoutAuthorisedSignatoryInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryCreateOrConnectWithoutOrderInput = {
  create: SignatoryUncheckedCreateWithoutOrderInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryCreateWithoutAuthorisedSignatoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutSignatoriesInput;
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryCreateWithoutOrderInput = {
  authorisedSignatory?: InputMaybe<AuthorisedSignatoryCreateNestedOneWithoutSignatoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  provider: SignatoryProvider;
  signatureDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type SignatoryListRelationFilter = {
  every?: InputMaybe<SignatoryWhereInput>;
  none?: InputMaybe<SignatoryWhereInput>;
  some?: InputMaybe<SignatoryWhereInput>;
};

export type SignatoryMaxAggregate = {
  __typename?: 'SignatoryMaxAggregate';
  authorisedSignatoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<SignatoryProvider>;
  signatureId?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SignatoryStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SignatoryMinAggregate = {
  __typename?: 'SignatoryMinAggregate';
  authorisedSignatoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<SignatoryProvider>;
  signatureId?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SignatoryStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SignatoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SignatoryOrderByWithRelationInput = {
  authorisedSignatory?: InputMaybe<AuthorisedSignatoryOrderByWithRelationInput>;
  authorisedSignatoryId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrderInput>;
  signedAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SignatoryProvider {
  ESign = 'E_SIGN',
  Manual = 'MANUAL'
}

export enum SignatoryScalarFieldEnum {
  AuthorisedSignatoryId = 'authorisedSignatoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrderId = 'orderId',
  Provider = 'provider',
  SignatureId = 'signatureId',
  SignedAt = 'signedAt',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SignatoryScalarWhereInput = {
  AND?: InputMaybe<Array<SignatoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<SignatoryScalarWhereInput>>;
  OR?: InputMaybe<Array<SignatoryScalarWhereInput>>;
  authorisedSignatoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumSignatoryProviderFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum SignatoryStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type SignatoryUncheckedCreateInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedCreateNestedManyWithoutAuthorisedSignatoryInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutAuthorisedSignatoryInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutAuthorisedSignatoryInput>>;
  createMany?: InputMaybe<SignatoryCreateManyAuthorisedSignatoryInputEnvelope>;
};

export type SignatoryUncheckedCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<SignatoryCreateManyOrderInputEnvelope>;
};

export type SignatoryUncheckedCreateWithoutAuthorisedSignatoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedCreateWithoutOrderInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider: SignatoryProvider;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedUpdateManyWithoutAuthorisedSignatoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<SignatoryProvider>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedUpdateManyWithoutAuthorisedSignatoryNestedInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutAuthorisedSignatoryInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutAuthorisedSignatoryInput>>;
  createMany?: InputMaybe<SignatoryCreateManyAuthorisedSignatoryInputEnvelope>;
  delete?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SignatoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  set?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  update?: InputMaybe<Array<SignatoryUpdateWithWhereUniqueWithoutAuthorisedSignatoryInput>>;
  updateMany?: InputMaybe<Array<SignatoryUpdateManyWithWhereWithoutAuthorisedSignatoryInput>>;
  upsert?: InputMaybe<Array<SignatoryUpsertWithWhereUniqueWithoutAuthorisedSignatoryInput>>;
};

export type SignatoryUncheckedUpdateManyWithoutOrderInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<SignatoryProvider>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignatoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<SignatoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<SignatoryCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SignatoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  set?: InputMaybe<Array<SignatoryWhereUniqueInput>>;
  update?: InputMaybe<Array<SignatoryUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<SignatoryUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<SignatoryUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type SignatoryUncheckedUpdateWithoutAuthorisedSignatoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<SignatoryProvider>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUncheckedUpdateWithoutOrderInput = {
  authorisedSignatoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<SignatoryProvider>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SignatoryStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignatoryUpdateManyWithWhereWithoutAuthorisedSignatoryInput = {
  data: SignatoryUncheckedUpdateManyWithoutAuthorisedSignatoryInput;
  where: SignatoryScalarWhereInput;
};

export type SignatoryUpdateManyWithWhereWithoutOrderInput = {
  data: SignatoryUncheckedUpdateManyWithoutOrderInput;
  where: SignatoryScalarWhereInput;
};

export type SignatoryUpdateWithWhereUniqueWithoutAuthorisedSignatoryInput = {
  data: SignatoryUncheckedUpdateWithoutAuthorisedSignatoryInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryUpdateWithWhereUniqueWithoutOrderInput = {
  data: SignatoryUncheckedUpdateWithoutOrderInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryUpsertWithWhereUniqueWithoutAuthorisedSignatoryInput = {
  create: SignatoryUncheckedCreateWithoutAuthorisedSignatoryInput;
  update: SignatoryUncheckedUpdateWithoutAuthorisedSignatoryInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryUpsertWithWhereUniqueWithoutOrderInput = {
  create: SignatoryUncheckedCreateWithoutOrderInput;
  update: SignatoryUncheckedUpdateWithoutOrderInput;
  where: SignatoryWhereUniqueInput;
};

export type SignatoryWhereInput = {
  AND?: InputMaybe<Array<SignatoryWhereInput>>;
  NOT?: InputMaybe<Array<SignatoryWhereInput>>;
  OR?: InputMaybe<Array<SignatoryWhereInput>>;
  authorisedSignatory?: InputMaybe<AuthorisedSignatoryNullableRelationFilter>;
  authorisedSignatoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumSignatoryProviderFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SignatoryWhereUniqueInput = {
  AND?: InputMaybe<Array<SignatoryWhereInput>>;
  NOT?: InputMaybe<Array<SignatoryWhereInput>>;
  OR?: InputMaybe<Array<SignatoryWhereInput>>;
  authorisedSignatory?: InputMaybe<AuthorisedSignatoryNullableRelationFilter>;
  authorisedSignatoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumSignatoryProviderFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumSignatoryStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SignedFile = {
  __typename?: 'SignedFile';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type Statement = {
  __typename?: 'Statement';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  documentLocation?: Maybe<StatementDocumentLocation>;
  id: Scalars['ID']['output'];
  profile: Profile;
  profileId: Scalars['String']['output'];
  source: StatementSource;
  statementDate: Scalars['DateTime']['output'];
  statementLink?: Maybe<Scalars['String']['output']>;
  statementSubType: StatementSubType;
  statementType: StatementType;
  status: StatementStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatementCountAggregate = {
  __typename?: 'StatementCountAggregate';
  _all: Scalars['Int']['output'];
  accountMasterAccountNo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  displayName: Scalars['Int']['output'];
  documentLocation: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  statementDate: Scalars['Int']['output'];
  statementLink: Scalars['Int']['output'];
  statementSubType: Scalars['Int']['output'];
  statementType: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type StatementCreateManyProfileInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  source: StatementSource;
  statementDate: Scalars['DateTime']['input'];
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType: StatementSubType;
  statementType: StatementType;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementCreateManyProfileInputEnvelope = {
  data: Array<StatementCreateManyProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatementCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<StatementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatementCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<StatementCreateWithoutProfileInput>>;
  createMany?: InputMaybe<StatementCreateManyProfileInputEnvelope>;
};

export type StatementCreateOrConnectWithoutProfileInput = {
  create: StatementUncheckedCreateWithoutProfileInput;
  where: StatementWhereUniqueInput;
};

export type StatementCreateWithoutProfileInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  source: StatementSource;
  statementDate: Scalars['DateTime']['input'];
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType: StatementSubType;
  statementType: StatementType;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum StatementDocumentLocation {
  Db = 'DB',
  Local = 'Local',
  S3 = 'S3'
}

export type StatementListRelationFilter = {
  every?: InputMaybe<StatementWhereInput>;
  none?: InputMaybe<StatementWhereInput>;
  some?: InputMaybe<StatementWhereInput>;
};

export type StatementMaxAggregate = {
  __typename?: 'StatementMaxAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentLocation?: Maybe<StatementDocumentLocation>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<StatementSource>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  statementLink?: Maybe<Scalars['String']['output']>;
  statementSubType?: Maybe<StatementSubType>;
  statementType?: Maybe<StatementType>;
  status?: Maybe<StatementStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StatementMinAggregate = {
  __typename?: 'StatementMinAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentLocation?: Maybe<StatementDocumentLocation>;
  id?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<StatementSource>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  statementLink?: Maybe<Scalars['String']['output']>;
  statementSubType?: Maybe<StatementSubType>;
  statementType?: Maybe<StatementType>;
  status?: Maybe<StatementStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StatementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StatementOrderByWithRelationInput = {
  accountMasterAccountNo?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  documentLocation?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  statementDate?: InputMaybe<SortOrder>;
  statementLink?: InputMaybe<SortOrderInput>;
  statementSubType?: InputMaybe<SortOrder>;
  statementType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum StatementScalarFieldEnum {
  AccountMasterAccountNo = 'accountMasterAccountNo',
  CreatedAt = 'createdAt',
  DisplayName = 'displayName',
  DocumentLocation = 'documentLocation',
  Id = 'id',
  ProfileId = 'profileId',
  Source = 'source',
  StatementDate = 'statementDate',
  StatementLink = 'statementLink',
  StatementSubType = 'statementSubType',
  StatementType = 'statementType',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type StatementScalarWhereInput = {
  AND?: InputMaybe<Array<StatementScalarWhereInput>>;
  NOT?: InputMaybe<Array<StatementScalarWhereInput>>;
  OR?: InputMaybe<Array<StatementScalarWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLocation?: InputMaybe<EnumStatementDocumentLocationNullableFilter>;
  id?: InputMaybe<StringFilter>;
  profileId?: InputMaybe<StringFilter>;
  source?: InputMaybe<EnumStatementSourceFilter>;
  statementDate?: InputMaybe<DateTimeFilter>;
  statementLink?: InputMaybe<StringNullableFilter>;
  statementSubType?: InputMaybe<EnumStatementSubTypeFilter>;
  statementType?: InputMaybe<EnumStatementTypeFilter>;
  status?: InputMaybe<EnumStatementStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum StatementSource {
  Canon = 'CANON',
  Coeus = 'COEUS'
}

export enum StatementStatus {
  Completed = 'Completed',
  Pending = 'Pending'
}

export enum StatementSubType {
  Cmt = 'CMT',
  Cmtd = 'CMTD',
  Prs = 'PRS',
  Prsh = 'PRSH',
  Ut = 'UT',
  Ute = 'UTE',
  Utpa = 'UTPA',
  Utpc = 'UTPC',
  Utr = 'UTR'
}

export enum StatementType {
  Monthly = 'monthly',
  TaxVoucher = 'taxVoucher',
  TxnAdviceSlip = 'txnAdviceSlip'
}

export type StatementUncheckedCreateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  source: StatementSource;
  statementDate: Scalars['DateTime']['input'];
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType: StatementSubType;
  statementType: StatementType;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementUncheckedCreateNestedManyWithoutProfileInput = {
  connect?: InputMaybe<Array<StatementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatementCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<StatementCreateWithoutProfileInput>>;
  createMany?: InputMaybe<StatementCreateManyProfileInputEnvelope>;
};

export type StatementUncheckedCreateWithoutProfileInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  source: StatementSource;
  statementDate: Scalars['DateTime']['input'];
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType: StatementSubType;
  statementType: StatementType;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementUncheckedUpdateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<StatementSource>;
  statementDate?: InputMaybe<Scalars['DateTime']['input']>;
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType?: InputMaybe<StatementSubType>;
  statementType?: InputMaybe<StatementType>;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementUncheckedUpdateManyWithoutProfileInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<StatementSource>;
  statementDate?: InputMaybe<Scalars['DateTime']['input']>;
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType?: InputMaybe<StatementSubType>;
  statementType?: InputMaybe<StatementType>;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementUncheckedUpdateManyWithoutProfileNestedInput = {
  connect?: InputMaybe<Array<StatementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatementCreateOrConnectWithoutProfileInput>>;
  create?: InputMaybe<Array<StatementCreateWithoutProfileInput>>;
  createMany?: InputMaybe<StatementCreateManyProfileInputEnvelope>;
  delete?: InputMaybe<Array<StatementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatementWhereUniqueInput>>;
  set?: InputMaybe<Array<StatementWhereUniqueInput>>;
  update?: InputMaybe<Array<StatementUpdateWithWhereUniqueWithoutProfileInput>>;
  updateMany?: InputMaybe<Array<StatementUpdateManyWithWhereWithoutProfileInput>>;
  upsert?: InputMaybe<Array<StatementUpsertWithWhereUniqueWithoutProfileInput>>;
};

export type StatementUncheckedUpdateWithoutProfileInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentLocation?: InputMaybe<StatementDocumentLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<StatementSource>;
  statementDate?: InputMaybe<Scalars['DateTime']['input']>;
  statementLink?: InputMaybe<Scalars['String']['input']>;
  statementSubType?: InputMaybe<StatementSubType>;
  statementType?: InputMaybe<StatementType>;
  status?: InputMaybe<StatementStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementUpdateManyWithWhereWithoutProfileInput = {
  data: StatementUncheckedUpdateManyWithoutProfileInput;
  where: StatementScalarWhereInput;
};

export type StatementUpdateWithWhereUniqueWithoutProfileInput = {
  data: StatementUncheckedUpdateWithoutProfileInput;
  where: StatementWhereUniqueInput;
};

export type StatementUpsertWithWhereUniqueWithoutProfileInput = {
  create: StatementUncheckedCreateWithoutProfileInput;
  update: StatementUncheckedUpdateWithoutProfileInput;
  where: StatementWhereUniqueInput;
};

export type StatementWhereInput = {
  AND?: InputMaybe<Array<StatementWhereInput>>;
  NOT?: InputMaybe<Array<StatementWhereInput>>;
  OR?: InputMaybe<Array<StatementWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLocation?: InputMaybe<EnumStatementDocumentLocationNullableFilter>;
  id?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<StringFilter>;
  source?: InputMaybe<EnumStatementSourceFilter>;
  statementDate?: InputMaybe<DateTimeFilter>;
  statementLink?: InputMaybe<StringNullableFilter>;
  statementSubType?: InputMaybe<EnumStatementSubTypeFilter>;
  statementType?: InputMaybe<EnumStatementTypeFilter>;
  status?: InputMaybe<EnumStatementStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StatementWhereUniqueInput = {
  AND?: InputMaybe<Array<StatementWhereInput>>;
  NOT?: InputMaybe<Array<StatementWhereInput>>;
  OR?: InputMaybe<Array<StatementWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringFilter>;
  documentLocation?: InputMaybe<EnumStatementDocumentLocationNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileRelationFilter>;
  profileId?: InputMaybe<StringFilter>;
  source?: InputMaybe<EnumStatementSourceFilter>;
  statementDate?: InputMaybe<DateTimeFilter>;
  statementLink?: InputMaybe<StringNullableFilter>;
  statementSubType?: InputMaybe<EnumStatementSubTypeFilter>;
  statementType?: InputMaybe<EnumStatementTypeFilter>;
  status?: InputMaybe<EnumStatementStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubCategory = {
  __typename?: 'SubCategory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questions: Array<Question>;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SupportCreateInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SwitchOrderInput = {
  originId?: InputMaybe<Scalars['String']['input']>;
  signatories: Array<SignatoryInput>;
  switchTransactions: Array<SwitchTransactionInput>;
};

export type SwitchTransactionInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  portfolioAccountNo: Scalars['String']['input'];
  redemptionExtent: RedemptionExtent;
  switchToAccountMasterAccountNo: Scalars['String']['input'];
  switchToFundCode: Scalars['String']['input'];
  switchToPortfolioAccountNo: Scalars['String']['input'];
  unit: Scalars['Float']['input'];
};

export enum TomswinDvdInst {
  AutoCredit = 'AUTO_CREDIT',
  BankIn = 'BANK_IN',
  PayoutByCheque = 'PAYOUT_BY_CHEQUE',
  Reinvestment = 'REINVESTMENT'
}

export enum TomswinFundPlan {
  Cash = 'CASH'
}

export enum TomswinPaymentType {
  Cash = 'CASH',
  CreditAdvice = 'CREDIT_ADVICE',
  HouseCheque = 'HOUSE_CHEQUE',
  Kwsp = 'KWSP',
  LocalClearingChq = 'LOCAL_CLEARING_CHQ',
  MoneyOrder = 'MONEY_ORDER',
  OnlineBanking = 'ONLINE_BANKING',
  OutstationChq = 'OUTSTATION_CHQ',
  TelegraphicTransfer = 'TELEGRAPHIC_TRANSFER'
}

export enum TomswinRedemptionPaymentType {
  AutoCredit = 'AUTO_CREDIT',
  BankIn = 'BANK_IN',
  Cheque = 'CHEQUE',
  Tt = 'TT'
}

export enum TomswinRedemptionType {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export enum TomswinSwitchingType {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export type TomswinSync = {
  __typename?: 'TomswinSync';
  batchId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  dataHash?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  /** prisma-lint-ignore-model require-field-type */
  id: Scalars['ID']['output'];
  lineNo: Scalars['Int']['output'];
  primaryKeyValue?: Maybe<Scalars['String']['output']>;
  status: TomswinSyncStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type TomswinSyncAvgAggregate = {
  __typename?: 'TomswinSyncAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  lineNo?: Maybe<Scalars['Float']['output']>;
};

export type TomswinSyncBatch = {
  __typename?: 'TomswinSyncBatch';
  batchId: Scalars['String']['output'];
  changedNo: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorNo: Scalars['Int']['output'];
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indexedLineNo: Scalars['Int']['output'];
  skippedNo: Scalars['Int']['output'];
  status: TomswinSyncBatchStatus;
  tomswinSyncCurrent: ActiveTomswinSync;
  totalLineNo: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TomswinSyncBatchAvgAggregate = {
  __typename?: 'TomswinSyncBatchAvgAggregate';
  changedNo?: Maybe<Scalars['Float']['output']>;
  errorNo?: Maybe<Scalars['Float']['output']>;
  indexedLineNo?: Maybe<Scalars['Float']['output']>;
  skippedNo?: Maybe<Scalars['Float']['output']>;
  totalLineNo?: Maybe<Scalars['Float']['output']>;
};

export type TomswinSyncBatchCountAggregate = {
  __typename?: 'TomswinSyncBatchCountAggregate';
  _all: Scalars['Int']['output'];
  batchId: Scalars['Int']['output'];
  changedNo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  errorNo: Scalars['Int']['output'];
  fileLastModifiedAt: Scalars['Int']['output'];
  fileName: Scalars['Int']['output'];
  fileType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  indexedLineNo: Scalars['Int']['output'];
  skippedNo: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  totalLineNo: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TomswinSyncBatchMaxAggregate = {
  __typename?: 'TomswinSyncBatchMaxAggregate';
  batchId?: Maybe<Scalars['String']['output']>;
  changedNo?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorNo?: Maybe<Scalars['Int']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  indexedLineNo?: Maybe<Scalars['Int']['output']>;
  skippedNo?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<TomswinSyncBatchStatus>;
  totalLineNo?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncBatchMinAggregate = {
  __typename?: 'TomswinSyncBatchMinAggregate';
  batchId?: Maybe<Scalars['String']['output']>;
  changedNo?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorNo?: Maybe<Scalars['Int']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  indexedLineNo?: Maybe<Scalars['Int']['output']>;
  skippedNo?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<TomswinSyncBatchStatus>;
  totalLineNo?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncBatchOrderByWithRelationInput = {
  batchId?: InputMaybe<SortOrder>;
  changedNo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  errorNo?: InputMaybe<SortOrder>;
  fileLastModifiedAt?: InputMaybe<SortOrderInput>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  indexedLineNo?: InputMaybe<SortOrder>;
  skippedNo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalLineNo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TomswinSyncBatchStatus {
  Cleared = 'Cleared',
  Identified = 'Identified',
  Ignored = 'Ignored',
  Indexed = 'Indexed'
}

export type TomswinSyncBatchSumAggregate = {
  __typename?: 'TomswinSyncBatchSumAggregate';
  changedNo?: Maybe<Scalars['Int']['output']>;
  errorNo?: Maybe<Scalars['Int']['output']>;
  indexedLineNo?: Maybe<Scalars['Int']['output']>;
  skippedNo?: Maybe<Scalars['Int']['output']>;
  totalLineNo?: Maybe<Scalars['Int']['output']>;
};

export type TomswinSyncBatchWhereInput = {
  AND?: InputMaybe<Array<TomswinSyncBatchWhereInput>>;
  NOT?: InputMaybe<Array<TomswinSyncBatchWhereInput>>;
  OR?: InputMaybe<Array<TomswinSyncBatchWhereInput>>;
  batchId?: InputMaybe<StringFilter>;
  changedNo?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  errorNo?: InputMaybe<IntFilter>;
  fileLastModifiedAt?: InputMaybe<DateTimeNullableFilter>;
  fileName?: InputMaybe<StringFilter>;
  fileType?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  indexedLineNo?: InputMaybe<IntFilter>;
  skippedNo?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumTomswinSyncBatchStatusFilter>;
  totalLineNo?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TomswinSyncCountAggregate = {
  __typename?: 'TomswinSyncCountAggregate';
  _all: Scalars['Int']['output'];
  batchId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  dataHash: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  fileLastModifiedAt: Scalars['Int']['output'];
  fileName: Scalars['Int']['output'];
  fileType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lineNo: Scalars['Int']['output'];
  primaryKeyValue: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TomswinSyncDeadLetterAvgAggregate = {
  __typename?: 'TomswinSyncDeadLetterAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  lineNo?: Maybe<Scalars['Float']['output']>;
};

export type TomswinSyncDeadLetterCountAggregate = {
  __typename?: 'TomswinSyncDeadLetterCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  fileLastModifiedAt: Scalars['Int']['output'];
  fileName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lineNo: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TomswinSyncDeadLetterMaxAggregate = {
  __typename?: 'TomswinSyncDeadLetterMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncDeadLetterMinAggregate = {
  __typename?: 'TomswinSyncDeadLetterMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncDeadLetterSumAggregate = {
  __typename?: 'TomswinSyncDeadLetterSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
};

export type TomswinSyncMaxAggregate = {
  __typename?: 'TomswinSyncMaxAggregate';
  batchId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  primaryKeyValue?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TomswinSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncMinAggregate = {
  __typename?: 'TomswinSyncMinAggregate';
  batchId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  primaryKeyValue?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TomswinSyncStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TomswinSyncOrderByWithRelationInput = {
  batchId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  dataHash?: InputMaybe<SortOrderInput>;
  failureReason?: InputMaybe<SortOrderInput>;
  fileLastModifiedAt?: InputMaybe<SortOrderInput>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lineNo?: InputMaybe<SortOrder>;
  primaryKeyValue?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TomswinSyncStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type TomswinSyncSumAggregate = {
  __typename?: 'TomswinSyncSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
};

export type TomswinSyncWhereInput = {
  AND?: InputMaybe<Array<TomswinSyncWhereInput>>;
  NOT?: InputMaybe<Array<TomswinSyncWhereInput>>;
  OR?: InputMaybe<Array<TomswinSyncWhereInput>>;
  batchId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  dataHash?: InputMaybe<StringNullableFilter>;
  failureReason?: InputMaybe<StringNullableFilter>;
  fileLastModifiedAt?: InputMaybe<DateTimeNullableFilter>;
  fileName?: InputMaybe<StringFilter>;
  fileType?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lineNo?: InputMaybe<IntFilter>;
  primaryKeyValue?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumTomswinSyncStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TomswinTransaction = {
  __typename?: 'TomswinTransaction';
  transactionId: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  account: Account;
  accountMasterAccountNo: Scalars['String']['output'];
  accountPortfolio?: Maybe<AccountPortfolio>;
  actualAmount: Scalars['Decimal']['output'];
  actualQuantity: Scalars['Decimal']['output'];
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fund: Fund;
  fundCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  navPrice?: Maybe<Scalars['Decimal']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Payment>;
  paymentReferenceNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  publicStatus?: Maybe<TransactionPublicStatus>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  redemptionExtent?: Maybe<RedemptionExtent>;
  referenceNo: Scalars['String']['output'];
  requestedAmount: Scalars['Decimal']['output'];
  requestedNavPrice: Scalars['Decimal']['output'];
  requestedQuantity: Scalars['Decimal']['output'];
  switchToAccountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  switchToFund?: Maybe<Fund>;
  switchToFundCode?: Maybe<Scalars['String']['output']>;
  switchToPortfolioAccountNo?: Maybe<Scalars['String']['output']>;
  transactionCharge: Scalars['Decimal']['output'];
  transactionDatetime: Scalars['DateTime']['output'];
  transactionStatus: TransactionStatus;
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};


export type TransactionAccountPortfolioArgs = {
  where?: InputMaybe<AccountPortfolioWhereInput>;
};


export type TransactionOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type TransactionPaymentArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};


export type TransactionSwitchToFundArgs = {
  where?: InputMaybe<FundWhereInput>;
};

export type TransactionAvgAggregate = {
  __typename?: 'TransactionAvgAggregate';
  actualAmount?: Maybe<Scalars['Decimal']['output']>;
  actualQuantity?: Maybe<Scalars['Decimal']['output']>;
  requestedAmount?: Maybe<Scalars['Decimal']['output']>;
  requestedNavPrice?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  transactionCharge?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionCountAggregate = {
  __typename?: 'TransactionCountAggregate';
  _all: Scalars['Int']['output'];
  accountMasterAccountNo: Scalars['Int']['output'];
  actualAmount: Scalars['Int']['output'];
  actualQuantity: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  externalTransactionNo: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  paymentReferenceNo: Scalars['Int']['output'];
  portfolioAccountNo: Scalars['Int']['output'];
  redemptionExtent: Scalars['Int']['output'];
  referenceNo: Scalars['Int']['output'];
  requestedAmount: Scalars['Int']['output'];
  requestedNavPrice: Scalars['Int']['output'];
  requestedQuantity: Scalars['Int']['output'];
  switchToAccountMasterAccountNo: Scalars['Int']['output'];
  switchToFundCode: Scalars['Int']['output'];
  switchToPortfolioAccountNo: Scalars['Int']['output'];
  transactionCharge: Scalars['Int']['output'];
  transactionDatetime: Scalars['Int']['output'];
  transactionStatus: Scalars['Int']['output'];
  transactionType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TransactionCreateManyAccountInput = {
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionCreateManyAccountInputEnvelope = {
  data: Array<TransactionCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransactionCreateManyAccountPortfolioInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionCreateManyAccountPortfolioInputEnvelope = {
  data: Array<TransactionCreateManyAccountPortfolioInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransactionCreateManyOrderInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionCreateManyOrderInputEnvelope = {
  data: Array<TransactionCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransactionCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountInputEnvelope>;
};

export type TransactionCreateNestedManyWithoutAccountPortfolioInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountPortfolioInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountPortfolioInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountPortfolioInputEnvelope>;
};

export type TransactionCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutOrderInput>>;
  createMany?: InputMaybe<TransactionCreateManyOrderInputEnvelope>;
};

export type TransactionCreateOrConnectWithoutAccountInput = {
  create: TransactionUncheckedCreateWithoutAccountInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutAccountPortfolioInput = {
  create: TransactionUncheckedCreateWithoutAccountPortfolioInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutOrderInput = {
  create: TransactionUncheckedCreateWithoutOrderInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateWithoutAccountInput = {
  accountPortfolio?: InputMaybe<AccountPortfolioCreateNestedOneWithoutTransactionsInput>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fund: FundCreateNestedOneWithoutTransactionsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutTransactionsInput>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutTransactionsInput>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFund?: InputMaybe<FundCreateNestedOneWithoutSwitchToTransactionsInput>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionCreateWithoutAccountPortfolioInput = {
  account: AccountCreateNestedOneWithoutTransactionsInput;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fund: FundCreateNestedOneWithoutTransactionsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutTransactionsInput>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutTransactionsInput>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFund?: InputMaybe<FundCreateNestedOneWithoutSwitchToTransactionsInput>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionCreateWithoutOrderInput = {
  account: AccountCreateNestedOneWithoutTransactionsInput;
  accountPortfolio?: InputMaybe<AccountPortfolioCreateNestedOneWithoutTransactionsInput>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fund: FundCreateNestedOneWithoutTransactionsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutTransactionsInput>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFund?: InputMaybe<FundCreateNestedOneWithoutSwitchToTransactionsInput>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export enum TransactionDetailedPublicStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  PendingPayment = 'PendingPayment',
  PendingReview = 'PendingReview',
  PendingSignature = 'PendingSignature',
  Processing = 'Processing',
  Rejected = 'Rejected'
}

export type TransactionInitiatedExportRow = {
  __typename?: 'TransactionInitiatedExportRow';
  action: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  fundCode: Scalars['String']['output'];
  fundName: Scalars['String']['output'];
  masterAccountNumber: Scalars['String']['output'];
  orderReferenceNo?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionReferenceNo: Scalars['String']['output'];
  transactionStatus: Scalars['String']['output'];
};

export type TransactionLedgerAvgAggregate = {
  __typename?: 'TransactionLedgerAvgAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  unit?: Maybe<Scalars['Decimal']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionLedgerCountAggregate = {
  __typename?: 'TransactionLedgerCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  correspondingExternalId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  externalTransactionNo: Scalars['Int']['output'];
  fundCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  planCode: Scalars['Int']['output'];
  portfolioAccountNo: Scalars['Int']['output'];
  priceDate: Scalars['Int']['output'];
  referenceNo: Scalars['Int']['output'];
  remarks: Scalars['Int']['output'];
  transactionDate: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  unit: Scalars['Int']['output'];
  unitPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weightedAvgPrice: Scalars['Int']['output'];
};

export type TransactionLedgerMaxAggregate = {
  __typename?: 'TransactionLedgerMaxAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  correspondingExternalId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  priceDate?: Maybe<Scalars['DateTime']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<LedgerTransactionType>;
  unit?: Maybe<Scalars['Decimal']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weightedAvgPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionLedgerMinAggregate = {
  __typename?: 'TransactionLedgerMinAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  correspondingExternalId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  priceDate?: Maybe<Scalars['DateTime']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<LedgerTransactionType>;
  unit?: Maybe<Scalars['Decimal']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weightedAvgPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionLedgerSumAggregate = {
  __typename?: 'TransactionLedgerSumAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  unit?: Maybe<Scalars['Decimal']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  weightedAvgPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionListRelationFilter = {
  every?: InputMaybe<TransactionWhereInput>;
  none?: InputMaybe<TransactionWhereInput>;
  some?: InputMaybe<TransactionWhereInput>;
};

export type TransactionMaxAggregate = {
  __typename?: 'TransactionMaxAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  actualAmount?: Maybe<Scalars['Decimal']['output']>;
  actualQuantity?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentReferenceNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  redemptionExtent?: Maybe<RedemptionExtent>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  requestedAmount?: Maybe<Scalars['Decimal']['output']>;
  requestedNavPrice?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  switchToAccountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  switchToFundCode?: Maybe<Scalars['String']['output']>;
  switchToPortfolioAccountNo?: Maybe<Scalars['String']['output']>;
  transactionCharge?: Maybe<Scalars['Decimal']['output']>;
  transactionDatetime?: Maybe<Scalars['DateTime']['output']>;
  transactionStatus?: Maybe<TransactionStatus>;
  transactionType?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TransactionMinAggregate = {
  __typename?: 'TransactionMinAggregate';
  accountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  actualAmount?: Maybe<Scalars['Decimal']['output']>;
  actualQuantity?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalTransactionNo?: Maybe<Scalars['String']['output']>;
  fundCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentReferenceNo?: Maybe<Scalars['String']['output']>;
  portfolioAccountNo?: Maybe<Scalars['String']['output']>;
  redemptionExtent?: Maybe<RedemptionExtent>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  requestedAmount?: Maybe<Scalars['Decimal']['output']>;
  requestedNavPrice?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  switchToAccountMasterAccountNo?: Maybe<Scalars['String']['output']>;
  switchToFundCode?: Maybe<Scalars['String']['output']>;
  switchToPortfolioAccountNo?: Maybe<Scalars['String']['output']>;
  transactionCharge?: Maybe<Scalars['Decimal']['output']>;
  transactionDatetime?: Maybe<Scalars['DateTime']['output']>;
  transactionStatus?: Maybe<TransactionStatus>;
  transactionType?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransactionOrderByWithRelationInput = {
  account?: InputMaybe<AccountOrderByWithRelationInput>;
  accountMasterAccountNo?: InputMaybe<SortOrder>;
  accountPortfolio?: InputMaybe<AccountPortfolioOrderByWithRelationInput>;
  actualAmount?: InputMaybe<SortOrder>;
  actualQuantity?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrderInput>;
  externalTransactionNo?: InputMaybe<SortOrderInput>;
  fund?: InputMaybe<FundOrderByWithRelationInput>;
  fundCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentReferenceNo?: InputMaybe<SortOrderInput>;
  portfolioAccountNo?: InputMaybe<SortOrderInput>;
  redemptionExtent?: InputMaybe<SortOrderInput>;
  referenceNo?: InputMaybe<SortOrder>;
  requestedAmount?: InputMaybe<SortOrder>;
  requestedNavPrice?: InputMaybe<SortOrder>;
  requestedQuantity?: InputMaybe<SortOrder>;
  switchToAccountMasterAccountNo?: InputMaybe<SortOrderInput>;
  switchToFund?: InputMaybe<FundOrderByWithRelationInput>;
  switchToFundCode?: InputMaybe<SortOrderInput>;
  switchToPortfolioAccountNo?: InputMaybe<SortOrderInput>;
  transactionCharge?: InputMaybe<SortOrder>;
  transactionDatetime?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  transactionType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransactionProcessFlow = {
  __typename?: 'TransactionProcessFlow';
  purchase: Array<ProcessFlow>;
  withdrawal: Array<ProcessFlow>;
};

export enum TransactionPublicStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Processing = 'Processing',
  Rejected = 'Rejected'
}

export enum TransactionScalarFieldEnum {
  AccountMasterAccountNo = 'accountMasterAccountNo',
  ActualAmount = 'actualAmount',
  ActualQuantity = 'actualQuantity',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ErrorMessage = 'errorMessage',
  ExternalTransactionNo = 'externalTransactionNo',
  FundCode = 'fundCode',
  Id = 'id',
  OrderId = 'orderId',
  PaymentReferenceNo = 'paymentReferenceNo',
  PortfolioAccountNo = 'portfolioAccountNo',
  RedemptionExtent = 'redemptionExtent',
  ReferenceNo = 'referenceNo',
  RequestedAmount = 'requestedAmount',
  RequestedNavPrice = 'requestedNavPrice',
  RequestedQuantity = 'requestedQuantity',
  SwitchToAccountMasterAccountNo = 'switchToAccountMasterAccountNo',
  SwitchToFundCode = 'switchToFundCode',
  SwitchToPortfolioAccountNo = 'switchToPortfolioAccountNo',
  TransactionCharge = 'transactionCharge',
  TransactionDatetime = 'transactionDatetime',
  TransactionStatus = 'transactionStatus',
  TransactionType = 'transactionType',
  UpdatedAt = 'updatedAt'
}

export type TransactionScalarWhereInput = {
  AND?: InputMaybe<Array<TransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<TransactionScalarWhereInput>>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  actualAmount?: InputMaybe<DecimalFilter>;
  actualQuantity?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  externalTransactionNo?: InputMaybe<StringNullableFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  paymentReferenceNo?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<StringNullableFilter>;
  redemptionExtent?: InputMaybe<EnumRedemptionExtentNullableFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  requestedAmount?: InputMaybe<DecimalFilter>;
  requestedNavPrice?: InputMaybe<DecimalFilter>;
  requestedQuantity?: InputMaybe<DecimalFilter>;
  switchToAccountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  switchToFundCode?: InputMaybe<StringNullableFilter>;
  switchToPortfolioAccountNo?: InputMaybe<StringNullableFilter>;
  transactionCharge?: InputMaybe<DecimalFilter>;
  transactionDatetime?: InputMaybe<DateTimeFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TransactionStatsAllTime = {
  __typename?: 'TransactionStatsAllTime';
  transactionStatusRows: Array<CountRow>;
  transactionTypeRows: Array<CountRow>;
};

export type TransactionStatsByTypeRow = {
  __typename?: 'TransactionStatsByTypeRow';
  stats: TransactionStatusBreakdown;
  transactionType: TransactionType;
};

export type TransactionStatsInRange = {
  __typename?: 'TransactionStatsInRange';
  transactionTypeRows: Array<TransactionStatsByTypeRow>;
};

export enum TransactionStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
  Succeeded = 'Succeeded',
  Void = 'Void'
}

export type TransactionStatusBreakdown = {
  __typename?: 'TransactionStatusBreakdown';
  Approved: Scalars['Int']['output'];
  Cancelled: Scalars['Int']['output'];
  Failed: Scalars['Int']['output'];
  Pending: Scalars['Int']['output'];
  PendingOpsConfirmation: Scalars['Int']['output'];
  PendingPaymentVerification: Scalars['Int']['output'];
  PendingSubmission: Scalars['Int']['output'];
  Rejected: Scalars['Int']['output'];
  Submitted: Scalars['Int']['output'];
  Succeeded: Scalars['Int']['output'];
  Void: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TransactionSumAggregate = {
  __typename?: 'TransactionSumAggregate';
  actualAmount?: Maybe<Scalars['Decimal']['output']>;
  actualQuantity?: Maybe<Scalars['Decimal']['output']>;
  requestedAmount?: Maybe<Scalars['Decimal']['output']>;
  requestedNavPrice?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  transactionCharge?: Maybe<Scalars['Decimal']['output']>;
};

export enum TransactionType {
  Buy = 'Buy',
  Sell = 'Sell',
  Switch = 'Switch'
}

export type TransactionUncheckedCreateInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountInputEnvelope>;
};

export type TransactionUncheckedCreateNestedManyWithoutAccountPortfolioInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountPortfolioInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountPortfolioInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountPortfolioInputEnvelope>;
};

export type TransactionUncheckedCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutOrderInput>>;
  createMany?: InputMaybe<TransactionCreateManyOrderInputEnvelope>;
};

export type TransactionUncheckedCreateWithoutAccountInput = {
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionUncheckedCreateWithoutAccountPortfolioInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionUncheckedCreateWithoutOrderInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo: Scalars['String']['input'];
  requestedAmount: Scalars['Decimal']['input'];
  requestedNavPrice: Scalars['Decimal']['input'];
  requestedQuantity: Scalars['Decimal']['input'];
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge: Scalars['Decimal']['input'];
  transactionDatetime: Scalars['DateTime']['input'];
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};

export type TransactionUncheckedUpdateInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateManyWithoutAccountInput = {
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type TransactionUncheckedUpdateManyWithoutAccountPortfolioInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateManyWithoutAccountPortfolioNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutAccountPortfolioInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutAccountPortfolioInput>>;
  createMany?: InputMaybe<TransactionCreateManyAccountPortfolioInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutAccountPortfolioInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutAccountPortfolioInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutAccountPortfolioInput>>;
};

export type TransactionUncheckedUpdateManyWithoutOrderInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutOrderInput>>;
  createMany?: InputMaybe<TransactionCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type TransactionUncheckedUpdateWithoutAccountInput = {
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateWithoutAccountPortfolioInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUncheckedUpdateWithoutOrderInput = {
  accountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  actualAmount?: InputMaybe<Scalars['Decimal']['input']>;
  actualQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalTransactionNo?: InputMaybe<Scalars['String']['input']>;
  fundCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceNo?: InputMaybe<Scalars['String']['input']>;
  portfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  redemptionExtent?: InputMaybe<RedemptionExtent>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestedNavPrice?: InputMaybe<Scalars['Decimal']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  switchToAccountMasterAccountNo?: InputMaybe<Scalars['String']['input']>;
  switchToFundCode?: InputMaybe<Scalars['String']['input']>;
  switchToPortfolioAccountNo?: InputMaybe<Scalars['String']['input']>;
  transactionCharge?: InputMaybe<Scalars['Decimal']['input']>;
  transactionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransactionUpdateManyWithWhereWithoutAccountInput = {
  data: TransactionUncheckedUpdateManyWithoutAccountInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithWhereWithoutAccountPortfolioInput = {
  data: TransactionUncheckedUpdateManyWithoutAccountPortfolioInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithWhereWithoutOrderInput = {
  data: TransactionUncheckedUpdateManyWithoutOrderInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateWithWhereUniqueWithoutAccountInput = {
  data: TransactionUncheckedUpdateWithoutAccountInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithWhereUniqueWithoutAccountPortfolioInput = {
  data: TransactionUncheckedUpdateWithoutAccountPortfolioInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithWhereUniqueWithoutOrderInput = {
  data: TransactionUncheckedUpdateWithoutOrderInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithWhereUniqueWithoutAccountInput = {
  create: TransactionUncheckedCreateWithoutAccountInput;
  update: TransactionUncheckedUpdateWithoutAccountInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithWhereUniqueWithoutAccountPortfolioInput = {
  create: TransactionUncheckedCreateWithoutAccountPortfolioInput;
  update: TransactionUncheckedUpdateWithoutAccountPortfolioInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithWhereUniqueWithoutOrderInput = {
  create: TransactionUncheckedCreateWithoutOrderInput;
  update: TransactionUncheckedUpdateWithoutOrderInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionWhereInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  accountPortfolio?: InputMaybe<AccountPortfolioNullableRelationFilter>;
  actualAmount?: InputMaybe<DecimalFilter>;
  actualQuantity?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  externalTransactionNo?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<PaymentNullableRelationFilter>;
  paymentReferenceNo?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<StringNullableFilter>;
  redemptionExtent?: InputMaybe<EnumRedemptionExtentNullableFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  requestedAmount?: InputMaybe<DecimalFilter>;
  requestedNavPrice?: InputMaybe<DecimalFilter>;
  requestedQuantity?: InputMaybe<DecimalFilter>;
  switchToAccountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  switchToFund?: InputMaybe<FundNullableRelationFilter>;
  switchToFundCode?: InputMaybe<StringNullableFilter>;
  switchToPortfolioAccountNo?: InputMaybe<StringNullableFilter>;
  transactionCharge?: InputMaybe<DecimalFilter>;
  transactionDatetime?: InputMaybe<DateTimeFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountMasterAccountNo?: InputMaybe<StringFilter>;
  accountPortfolio?: InputMaybe<AccountPortfolioNullableRelationFilter>;
  actualAmount?: InputMaybe<DecimalFilter>;
  actualQuantity?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  externalTransactionNo?: InputMaybe<StringNullableFilter>;
  fund?: InputMaybe<FundRelationFilter>;
  fundCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<PaymentNullableRelationFilter>;
  paymentReferenceNo?: InputMaybe<StringNullableFilter>;
  portfolioAccountNo?: InputMaybe<StringNullableFilter>;
  redemptionExtent?: InputMaybe<EnumRedemptionExtentNullableFilter>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<DecimalFilter>;
  requestedNavPrice?: InputMaybe<DecimalFilter>;
  requestedQuantity?: InputMaybe<DecimalFilter>;
  switchToAccountMasterAccountNo?: InputMaybe<StringNullableFilter>;
  switchToFund?: InputMaybe<FundNullableRelationFilter>;
  switchToFundCode?: InputMaybe<StringNullableFilter>;
  switchToPortfolioAccountNo?: InputMaybe<StringNullableFilter>;
  transactionCharge?: InputMaybe<DecimalFilter>;
  transactionDatetime?: InputMaybe<DateTimeFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  transactionType?: InputMaybe<EnumTransactionTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Trustee = {
  __typename?: 'Trustee';
  _count?: Maybe<TrusteeCount>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  funds: Array<Fund>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  registeredAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type TrusteeFundsArgs = {
  cursor?: InputMaybe<FundWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FundWhereInput>;
};

export type TrusteeCount = {
  __typename?: 'TrusteeCount';
  funds: Scalars['Int']['output'];
};

export type TrusteeCountAggregate = {
  __typename?: 'TrusteeCountAggregate';
  _all: Scalars['Int']['output'];
  businessAddress: Scalars['Int']['output'];
  contactNo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  faxNo: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  registeredAddress: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type TrusteeCreateNestedOneWithoutFundsInput = {
  connect?: InputMaybe<TrusteeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrusteeCreateOrConnectWithoutFundsInput>;
  create?: InputMaybe<TrusteeUncheckedCreateWithoutFundsInput>;
};

export type TrusteeCreateOrConnectWithoutFundsInput = {
  create: TrusteeUncheckedCreateWithoutFundsInput;
  where: TrusteeWhereUniqueInput;
};

export type TrusteeMaxAggregate = {
  __typename?: 'TrusteeMaxAggregate';
  businessAddress?: Maybe<Scalars['String']['output']>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registeredAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type TrusteeMinAggregate = {
  __typename?: 'TrusteeMinAggregate';
  businessAddress?: Maybe<Scalars['String']['output']>;
  contactNo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registeredAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type TrusteeNullableRelationFilter = {
  is?: InputMaybe<TrusteeWhereInput>;
  isNot?: InputMaybe<TrusteeWhereInput>;
};

export type TrusteeOrderByWithRelationInput = {
  businessAddress?: InputMaybe<SortOrderInput>;
  contactNo?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  faxNo?: InputMaybe<SortOrderInput>;
  funds?: InputMaybe<FundOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  registeredAddress?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrderInput>;
};

export type TrusteeUncheckedCreateInput = {
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<FundUncheckedCreateNestedManyWithoutTrusteeInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type TrusteeUncheckedCreateWithoutFundsInput = {
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type TrusteeUncheckedUpdateInput = {
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNo?: InputMaybe<Scalars['String']['input']>;
  funds?: InputMaybe<FundUncheckedUpdateManyWithoutTrusteeNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type TrusteeWhereInput = {
  AND?: InputMaybe<Array<TrusteeWhereInput>>;
  NOT?: InputMaybe<Array<TrusteeWhereInput>>;
  OR?: InputMaybe<Array<TrusteeWhereInput>>;
  businessAddress?: InputMaybe<StringNullableFilter>;
  contactNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  registeredAddress?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type TrusteeWhereUniqueInput = {
  AND?: InputMaybe<Array<TrusteeWhereInput>>;
  NOT?: InputMaybe<Array<TrusteeWhereInput>>;
  OR?: InputMaybe<Array<TrusteeWhereInput>>;
  businessAddress?: InputMaybe<StringNullableFilter>;
  contactNo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  faxNo?: InputMaybe<StringNullableFilter>;
  funds?: InputMaybe<FundListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  registeredAddress?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type User = {
  __typename?: 'User';
  _count?: Maybe<UserCount>;
  createdAt: Scalars['DateTime']['output'];
  creationStatus: CreationStatus;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  hpPhoneNo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationCode?: Maybe<Scalars['String']['output']>;
  invitationSentAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardedAt?: Maybe<Scalars['DateTime']['output']>;
  orders: Array<Order>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  profiles: Array<Profile>;
  securityImage?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  updatedAt: Scalars['DateTime']['output'];
  userMFA?: Maybe<UserMfa>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserProfilesArgs = {
  cursor?: InputMaybe<ProfileWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProfileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProfileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type UserUserMfaArgs = {
  where?: InputMaybe<UserMfaWhereInput>;
};

export type UserCount = {
  __typename?: 'UserCount';
  orders: Scalars['Int']['output'];
  profiles: Scalars['Int']['output'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creationStatus: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  hpPhoneNo: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitationCode: Scalars['Int']['output'];
  invitationSentAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  onboardedAt: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  phoneNo: Scalars['Int']['output'];
  profilePicture: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  username: Scalars['Int']['output'];
};

export type UserCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutOrdersInput>;
};

export type UserCreateOrConnectWithoutOrdersInput = {
  create: UserUncheckedCreateWithoutOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProfilesInput = {
  create: UserUncheckedCreateWithoutProfilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutProfilesInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserLoginAttemptAvgAggregate = {
  __typename?: 'UserLoginAttemptAvgAggregate';
  consecutiveFailCount?: Maybe<Scalars['Float']['output']>;
};

export type UserLoginAttemptCountAggregate = {
  __typename?: 'UserLoginAttemptCountAggregate';
  _all: Scalars['Int']['output'];
  consecutiveFailCount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastFailedAt: Scalars['Int']['output'];
  lastFailedMetadata: Scalars['Int']['output'];
  lastSuccessAt: Scalars['Int']['output'];
  lastSuccessMetadata: Scalars['Int']['output'];
  sessionToken: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserLoginAttemptMaxAggregate = {
  __typename?: 'UserLoginAttemptMaxAggregate';
  consecutiveFailCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserLoginAttemptMinAggregate = {
  __typename?: 'UserLoginAttemptMinAggregate';
  consecutiveFailCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserLoginAttemptSumAggregate = {
  __typename?: 'UserLoginAttemptSumAggregate';
  consecutiveFailCount?: Maybe<Scalars['Int']['output']>;
};

export type UserMfa = {
  __typename?: 'UserMFA';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  securityImageId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type UserMfaCountAggregate = {
  __typename?: 'UserMFACountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  securityImageId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserMfaCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<UserMfaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserMfaCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<UserMfaUncheckedCreateWithoutUserInput>;
};

export type UserMfaCreateOrConnectWithoutUserInput = {
  create: UserMfaUncheckedCreateWithoutUserInput;
  where: UserMfaWhereUniqueInput;
};

export type UserMfaMaxAggregate = {
  __typename?: 'UserMFAMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  securityImageId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserMfaMinAggregate = {
  __typename?: 'UserMFAMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  securityImageId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserMfaNullableRelationFilter = {
  is?: InputMaybe<UserMfaWhereInput>;
  isNot?: InputMaybe<UserMfaWhereInput>;
};

export type UserMfaOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  securityImageId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserMfaUncheckedCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<UserMfaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserMfaCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<UserMfaUncheckedCreateWithoutUserInput>;
};

export type UserMfaUncheckedCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  securityImageId?: InputMaybe<Scalars['String']['input']>;
};

export type UserMfaUncheckedUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<UserMfaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserMfaCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<UserMfaUncheckedCreateWithoutUserInput>;
  delete?: InputMaybe<UserMfaWhereInput>;
  disconnect?: InputMaybe<UserMfaWhereInput>;
  update?: InputMaybe<UserMfaUncheckedUpdateWithoutUserInput>;
  upsert?: InputMaybe<UserMfaUpsertWithoutUserInput>;
};

export type UserMfaUncheckedUpdateWithoutUserInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  securityImageId?: InputMaybe<Scalars['String']['input']>;
};

export type UserMfaUpsertWithoutUserInput = {
  create: UserMfaUncheckedCreateWithoutUserInput;
  update: UserMfaUncheckedUpdateWithoutUserInput;
  where?: InputMaybe<UserMfaWhereInput>;
};

export type UserMfaWhereInput = {
  AND?: InputMaybe<Array<UserMfaWhereInput>>;
  NOT?: InputMaybe<Array<UserMfaWhereInput>>;
  OR?: InputMaybe<Array<UserMfaWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  securityImageId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserMfaWhereUniqueInput = {
  AND?: InputMaybe<Array<UserMfaWhereInput>>;
  NOT?: InputMaybe<Array<UserMfaWhereInput>>;
  OR?: InputMaybe<Array<UserMfaWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  securityImageId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hpPhoneNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationCode?: Maybe<Scalars['String']['output']>;
  invitationSentAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardedAt?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationStatus?: Maybe<CreationStatus>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hpPhoneNo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationCode?: Maybe<Scalars['String']['output']>;
  invitationSentAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardedAt?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  creationStatus?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  hpPhoneNo?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invitationCode?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  onboardedAt?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  phoneNo?: InputMaybe<SortOrderInput>;
  profilePicture?: InputMaybe<SortOrderInput>;
  profiles?: InputMaybe<ProfileOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userMFA?: InputMaybe<UserMfaOrderByWithRelationInput>;
  username?: InputMaybe<SortOrderInput>;
};

export type UserPasswordHistoryAvgAggregate = {
  __typename?: 'UserPasswordHistoryAvgAggregate';
  revision?: Maybe<Scalars['Float']['output']>;
};

export type UserPasswordHistoryCountAggregate = {
  __typename?: 'UserPasswordHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserPasswordHistoryMaxAggregate = {
  __typename?: 'UserPasswordHistoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserPasswordHistoryMinAggregate = {
  __typename?: 'UserPasswordHistoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserPasswordHistorySumAggregate = {
  __typename?: 'UserPasswordHistorySumAggregate';
  revision?: Maybe<Scalars['Int']['output']>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreationStatus = 'creationStatus',
  DeletedAt = 'deletedAt',
  Email = 'email',
  HpPhoneNo = 'hpPhoneNo',
  Id = 'id',
  InvitationCode = 'invitationCode',
  InvitationSentAt = 'invitationSentAt',
  Name = 'name',
  OnboardedAt = 'onboardedAt',
  Password = 'password',
  PhoneNo = 'phoneNo',
  ProfilePicture = 'profilePicture',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  Username = 'username'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  hpPhoneNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invitationCode?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  onboardedAt?: InputMaybe<DateTimeNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  phoneNo?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumUserStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringNullableFilter>;
};

export type UserStatsAllTime = {
  __typename?: 'UserStatsAllTime';
  onboardedCompanyCount: Scalars['Int']['output'];
  userRows: Array<LabelValueRow>;
};

export type UserStatsInRange = {
  __typename?: 'UserStatsInRange';
  companiesOnboarded: Scalars['Int']['output'];
  invitationCodeCount: Scalars['Int']['output'];
  usersOnboarded: Scalars['Int']['output'];
};

export enum UserStatus {
  Active = 'Active',
  Closed = 'Closed',
  Dormant = 'Dormant',
  Inactive = 'Inactive',
  ProfileLocked = 'ProfileLocked',
  SuspectedFraud = 'SuspectedFraud'
}

export enum UserType {
  Admin = 'Admin',
  Customer = 'Customer'
}

export type UserUncheckedCreateInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<ProfileUncheckedCreateNestedManyWithoutUsersInput>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUncheckedCreateNestedManyWithoutProfilesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProfilesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProfilesInput>>;
};

export type UserUncheckedCreateWithoutOrdersInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<ProfileUncheckedCreateNestedManyWithoutUsersInput>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUncheckedCreateWithoutProfilesInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email: Scalars['String']['input'];
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedCreateNestedOneWithoutUserInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUncheckedUpdateInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<ProfileUncheckedUpdateManyWithoutUsersNestedInput>;
  securityImageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedUpdateOneWithoutUserNestedInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUncheckedUpdateManyWithoutProfilesInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUncheckedUpdateManyWithoutProfilesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProfilesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProfilesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutProfilesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutProfilesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutProfilesInput>>;
};

export type UserUncheckedUpdateWithoutProfilesInput = {
  creationStatus?: InputMaybe<CreationStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  hpPhoneNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  userMFA?: InputMaybe<UserMfaUncheckedUpdateOneWithoutUserNestedInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateManyWithWhereWithoutProfilesInput = {
  data: UserUncheckedUpdateManyWithoutProfilesInput;
  where: UserScalarWhereInput;
};

export type UserUpdateWithWhereUniqueWithoutProfilesInput = {
  data: UserUncheckedUpdateWithoutProfilesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutProfilesInput = {
  create: UserUncheckedCreateWithoutProfilesInput;
  update: UserUncheckedUpdateWithoutProfilesInput;
  where: UserWhereUniqueInput;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  hpPhoneNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invitationCode?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  onboardedAt?: InputMaybe<DateTimeNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  phoneNo?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  profiles?: InputMaybe<ProfileListRelationFilter>;
  status?: InputMaybe<EnumUserStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMFA?: InputMaybe<UserMfaNullableRelationFilter>;
  username?: InputMaybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationStatus?: InputMaybe<EnumCreationStatusFilter>;
  email?: InputMaybe<StringFilter>;
  hpPhoneNo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringNullableFilter>;
  onboardedAt?: InputMaybe<DateTimeNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  phoneNo?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  profiles?: InputMaybe<ProfileListRelationFilter>;
  status?: InputMaybe<EnumUserStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userMFA?: InputMaybe<UserMfaNullableRelationFilter>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyCorporateProfileInput = {
  companyName: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactPhoneNo: Scalars['String']['input'];
  idNo: Scalars['String']['input'];
  invitationCode: Scalars['String']['input'];
};

export type VerifyLoginOtpInput = {
  otpChallengeCode: Scalars['String']['input'];
  otpChallengeId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type VerifyOtpInput = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type VerifyOtpResponse = {
  __typename?: 'VerifyOtpResponse';
  verifyOTPResp: Scalars['Boolean']['output'];
};

export type VerifySimpleOtpInput = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type WithdrawOrderInput = {
  bankAccountId: Scalars['String']['input'];
  originId?: InputMaybe<Scalars['String']['input']>;
  signatories: Array<SignatoryInput>;
  withdrawTransactions: Array<WithdrawTransactionInput>;
};

export type WithdrawTransactionInput = {
  accountMasterAccountNo: Scalars['String']['input'];
  fundCode: Scalars['String']['input'];
  portfolioAccountNo: Scalars['String']['input'];
  redemptionExtent: RedemptionExtent;
  unit: Scalars['Float']['input'];
};

export enum YieldType {
  DailyYield = 'DAILY_YIELD',
  Default = 'DEFAULT',
  MonthlyYield = 'MONTHLY_YIELD'
}

export type CreateAdminRoleMutationVariables = Exact<{
  data: AdminRoleCreateInputV2;
}>;


export type CreateAdminRoleMutation = { __typename?: 'Mutation', createOneAdminRole: { __typename?: 'AdminRole', id: string } };

export type CreateAdminUserMutationVariables = Exact<{
  data: AdminUserCreateInputV2;
}>;


export type CreateAdminUserMutation = { __typename?: 'Mutation', createOneAdminUser: { __typename?: 'AdminUser', id: string } };

export type UpdateAdminRoleMutationVariables = Exact<{
  data: AdminRoleUpdateInputV2;
  where: AdminRoleWhereUniqueInput;
}>;


export type UpdateAdminRoleMutation = { __typename?: 'Mutation', updateOneAdminRole?: { __typename?: 'AdminRole', id: string } | null };

export type UpdateAdminUserMutationVariables = Exact<{
  data: AdminUserUpdateInputV2;
  where: AdminUserWhereUniqueInput;
}>;


export type UpdateAdminUserMutation = { __typename?: 'Mutation', updateOneAdminUser?: { __typename?: 'AdminUser', id: string } | null };


export const CreateAdminRoleDocument = gql`
    mutation createAdminRole($data: AdminRoleCreateInputV2!) {
  createOneAdminRole(data: $data) {
    id
  }
}
    `;
export const CreateAdminUserDocument = gql`
    mutation createAdminUser($data: AdminUserCreateInputV2!) {
  createOneAdminUser(data: $data) {
    id
  }
}
    `;
export const UpdateAdminRoleDocument = gql`
    mutation updateAdminRole($data: AdminRoleUpdateInputV2!, $where: AdminRoleWhereUniqueInput!) {
  updateOneAdminRole(data: $data, where: $where) {
    id
  }
}
    `;
export const UpdateAdminUserDocument = gql`
    mutation updateAdminUser($data: AdminUserUpdateInputV2!, $where: AdminUserWhereUniqueInput!) {
  updateOneAdminUser(data: $data, where: $where) {
    id
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    createAdminRole(variables: CreateAdminRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAdminRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdminRoleMutation>(CreateAdminRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdminRole', 'mutation', variables);
    },
    createAdminUser(variables: CreateAdminUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAdminUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdminUserMutation>(CreateAdminUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdminUser', 'mutation', variables);
    },
    updateAdminRole(variables: UpdateAdminRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminRoleMutation>(UpdateAdminRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminRole', 'mutation', variables);
    },
    updateAdminUser(variables: UpdateAdminUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminUserMutation>(UpdateAdminUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminUser', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;